class DiacriticsFilterInstructionsTheta {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0xFB1E:
        return [];
      case 0xFE00:
        return [];
      case 0xFE01:
        return [];
      case 0xFE02:
        return [];
      case 0xFE03:
        return [];
      case 0xFE04:
        return [];
      case 0xFE05:
        return [];
      case 0xFE06:
        return [];
      case 0xFE07:
        return [];
      case 0xFE08:
        return [];
      case 0xFE09:
        return [];
      case 0xFE0A:
        return [];
      case 0xFE0B:
        return [];
      case 0xFE0C:
        return [];
      case 0xFE0D:
        return [];
      case 0xFE0E:
        return [];
      case 0xFE0F:
        return [];
      case 0xFE20:
        return [];
      case 0xFE21:
        return [];
      case 0xFE22:
        return [];
      case 0xFE23:
        return [];
      default:
        return [opcode];
    }
  }
}
class DiacriticsFilterInstructionsBeta {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0x20D0:
        return [];
      case 0x20D1:
        return [];
      case 0x20D2:
        return [];
      case 0x20D3:
        return [];
      case 0x20D4:
        return [];
      case 0x20D5:
        return [];
      case 0x20D6:
        return [];
      case 0x20D7:
        return [];
      case 0x20D8:
        return [];
      case 0x20D9:
        return [];
      case 0x20DA:
        return [];
      case 0x20DB:
        return [];
      case 0x20DC:
        return [];
      case 0x20DD:
        return [];
      case 0x20DE:
        return [];
      case 0x20DF:
        return [];
      case 0x20E0:
        return [];
      case 0x20E1:
        return [];
      case 0x20E2:
        return [];
      case 0x20E3:
        return [];
      case 0x20E4:
        return [];
      case 0x20E5:
        return [];
      case 0x20E6:
        return [];
      case 0x20E7:
        return [];
      case 0x20E8:
        return [];
      case 0x20E9:
        return [];
      case 0x20EA:
        return [];
      case 0x20EB:
        return [];
      case 0x20EC:
        return [];
      case 0x20ED:
        return [];
      case 0x20EE:
        return [];
      case 0x20EF:
        return [];
      case 0x302A:
        return [];
      case 0x302B:
        return [];
      case 0x302C:
        return [];
      case 0x302D:
        return [];
      case 0x302E:
        return [];
      case 0x302F:
        return [];
      case 0x3099:
        return [];
      case 0x309A:
        return [];
      default:
        return [opcode];
    }
  }
}
class DiacriticsFilterInstructionsAlpha {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0x0300:
        return [];
      case 0x0301:
        return [];
      case 0x0302:
        return [];
      case 0x0303:
        return [];
      case 0x0304:
        return [];
      case 0x0305:
        return [];
      case 0x0306:
        return [];
      case 0x0307:
        return [];
      case 0x0308:
        return [];
      case 0x0309:
        return [];
      case 0x030A:
        return [];
      case 0x030B:
        return [];
      case 0x030C:
        return [];
      case 0x030D:
        return [];
      case 0x030E:
        return [];
      case 0x030F:
        return [];
      case 0x0310:
        return [];
      case 0x0311:
        return [];
      case 0x0312:
        return [];
      case 0x0313:
        return [];
      case 0x0314:
        return [];
      case 0x0315:
        return [];
      case 0x0316:
        return [];
      case 0x0317:
        return [];
      case 0x0318:
        return [];
      case 0x0319:
        return [];
      case 0x031A:
        return [];
      case 0x031B:
        return [];
      case 0x031C:
        return [];
      case 0x031D:
        return [];
      case 0x031E:
        return [];
      case 0x031F:
        return [];
      case 0x0320:
        return [];
      case 0x0321:
        return [];
      case 0x0322:
        return [];
      case 0x0323:
        return [];
      case 0x0324:
        return [];
      case 0x0325:
        return [];
      case 0x0326:
        return [];
      case 0x0327:
        return [];
      case 0x0328:
        return [];
      case 0x0329:
        return [];
      case 0x032A:
        return [];
      case 0x032B:
        return [];
      case 0x032C:
        return [];
      case 0x032D:
        return [];
      case 0x032E:
        return [];
      case 0x032F:
        return [];
      case 0x0330:
        return [];
      case 0x0331:
        return [];
      case 0x0332:
        return [];
      case 0x0333:
        return [];
      case 0x0334:
        return [];
      case 0x0335:
        return [];
      case 0x0336:
        return [];
      case 0x0337:
        return [];
      case 0x0338:
        return [];
      case 0x0339:
        return [];
      case 0x033A:
        return [];
      case 0x033B:
        return [];
      case 0x033C:
        return [];
      case 0x033D:
        return [];
      case 0x033E:
        return [];
      case 0x033F:
        return [];
      case 0x0340:
        return [];
      case 0x0341:
        return [];
      case 0x0342:
        return [];
      case 0x0343:
        return [];
      case 0x0344:
        return [];
      case 0x0345:
        return [];
      case 0x0346:
        return [];
      case 0x0347:
        return [];
      case 0x0348:
        return [];
      case 0x0349:
        return [];
      case 0x034A:
        return [];
      case 0x034B:
        return [];
      case 0x034C:
        return [];
      case 0x034D:
        return [];
      case 0x034E:
        return [];
      case 0x034F:
        return [];
      case 0x0350:
        return [];
      case 0x0351:
        return [];
      case 0x0352:
        return [];
      case 0x0353:
        return [];
      case 0x0354:
        return [];
      case 0x0355:
        return [];
      case 0x0356:
        return [];
      case 0x0357:
        return [];
      case 0x0358:
        return [];
      case 0x0359:
        return [];
      case 0x035A:
        return [];
      case 0x035B:
        return [];
      case 0x035C:
        return [];
      case 0x035D:
        return [];
      case 0x035E:
        return [];
      case 0x035F:
        return [];
      case 0x0360:
        return [];
      case 0x0361:
        return [];
      case 0x0362:
        return [];
      case 0x0363:
        return [];
      case 0x0364:
        return [];
      case 0x0365:
        return [];
      case 0x0366:
        return [];
      case 0x0367:
        return [];
      case 0x0368:
        return [];
      case 0x0369:
        return [];
      case 0x036A:
        return [];
      case 0x036B:
        return [];
      case 0x036C:
        return [];
      case 0x036D:
        return [];
      case 0x036E:
        return [];
      case 0x036F:
        return [];
      case 0x0483:
        return [];
      case 0x0484:
        return [];
      case 0x0485:
        return [];
      case 0x0486:
        return [];
      case 0x0488:
        return [];
      case 0x0489:
        return [];
      case 0x0591:
        return [];
      case 0x0592:
        return [];
      case 0x0593:
        return [];
      case 0x0594:
        return [];
      case 0x0595:
        return [];
      case 0x0596:
        return [];
      case 0x0597:
        return [];
      case 0x0598:
        return [];
      case 0x0599:
        return [];
      case 0x059A:
        return [];
      case 0x059B:
        return [];
      case 0x059C:
        return [];
      case 0x059D:
        return [];
      case 0x059E:
        return [];
      case 0x059F:
        return [];
      case 0x05A0:
        return [];
      case 0x05A1:
        return [];
      case 0x05A2:
        return [];
      case 0x05A3:
        return [];
      case 0x05A4:
        return [];
      case 0x05A5:
        return [];
      case 0x05A6:
        return [];
      case 0x05A7:
        return [];
      case 0x05A8:
        return [];
      case 0x05A9:
        return [];
      case 0x05AA:
        return [];
      case 0x05AB:
        return [];
      case 0x05AC:
        return [];
      case 0x05AD:
        return [];
      case 0x05AE:
        return [];
      case 0x05AF:
        return [];
      case 0x05B0:
        return [];
      case 0x05B1:
        return [];
      case 0x05B2:
        return [];
      case 0x05B3:
        return [];
      case 0x05B4:
        return [];
      case 0x05B5:
        return [];
      case 0x05B6:
        return [];
      case 0x05B7:
        return [];
      case 0x05B8:
        return [];
      case 0x05B9:
        return [];
      case 0x05BA:
        return [];
      case 0x05BB:
        return [];
      case 0x05BC:
        return [];
      case 0x05BD:
        return [];
      case 0x05BF:
        return [];
      case 0x05C1:
        return [];
      case 0x05C2:
        return [];
      case 0x05C4:
        return [];
      case 0x05C5:
        return [];
      case 0x05C7:
        return [];
      case 0x0610:
        return [];
      case 0x0611:
        return [];
      case 0x0612:
        return [];
      case 0x0613:
        return [];
      case 0x0614:
        return [];
      case 0x0615:
        return [];
      case 0x064B:
        return [];
      case 0x064C:
        return [];
      case 0x064D:
        return [];
      case 0x064E:
        return [];
      case 0x064F:
        return [];
      case 0x0650:
        return [];
      case 0x0651:
        return [];
      case 0x0652:
        return [];
      case 0x0653:
        return [];
      case 0x0654:
        return [];
      case 0x0655:
        return [];
      case 0x0656:
        return [];
      case 0x0657:
        return [];
      case 0x0658:
        return [];
      case 0x0659:
        return [];
      case 0x065A:
        return [];
      case 0x065B:
        return [];
      case 0x065C:
        return [];
      case 0x065D:
        return [];
      case 0x065E:
        return [];
      case 0x0670:
        return [];
      case 0x06D6:
        return [];
      case 0x06D7:
        return [];
      case 0x06D8:
        return [];
      case 0x06D9:
        return [];
      case 0x06DA:
        return [];
      case 0x06DB:
        return [];
      case 0x06DC:
        return [];
      case 0x06DE:
        return [];
      case 0x06DF:
        return [];
      case 0x06E0:
        return [];
      case 0x06E1:
        return [];
      case 0x06E2:
        return [];
      case 0x06E3:
        return [];
      case 0x06E4:
        return [];
      case 0x06E7:
        return [];
      case 0x06E8:
        return [];
      case 0x06EA:
        return [];
      case 0x06EB:
        return [];
      case 0x06EC:
        return [];
      case 0x06ED:
        return [];
      case 0x0711:
        return [];
      case 0x0730:
        return [];
      case 0x0731:
        return [];
      case 0x0732:
        return [];
      case 0x0733:
        return [];
      case 0x0734:
        return [];
      case 0x0735:
        return [];
      case 0x0736:
        return [];
      case 0x0737:
        return [];
      case 0x0738:
        return [];
      case 0x0739:
        return [];
      case 0x073A:
        return [];
      case 0x073B:
        return [];
      case 0x073C:
        return [];
      case 0x073D:
        return [];
      case 0x073E:
        return [];
      case 0x073F:
        return [];
      case 0x0740:
        return [];
      case 0x0741:
        return [];
      case 0x0742:
        return [];
      case 0x0743:
        return [];
      case 0x0744:
        return [];
      case 0x0745:
        return [];
      case 0x0746:
        return [];
      case 0x0747:
        return [];
      case 0x0748:
        return [];
      case 0x0749:
        return [];
      case 0x074A:
        return [];
      case 0x07A6:
        return [];
      case 0x07A7:
        return [];
      case 0x07A8:
        return [];
      case 0x07A9:
        return [];
      case 0x07AA:
        return [];
      case 0x07AB:
        return [];
      case 0x07AC:
        return [];
      case 0x07AD:
        return [];
      case 0x07AE:
        return [];
      case 0x07AF:
        return [];
      case 0x07B0:
        return [];
      case 0x07EB:
        return [];
      case 0x07EC:
        return [];
      case 0x07ED:
        return [];
      case 0x07EE:
        return [];
      case 0x07EF:
        return [];
      case 0x07F0:
        return [];
      case 0x07F1:
        return [];
      case 0x07F2:
        return [];
      case 0x07F3:
        return [];
      case 0x0901:
        return [];
      case 0x0902:
        return [];
      case 0x0903:
        return [];
      case 0x093C:
        return [];
      case 0x093E:
        return [];
      case 0x093F:
        return [];
      case 0x0940:
        return [];
      case 0x0941:
        return [];
      case 0x0942:
        return [];
      case 0x0943:
        return [];
      case 0x0944:
        return [];
      case 0x0945:
        return [];
      case 0x0946:
        return [];
      case 0x0947:
        return [];
      case 0x0948:
        return [];
      case 0x0949:
        return [];
      case 0x094A:
        return [];
      case 0x094B:
        return [];
      case 0x094C:
        return [];
      case 0x094D:
        return [];
      case 0x0951:
        return [];
      case 0x0952:
        return [];
      case 0x0953:
        return [];
      case 0x0954:
        return [];
      case 0x0962:
        return [];
      case 0x0963:
        return [];
      case 0x0981:
        return [];
      case 0x0982:
        return [];
      case 0x0983:
        return [];
      case 0x09BC:
        return [];
      case 0x09BE:
        return [];
      case 0x09BF:
        return [];
      case 0x09C0:
        return [];
      case 0x09C1:
        return [];
      case 0x09C2:
        return [];
      case 0x09C3:
        return [];
      case 0x09C4:
        return [];
      case 0x09C7:
        return [];
      case 0x09C8:
        return [];
      case 0x09CB:
        return [];
      case 0x09CC:
        return [];
      case 0x09CD:
        return [];
      case 0x09D7:
        return [];
      case 0x09E2:
        return [];
      case 0x09E3:
        return [];
      case 0x0A01:
        return [];
      case 0x0A02:
        return [];
      case 0x0A03:
        return [];
      case 0x0A3C:
        return [];
      case 0x0A3E:
        return [];
      case 0x0A3F:
        return [];
      case 0x0A40:
        return [];
      case 0x0A41:
        return [];
      case 0x0A42:
        return [];
      case 0x0A47:
        return [];
      case 0x0A48:
        return [];
      case 0x0A4B:
        return [];
      case 0x0A4C:
        return [];
      case 0x0A4D:
        return [];
      case 0x0A70:
        return [];
      case 0x0A71:
        return [];
      case 0x0A81:
        return [];
      case 0x0A82:
        return [];
      case 0x0A83:
        return [];
      case 0x0ABC:
        return [];
      case 0x0ABE:
        return [];
      case 0x0ABF:
        return [];
      case 0x0AC0:
        return [];
      case 0x0AC1:
        return [];
      case 0x0AC2:
        return [];
      case 0x0AC3:
        return [];
      case 0x0AC4:
        return [];
      case 0x0AC5:
        return [];
      case 0x0AC7:
        return [];
      case 0x0AC8:
        return [];
      case 0x0AC9:
        return [];
      case 0x0ACB:
        return [];
      case 0x0ACC:
        return [];
      case 0x0ACD:
        return [];
      case 0x0AE2:
        return [];
      case 0x0AE3:
        return [];
      case 0x0B01:
        return [];
      case 0x0B02:
        return [];
      case 0x0B03:
        return [];
      case 0x0B3C:
        return [];
      case 0x0B3E:
        return [];
      case 0x0B3F:
        return [];
      case 0x0B40:
        return [];
      case 0x0B41:
        return [];
      case 0x0B42:
        return [];
      case 0x0B43:
        return [];
      case 0x0B47:
        return [];
      case 0x0B48:
        return [];
      case 0x0B4B:
        return [];
      case 0x0B4C:
        return [];
      case 0x0B4D:
        return [];
      case 0x0B56:
        return [];
      case 0x0B57:
        return [];
      case 0x0B82:
        return [];
      case 0x0BBE:
        return [];
      case 0x0BBF:
        return [];
      case 0x0BC0:
        return [];
      case 0x0BC1:
        return [];
      case 0x0BC2:
        return [];
      case 0x0BC6:
        return [];
      case 0x0BC7:
        return [];
      case 0x0BC8:
        return [];
      case 0x0BCA:
        return [];
      case 0x0BCB:
        return [];
      case 0x0BCC:
        return [];
      case 0x0BCD:
        return [];
      case 0x0BD7:
        return [];
      case 0x0C01:
        return [];
      case 0x0C02:
        return [];
      case 0x0C03:
        return [];
      case 0x0C3E:
        return [];
      case 0x0C3F:
        return [];
      case 0x0C40:
        return [];
      case 0x0C41:
        return [];
      case 0x0C42:
        return [];
      case 0x0C43:
        return [];
      case 0x0C44:
        return [];
      case 0x0C46:
        return [];
      case 0x0C47:
        return [];
      case 0x0C48:
        return [];
      case 0x0C4A:
        return [];
      case 0x0C4B:
        return [];
      case 0x0C4C:
        return [];
      case 0x0C4D:
        return [];
      case 0x0C55:
        return [];
      case 0x0C56:
        return [];
      case 0x0C82:
        return [];
      case 0x0C83:
        return [];
      case 0x0CBC:
        return [];
      case 0x0CBE:
        return [];
      case 0x0CBF:
        return [];
      case 0x0CC0:
        return [];
      case 0x0CC1:
        return [];
      case 0x0CC2:
        return [];
      case 0x0CC3:
        return [];
      case 0x0CC4:
        return [];
      case 0x0CC6:
        return [];
      case 0x0CC7:
        return [];
      case 0x0CC8:
        return [];
      case 0x0CCA:
        return [];
      case 0x0CCB:
        return [];
      case 0x0CCC:
        return [];
      case 0x0CCD:
        return [];
      case 0x0CD5:
        return [];
      case 0x0CD6:
        return [];
      case 0x0CE2:
        return [];
      case 0x0CE3:
        return [];
      case 0x0D02:
        return [];
      case 0x0D03:
        return [];
      case 0x0D3E:
        return [];
      case 0x0D3F:
        return [];
      case 0x0D40:
        return [];
      case 0x0D41:
        return [];
      case 0x0D42:
        return [];
      case 0x0D43:
        return [];
      case 0x0D46:
        return [];
      case 0x0D47:
        return [];
      case 0x0D48:
        return [];
      case 0x0D4A:
        return [];
      case 0x0D4B:
        return [];
      case 0x0D4C:
        return [];
      case 0x0D4D:
        return [];
      case 0x0D57:
        return [];
      case 0x0D82:
        return [];
      case 0x0D83:
        return [];
      case 0x0DCA:
        return [];
      case 0x0DCF:
        return [];
      case 0x0DD0:
        return [];
      case 0x0DD1:
        return [];
      case 0x0DD2:
        return [];
      case 0x0DD3:
        return [];
      case 0x0DD4:
        return [];
      case 0x0DD6:
        return [];
      case 0x0DD8:
        return [];
      case 0x0DD9:
        return [];
      case 0x0DDA:
        return [];
      case 0x0DDB:
        return [];
      case 0x0DDC:
        return [];
      case 0x0DDD:
        return [];
      case 0x0DDE:
        return [];
      case 0x0DDF:
        return [];
      case 0x0DF2:
        return [];
      case 0x0DF3:
        return [];
      case 0x0E31:
        return [];
      case 0x0E34:
        return [];
      case 0x0E35:
        return [];
      case 0x0E36:
        return [];
      case 0x0E37:
        return [];
      case 0x0E38:
        return [];
      case 0x0E39:
        return [];
      case 0x0E3A:
        return [];
      case 0x0E47:
        return [];
      case 0x0E48:
        return [];
      case 0x0E49:
        return [];
      case 0x0E4A:
        return [];
      case 0x0E4B:
        return [];
      case 0x0E4C:
        return [];
      case 0x0E4D:
        return [];
      case 0x0E4E:
        return [];
      case 0x0EB1:
        return [];
      case 0x0EB4:
        return [];
      case 0x0EB5:
        return [];
      case 0x0EB6:
        return [];
      case 0x0EB7:
        return [];
      case 0x0EB8:
        return [];
      case 0x0EB9:
        return [];
      case 0x0EBB:
        return [];
      case 0x0EBC:
        return [];
      case 0x0EC8:
        return [];
      case 0x0EC9:
        return [];
      case 0x0ECA:
        return [];
      case 0x0ECB:
        return [];
      case 0x0ECC:
        return [];
      case 0x0ECD:
        return [];
      case 0x0F18:
        return [];
      case 0x0F19:
        return [];
      case 0x0F35:
        return [];
      case 0x0F37:
        return [];
      case 0x0F39:
        return [];
      case 0x0F3E:
        return [];
      case 0x0F3F:
        return [];
      case 0x0F71:
        return [];
      case 0x0F72:
        return [];
      case 0x0F73:
        return [];
      case 0x0F74:
        return [];
      case 0x0F75:
        return [];
      case 0x0F76:
        return [];
      case 0x0F77:
        return [];
      case 0x0F78:
        return [];
      case 0x0F79:
        return [];
      case 0x0F7A:
        return [];
      case 0x0F7B:
        return [];
      case 0x0F7C:
        return [];
      case 0x0F7D:
        return [];
      case 0x0F7E:
        return [];
      case 0x0F7F:
        return [];
      case 0x0F80:
        return [];
      case 0x0F81:
        return [];
      case 0x0F82:
        return [];
      case 0x0F83:
        return [];
      case 0x0F84:
        return [];
      case 0x0F86:
        return [];
      case 0x0F87:
        return [];
      case 0x0F90:
        return [];
      case 0x0F91:
        return [];
      case 0x0F92:
        return [];
      case 0x0F93:
        return [];
      case 0x0F94:
        return [];
      case 0x0F95:
        return [];
      case 0x0F96:
        return [];
      case 0x0F97:
        return [];
      case 0x0F99:
        return [];
      case 0x0F9A:
        return [];
      case 0x0F9B:
        return [];
      case 0x0F9C:
        return [];
      case 0x0F9D:
        return [];
      case 0x0F9E:
        return [];
      case 0x0F9F:
        return [];
      case 0x0FA0:
        return [];
      case 0x0FA1:
        return [];
      case 0x0FA2:
        return [];
      case 0x0FA3:
        return [];
      case 0x0FA4:
        return [];
      case 0x0FA5:
        return [];
      case 0x0FA6:
        return [];
      case 0x0FA7:
        return [];
      case 0x0FA8:
        return [];
      case 0x0FA9:
        return [];
      case 0x0FAA:
        return [];
      case 0x0FAB:
        return [];
      case 0x0FAC:
        return [];
      case 0x0FAD:
        return [];
      case 0x0FAE:
        return [];
      case 0x0FAF:
        return [];
      case 0x0FB0:
        return [];
      case 0x0FB1:
        return [];
      case 0x0FB2:
        return [];
      case 0x0FB3:
        return [];
      case 0x0FB4:
        return [];
      case 0x0FB5:
        return [];
      case 0x0FB6:
        return [];
      case 0x0FB7:
        return [];
      case 0x0FB8:
        return [];
      case 0x0FB9:
        return [];
      case 0x0FBA:
        return [];
      case 0x0FBB:
        return [];
      case 0x0FBC:
        return [];
      case 0x0FC6:
        return [];
      case 0x102C:
        return [];
      case 0x102D:
        return [];
      case 0x102E:
        return [];
      case 0x102F:
        return [];
      case 0x1030:
        return [];
      case 0x1031:
        return [];
      case 0x1032:
        return [];
      case 0x1036:
        return [];
      case 0x1037:
        return [];
      case 0x1038:
        return [];
      case 0x1039:
        return [];
      case 0x1056:
        return [];
      case 0x1057:
        return [];
      case 0x1058:
        return [];
      case 0x1059:
        return [];
      case 0x135F:
        return [];
      case 0x1712:
        return [];
      case 0x1713:
        return [];
      case 0x1714:
        return [];
      case 0x1732:
        return [];
      case 0x1733:
        return [];
      case 0x1734:
        return [];
      case 0x1752:
        return [];
      case 0x1753:
        return [];
      case 0x1772:
        return [];
      case 0x1773:
        return [];
      case 0x17B6:
        return [];
      case 0x17B7:
        return [];
      case 0x17B8:
        return [];
      case 0x17B9:
        return [];
      case 0x17BA:
        return [];
      case 0x17BB:
        return [];
      case 0x17BC:
        return [];
      case 0x17BD:
        return [];
      case 0x17BE:
        return [];
      case 0x17BF:
        return [];
      case 0x17C0:
        return [];
      case 0x17C1:
        return [];
      case 0x17C2:
        return [];
      case 0x17C3:
        return [];
      case 0x17C4:
        return [];
      case 0x17C5:
        return [];
      case 0x17C6:
        return [];
      case 0x17C7:
        return [];
      case 0x17C8:
        return [];
      case 0x17C9:
        return [];
      case 0x17CA:
        return [];
      case 0x17CB:
        return [];
      case 0x17CC:
        return [];
      case 0x17CD:
        return [];
      case 0x17CE:
        return [];
      case 0x17CF:
        return [];
      case 0x17D0:
        return [];
      case 0x17D1:
        return [];
      case 0x17D2:
        return [];
      case 0x17D3:
        return [];
      case 0x17DD:
        return [];
      case 0x180B:
        return [];
      case 0x180C:
        return [];
      case 0x180D:
        return [];
      case 0x18A9:
        return [];
      case 0x1920:
        return [];
      case 0x1921:
        return [];
      case 0x1922:
        return [];
      case 0x1923:
        return [];
      case 0x1924:
        return [];
      case 0x1925:
        return [];
      case 0x1926:
        return [];
      case 0x1927:
        return [];
      case 0x1928:
        return [];
      case 0x1929:
        return [];
      case 0x192A:
        return [];
      case 0x192B:
        return [];
      case 0x1930:
        return [];
      case 0x1931:
        return [];
      case 0x1932:
        return [];
      case 0x1933:
        return [];
      case 0x1934:
        return [];
      case 0x1935:
        return [];
      case 0x1936:
        return [];
      case 0x1937:
        return [];
      case 0x1938:
        return [];
      case 0x1939:
        return [];
      case 0x193A:
        return [];
      case 0x193B:
        return [];
      case 0x19B0:
        return [];
      case 0x19B1:
        return [];
      case 0x19B2:
        return [];
      case 0x19B3:
        return [];
      case 0x19B4:
        return [];
      case 0x19B5:
        return [];
      case 0x19B6:
        return [];
      case 0x19B7:
        return [];
      case 0x19B8:
        return [];
      case 0x19B9:
        return [];
      case 0x19BA:
        return [];
      case 0x19BB:
        return [];
      case 0x19BC:
        return [];
      case 0x19BD:
        return [];
      case 0x19BE:
        return [];
      case 0x19BF:
        return [];
      case 0x19C0:
        return [];
      case 0x19C8:
        return [];
      case 0x19C9:
        return [];
      case 0x1A17:
        return [];
      case 0x1A18:
        return [];
      case 0x1A19:
        return [];
      case 0x1A1A:
        return [];
      case 0x1A1B:
        return [];
      case 0x1B00:
        return [];
      case 0x1B01:
        return [];
      case 0x1B02:
        return [];
      case 0x1B03:
        return [];
      case 0x1B04:
        return [];
      case 0x1B34:
        return [];
      case 0x1B35:
        return [];
      case 0x1B36:
        return [];
      case 0x1B37:
        return [];
      case 0x1B38:
        return [];
      case 0x1B39:
        return [];
      case 0x1B3A:
        return [];
      case 0x1B3B:
        return [];
      case 0x1B3C:
        return [];
      case 0x1B3D:
        return [];
      case 0x1B3E:
        return [];
      case 0x1B3F:
        return [];
      case 0x1B40:
        return [];
      case 0x1B41:
        return [];
      case 0x1B42:
        return [];
      case 0x1B43:
        return [];
      case 0x1B44:
        return [];
      case 0x1B6B:
        return [];
      case 0x1B6C:
        return [];
      case 0x1B6D:
        return [];
      case 0x1B6E:
        return [];
      case 0x1B6F:
        return [];
      case 0x1B70:
        return [];
      case 0x1B71:
        return [];
      case 0x1B72:
        return [];
      case 0x1B73:
        return [];
      case 0x1DC0:
        return [];
      case 0x1DC1:
        return [];
      case 0x1DC2:
        return [];
      case 0x1DC3:
        return [];
      case 0x1DC4:
        return [];
      case 0x1DC5:
        return [];
      case 0x1DC6:
        return [];
      case 0x1DC7:
        return [];
      case 0x1DC8:
        return [];
      case 0x1DC9:
        return [];
      case 0x1DCA:
        return [];
      case 0x1DFE:
        return [];
      case 0x1DFF:
        return [];
      default:
        return [opcode];
    }
  }
}
class LowercaseMachineTheta {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0xFF21:
        {
          return [0xFF41];
        }
      case 0xFF22:
        {
          return [0xFF42];
        }
      case 0xFF23:
        {
          return [0xFF43];
        }
      case 0xFF24:
        {
          return [0xFF44];
        }
      case 0xFF25:
        {
          return [0xFF45];
        }
      case 0xFF26:
        {
          return [0xFF46];
        }
      case 0xFF27:
        {
          return [0xFF47];
        }
      case 0xFF28:
        {
          return [0xFF48];
        }
      case 0xFF29:
        {
          return [0xFF49];
        }
      case 0xFF2A:
        {
          return [0xFF4A];
        }
      case 0xFF2B:
        {
          return [0xFF4B];
        }
      case 0xFF2C:
        {
          return [0xFF4C];
        }
      case 0xFF2D:
        {
          return [0xFF4D];
        }
      case 0xFF2E:
        {
          return [0xFF4E];
        }
      case 0xFF2F:
        {
          return [0xFF4F];
        }
      case 0xFF30:
        {
          return [0xFF50];
        }
      case 0xFF31:
        {
          return [0xFF51];
        }
      case 0xFF32:
        {
          return [0xFF52];
        }
      case 0xFF33:
        {
          return [0xFF53];
        }
      case 0xFF34:
        {
          return [0xFF54];
        }
      case 0xFF35:
        {
          return [0xFF55];
        }
      case 0xFF36:
        {
          return [0xFF56];
        }
      case 0xFF37:
        {
          return [0xFF57];
        }
      case 0xFF38:
        {
          return [0xFF58];
        }
      case 0xFF39:
        {
          return [0xFF59];
        }
      case 0xFF3A:
        {
          return [0xFF5A];
        }
      default:
        return null;
    }
  }
}
class LowercaseMachineAlpha {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0x0041:
        {
          return [0x0061];
        }
      case 0x0042:
        {
          return [0x0062];
        }
      case 0x0043:
        {
          return [0x0063];
        }
      case 0x0044:
        {
          return [0x0064];
        }
      case 0x0045:
        {
          return [0x0065];
        }
      case 0x0046:
        {
          return [0x0066];
        }
      case 0x0047:
        {
          return [0x0067];
        }
      case 0x0048:
        {
          return [0x0068];
        }
      case 0x0049:
        {
          return [0x0069];
        }
      case 0x004A:
        {
          return [0x006A];
        }
      case 0x004B:
        {
          return [0x006B];
        }
      case 0x004C:
        {
          return [0x006C];
        }
      case 0x004D:
        {
          return [0x006D];
        }
      case 0x004E:
        {
          return [0x006E];
        }
      case 0x004F:
        {
          return [0x006F];
        }
      case 0x0050:
        {
          return [0x0070];
        }
      case 0x0051:
        {
          return [0x0071];
        }
      case 0x0052:
        {
          return [0x0072];
        }
      case 0x0053:
        {
          return [0x0073];
        }
      case 0x0054:
        {
          return [0x0074];
        }
      case 0x0055:
        {
          return [0x0075];
        }
      case 0x0056:
        {
          return [0x0076];
        }
      case 0x0057:
        {
          return [0x0077];
        }
      case 0x0058:
        {
          return [0x0078];
        }
      case 0x0059:
        {
          return [0x0079];
        }
      case 0x005A:
        {
          return [0x007A];
        }
      case 0x00C0:
        {
          return [0x00E0];
        }
      case 0x00C1:
        {
          return [0x00E1];
        }
      case 0x00C2:
        {
          return [0x00E2];
        }
      case 0x00C3:
        {
          return [0x00E3];
        }
      case 0x00C4:
        {
          return [0x00E4];
        }
      case 0x00C5:
        {
          return [0x00E5];
        }
      case 0x00C6:
        {
          return [0x00E6];
        }
      case 0x00C7:
        {
          return [0x00E7];
        }
      case 0x00C8:
        {
          return [0x00E8];
        }
      case 0x00C9:
        {
          return [0x00E9];
        }
      case 0x00CA:
        {
          return [0x00EA];
        }
      case 0x00CB:
        {
          return [0x00EB];
        }
      case 0x00CC:
        {
          return [0x00EC];
        }
      case 0x00CD:
        {
          return [0x00ED];
        }
      case 0x00CE:
        {
          return [0x00EE];
        }
      case 0x00CF:
        {
          return [0x00EF];
        }
      case 0x00D0:
        {
          return [0x00F0];
        }
      case 0x00D1:
        {
          return [0x00F1];
        }
      case 0x00D2:
        {
          return [0x00F2];
        }
      case 0x00D3:
        {
          return [0x00F3];
        }
      case 0x00D4:
        {
          return [0x00F4];
        }
      case 0x00D5:
        {
          return [0x00F5];
        }
      case 0x00D6:
        {
          return [0x00F6];
        }
      case 0x00D8:
        {
          return [0x00F8];
        }
      case 0x00D9:
        {
          return [0x00F9];
        }
      case 0x00DA:
        {
          return [0x00FA];
        }
      case 0x00DB:
        {
          return [0x00FB];
        }
      case 0x00DC:
        {
          return [0x00FC];
        }
      case 0x00DD:
        {
          return [0x00FD];
        }
      case 0x00DE:
        {
          return [0x00FE];
        }
      case 0x0100:
        {
          return [0x0101];
        }
      case 0x0102:
        {
          return [0x0103];
        }
      case 0x0104:
        {
          return [0x0105];
        }
      case 0x0106:
        {
          return [0x0107];
        }
      case 0x0108:
        {
          return [0x0109];
        }
      case 0x010A:
        {
          return [0x010B];
        }
      case 0x010C:
        {
          return [0x010D];
        }
      case 0x010E:
        {
          return [0x010F];
        }
      case 0x0110:
        {
          return [0x0111];
        }
      case 0x0112:
        {
          return [0x0113];
        }
      case 0x0114:
        {
          return [0x0115];
        }
      case 0x0116:
        {
          return [0x0117];
        }
      case 0x0118:
        {
          return [0x0119];
        }
      case 0x011A:
        {
          return [0x011B];
        }
      case 0x011C:
        {
          return [0x011D];
        }
      case 0x011E:
        {
          return [0x011F];
        }
      case 0x0120:
        {
          return [0x0121];
        }
      case 0x0122:
        {
          return [0x0123];
        }
      case 0x0124:
        {
          return [0x0125];
        }
      case 0x0126:
        {
          return [0x0127];
        }
      case 0x0128:
        {
          return [0x0129];
        }
      case 0x012A:
        {
          return [0x012B];
        }
      case 0x012C:
        {
          return [0x012D];
        }
      case 0x012E:
        {
          return [0x012F];
        }
      case 0x0130:
        {
          return [0x0069];
        }
      case 0x0132:
        {
          return [0x0133];
        }
      case 0x0134:
        {
          return [0x0135];
        }
      case 0x0136:
        {
          return [0x0137];
        }
      case 0x0139:
        {
          return [0x013A];
        }
      case 0x013B:
        {
          return [0x013C];
        }
      case 0x013D:
        {
          return [0x013E];
        }
      case 0x013F:
        {
          return [0x0140];
        }
      case 0x0141:
        {
          return [0x0142];
        }
      case 0x0143:
        {
          return [0x0144];
        }
      case 0x0145:
        {
          return [0x0146];
        }
      case 0x0147:
        {
          return [0x0148];
        }
      case 0x014A:
        {
          return [0x014B];
        }
      case 0x014C:
        {
          return [0x014D];
        }
      case 0x014E:
        {
          return [0x014F];
        }
      case 0x0150:
        {
          return [0x0151];
        }
      case 0x0152:
        {
          return [0x0153];
        }
      case 0x0154:
        {
          return [0x0155];
        }
      case 0x0156:
        {
          return [0x0157];
        }
      case 0x0158:
        {
          return [0x0159];
        }
      case 0x015A:
        {
          return [0x015B];
        }
      case 0x015C:
        {
          return [0x015D];
        }
      case 0x015E:
        {
          return [0x015F];
        }
      case 0x0160:
        {
          return [0x0161];
        }
      case 0x0162:
        {
          return [0x0163];
        }
      case 0x0164:
        {
          return [0x0165];
        }
      case 0x0166:
        {
          return [0x0167];
        }
      case 0x0168:
        {
          return [0x0169];
        }
      case 0x016A:
        {
          return [0x016B];
        }
      case 0x016C:
        {
          return [0x016D];
        }
      case 0x016E:
        {
          return [0x016F];
        }
      case 0x0170:
        {
          return [0x0171];
        }
      case 0x0172:
        {
          return [0x0173];
        }
      case 0x0174:
        {
          return [0x0175];
        }
      case 0x0176:
        {
          return [0x0177];
        }
      case 0x0178:
        {
          return [0x00FF];
        }
      case 0x0179:
        {
          return [0x017A];
        }
      case 0x017B:
        {
          return [0x017C];
        }
      case 0x017D:
        {
          return [0x017E];
        }
      case 0x0181:
        {
          return [0x0253];
        }
      case 0x0182:
        {
          return [0x0183];
        }
      case 0x0184:
        {
          return [0x0185];
        }
      case 0x0186:
        {
          return [0x0254];
        }
      case 0x0187:
        {
          return [0x0188];
        }
      case 0x0189:
        {
          return [0x0256];
        }
      case 0x018A:
        {
          return [0x0257];
        }
      case 0x018B:
        {
          return [0x018C];
        }
      case 0x018E:
        {
          return [0x01DD];
        }
      case 0x018F:
        {
          return [0x0259];
        }
      case 0x0190:
        {
          return [0x025B];
        }
      case 0x0191:
        {
          return [0x0192];
        }
      case 0x0193:
        {
          return [0x0260];
        }
      case 0x0194:
        {
          return [0x0263];
        }
      case 0x0196:
        {
          return [0x0269];
        }
      case 0x0197:
        {
          return [0x0268];
        }
      case 0x0198:
        {
          return [0x0199];
        }
      case 0x019C:
        {
          return [0x026F];
        }
      case 0x019D:
        {
          return [0x0272];
        }
      case 0x019F:
        {
          return [0x0275];
        }
      case 0x01A0:
        {
          return [0x01A1];
        }
      case 0x01A2:
        {
          return [0x01A3];
        }
      case 0x01A4:
        {
          return [0x01A5];
        }
      case 0x01A6:
        {
          return [0x0280];
        }
      case 0x01A7:
        {
          return [0x01A8];
        }
      case 0x01A9:
        {
          return [0x0283];
        }
      case 0x01AC:
        {
          return [0x01AD];
        }
      case 0x01AE:
        {
          return [0x0288];
        }
      case 0x01AF:
        {
          return [0x01B0];
        }
      case 0x01B1:
        {
          return [0x028A];
        }
      case 0x01B2:
        {
          return [0x028B];
        }
      case 0x01B3:
        {
          return [0x01B4];
        }
      case 0x01B5:
        {
          return [0x01B6];
        }
      case 0x01B7:
        {
          return [0x0292];
        }
      case 0x01B8:
        {
          return [0x01B9];
        }
      case 0x01BC:
        {
          return [0x01BD];
        }
      case 0x01C4:
        {
          return [0x01C6];
        }
      case 0x01C5:
        {
          return [0x01C6];
        }
      case 0x01C7:
        {
          return [0x01C9];
        }
      case 0x01C8:
        {
          return [0x01C9];
        }
      case 0x01CA:
        {
          return [0x01CC];
        }
      case 0x01CB:
        {
          return [0x01CC];
        }
      case 0x01CD:
        {
          return [0x01CE];
        }
      case 0x01CF:
        {
          return [0x01D0];
        }
      case 0x01D1:
        {
          return [0x01D2];
        }
      case 0x01D3:
        {
          return [0x01D4];
        }
      case 0x01D5:
        {
          return [0x01D6];
        }
      case 0x01D7:
        {
          return [0x01D8];
        }
      case 0x01D9:
        {
          return [0x01DA];
        }
      case 0x01DB:
        {
          return [0x01DC];
        }
      case 0x01DE:
        {
          return [0x01DF];
        }
      case 0x01E0:
        {
          return [0x01E1];
        }
      case 0x01E2:
        {
          return [0x01E3];
        }
      case 0x01E4:
        {
          return [0x01E5];
        }
      case 0x01E6:
        {
          return [0x01E7];
        }
      case 0x01E8:
        {
          return [0x01E9];
        }
      case 0x01EA:
        {
          return [0x01EB];
        }
      case 0x01EC:
        {
          return [0x01ED];
        }
      case 0x01EE:
        {
          return [0x01EF];
        }
      case 0x01F1:
        {
          return [0x01F3];
        }
      case 0x01F2:
        {
          return [0x01F3];
        }
      case 0x01F4:
        {
          return [0x01F5];
        }
      case 0x01F6:
        {
          return [0x0195];
        }
      case 0x01F7:
        {
          return [0x01BF];
        }
      case 0x01F8:
        {
          return [0x01F9];
        }
      case 0x01FA:
        {
          return [0x01FB];
        }
      case 0x01FC:
        {
          return [0x01FD];
        }
      case 0x01FE:
        {
          return [0x01FF];
        }
      case 0x0200:
        {
          return [0x0201];
        }
      case 0x0202:
        {
          return [0x0203];
        }
      case 0x0204:
        {
          return [0x0205];
        }
      case 0x0206:
        {
          return [0x0207];
        }
      case 0x0208:
        {
          return [0x0209];
        }
      case 0x020A:
        {
          return [0x020B];
        }
      case 0x020C:
        {
          return [0x020D];
        }
      case 0x020E:
        {
          return [0x020F];
        }
      case 0x0210:
        {
          return [0x0211];
        }
      case 0x0212:
        {
          return [0x0213];
        }
      case 0x0214:
        {
          return [0x0215];
        }
      case 0x0216:
        {
          return [0x0217];
        }
      case 0x0218:
        {
          return [0x0219];
        }
      case 0x021A:
        {
          return [0x021B];
        }
      case 0x021C:
        {
          return [0x021D];
        }
      case 0x021E:
        {
          return [0x021F];
        }
      case 0x0220:
        {
          return [0x019E];
        }
      case 0x0222:
        {
          return [0x0223];
        }
      case 0x0224:
        {
          return [0x0225];
        }
      case 0x0226:
        {
          return [0x0227];
        }
      case 0x0228:
        {
          return [0x0229];
        }
      case 0x022A:
        {
          return [0x022B];
        }
      case 0x022C:
        {
          return [0x022D];
        }
      case 0x022E:
        {
          return [0x022F];
        }
      case 0x0230:
        {
          return [0x0231];
        }
      case 0x0232:
        {
          return [0x0233];
        }
      case 0x023A:
        {
          return [0x2C65];
        }
      case 0x023B:
        {
          return [0x023C];
        }
      case 0x023D:
        {
          return [0x019A];
        }
      case 0x023E:
        {
          return [0x2C66];
        }
      case 0x0241:
        {
          return [0x0242];
        }
      case 0x0243:
        {
          return [0x0180];
        }
      case 0x0244:
        {
          return [0x0289];
        }
      case 0x0245:
        {
          return [0x028C];
        }
      case 0x0246:
        {
          return [0x0247];
        }
      case 0x0248:
        {
          return [0x0249];
        }
      case 0x024A:
        {
          return [0x024B];
        }
      case 0x024C:
        {
          return [0x024D];
        }
      case 0x024E:
        {
          return [0x024F];
        }
      case 0x0386:
        {
          return [0x03AC];
        }
      case 0x0388:
        {
          return [0x03AD];
        }
      case 0x0389:
        {
          return [0x03AE];
        }
      case 0x038A:
        {
          return [0x03AF];
        }
      case 0x038C:
        {
          return [0x03CC];
        }
      case 0x038E:
        {
          return [0x03CD];
        }
      case 0x038F:
        {
          return [0x03CE];
        }
      case 0x0391:
        {
          return [0x03B1];
        }
      case 0x0392:
        {
          return [0x03B2];
        }
      case 0x0393:
        {
          return [0x03B3];
        }
      case 0x0394:
        {
          return [0x03B4];
        }
      case 0x0395:
        {
          return [0x03B5];
        }
      case 0x0396:
        {
          return [0x03B6];
        }
      case 0x0397:
        {
          return [0x03B7];
        }
      case 0x0398:
        {
          return [0x03B8];
        }
      case 0x0399:
        {
          return [0x03B9];
        }
      case 0x039A:
        {
          return [0x03BA];
        }
      case 0x039B:
        {
          return [0x03BB];
        }
      case 0x039C:
        {
          return [0x03BC];
        }
      case 0x039D:
        {
          return [0x03BD];
        }
      case 0x039E:
        {
          return [0x03BE];
        }
      case 0x039F:
        {
          return [0x03BF];
        }
      case 0x03A0:
        {
          return [0x03C0];
        }
      case 0x03A1:
        {
          return [0x03C1];
        }
      case 0x03A3:
        {
          return [0x03C3];
        }
      case 0x03A4:
        {
          return [0x03C4];
        }
      case 0x03A5:
        {
          return [0x03C5];
        }
      case 0x03A6:
        {
          return [0x03C6];
        }
      case 0x03A7:
        {
          return [0x03C7];
        }
      case 0x03A8:
        {
          return [0x03C8];
        }
      case 0x03A9:
        {
          return [0x03C9];
        }
      case 0x03AA:
        {
          return [0x03CA];
        }
      case 0x03AB:
        {
          return [0x03CB];
        }
      case 0x03D8:
        {
          return [0x03D9];
        }
      case 0x03DA:
        {
          return [0x03DB];
        }
      case 0x03DC:
        {
          return [0x03DD];
        }
      case 0x03DE:
        {
          return [0x03DF];
        }
      case 0x03E0:
        {
          return [0x03E1];
        }
      case 0x03E2:
        {
          return [0x03E3];
        }
      case 0x03E4:
        {
          return [0x03E5];
        }
      case 0x03E6:
        {
          return [0x03E7];
        }
      case 0x03E8:
        {
          return [0x03E9];
        }
      case 0x03EA:
        {
          return [0x03EB];
        }
      case 0x03EC:
        {
          return [0x03ED];
        }
      case 0x03EE:
        {
          return [0x03EF];
        }
      case 0x03F4:
        {
          return [0x03B8];
        }
      case 0x03F7:
        {
          return [0x03F8];
        }
      case 0x03F9:
        {
          return [0x03F2];
        }
      case 0x03FA:
        {
          return [0x03FB];
        }
      case 0x03FD:
        {
          return [0x037B];
        }
      case 0x03FE:
        {
          return [0x037C];
        }
      case 0x03FF:
        {
          return [0x037D];
        }
      case 0x0400:
        {
          return [0x0450];
        }
      case 0x0401:
        {
          return [0x0451];
        }
      case 0x0402:
        {
          return [0x0452];
        }
      case 0x0403:
        {
          return [0x0453];
        }
      case 0x0404:
        {
          return [0x0454];
        }
      case 0x0405:
        {
          return [0x0455];
        }
      case 0x0406:
        {
          return [0x0456];
        }
      case 0x0407:
        {
          return [0x0457];
        }
      case 0x0408:
        {
          return [0x0458];
        }
      case 0x0409:
        {
          return [0x0459];
        }
      case 0x040A:
        {
          return [0x045A];
        }
      case 0x040B:
        {
          return [0x045B];
        }
      case 0x040C:
        {
          return [0x045C];
        }
      case 0x040D:
        {
          return [0x045D];
        }
      case 0x040E:
        {
          return [0x045E];
        }
      case 0x040F:
        {
          return [0x045F];
        }
      case 0x0410:
        {
          return [0x0430];
        }
      case 0x0411:
        {
          return [0x0431];
        }
      case 0x0412:
        {
          return [0x0432];
        }
      case 0x0413:
        {
          return [0x0433];
        }
      case 0x0414:
        {
          return [0x0434];
        }
      case 0x0415:
        {
          return [0x0435];
        }
      case 0x0416:
        {
          return [0x0436];
        }
      case 0x0417:
        {
          return [0x0437];
        }
      case 0x0418:
        {
          return [0x0438];
        }
      case 0x0419:
        {
          return [0x0439];
        }
      case 0x041A:
        {
          return [0x043A];
        }
      case 0x041B:
        {
          return [0x043B];
        }
      case 0x041C:
        {
          return [0x043C];
        }
      case 0x041D:
        {
          return [0x043D];
        }
      case 0x041E:
        {
          return [0x043E];
        }
      case 0x041F:
        {
          return [0x043F];
        }
      case 0x0420:
        {
          return [0x0440];
        }
      case 0x0421:
        {
          return [0x0441];
        }
      case 0x0422:
        {
          return [0x0442];
        }
      case 0x0423:
        {
          return [0x0443];
        }
      case 0x0424:
        {
          return [0x0444];
        }
      case 0x0425:
        {
          return [0x0445];
        }
      case 0x0426:
        {
          return [0x0446];
        }
      case 0x0427:
        {
          return [0x0447];
        }
      case 0x0428:
        {
          return [0x0448];
        }
      case 0x0429:
        {
          return [0x0449];
        }
      case 0x042A:
        {
          return [0x044A];
        }
      case 0x042B:
        {
          return [0x044B];
        }
      case 0x042C:
        {
          return [0x044C];
        }
      case 0x042D:
        {
          return [0x044D];
        }
      case 0x042E:
        {
          return [0x044E];
        }
      case 0x042F:
        {
          return [0x044F];
        }
      case 0x0460:
        {
          return [0x0461];
        }
      case 0x0462:
        {
          return [0x0463];
        }
      case 0x0464:
        {
          return [0x0465];
        }
      case 0x0466:
        {
          return [0x0467];
        }
      case 0x0468:
        {
          return [0x0469];
        }
      case 0x046A:
        {
          return [0x046B];
        }
      case 0x046C:
        {
          return [0x046D];
        }
      case 0x046E:
        {
          return [0x046F];
        }
      case 0x0470:
        {
          return [0x0471];
        }
      case 0x0472:
        {
          return [0x0473];
        }
      case 0x0474:
        {
          return [0x0475];
        }
      case 0x0476:
        {
          return [0x0477];
        }
      case 0x0478:
        {
          return [0x0479];
        }
      case 0x047A:
        {
          return [0x047B];
        }
      case 0x047C:
        {
          return [0x047D];
        }
      case 0x047E:
        {
          return [0x047F];
        }
      case 0x0480:
        {
          return [0x0481];
        }
      case 0x048A:
        {
          return [0x048B];
        }
      case 0x048C:
        {
          return [0x048D];
        }
      case 0x048E:
        {
          return [0x048F];
        }
      case 0x0490:
        {
          return [0x0491];
        }
      case 0x0492:
        {
          return [0x0493];
        }
      case 0x0494:
        {
          return [0x0495];
        }
      case 0x0496:
        {
          return [0x0497];
        }
      case 0x0498:
        {
          return [0x0499];
        }
      case 0x049A:
        {
          return [0x049B];
        }
      case 0x049C:
        {
          return [0x049D];
        }
      case 0x049E:
        {
          return [0x049F];
        }
      case 0x04A0:
        {
          return [0x04A1];
        }
      case 0x04A2:
        {
          return [0x04A3];
        }
      case 0x04A4:
        {
          return [0x04A5];
        }
      case 0x04A6:
        {
          return [0x04A7];
        }
      case 0x04A8:
        {
          return [0x04A9];
        }
      case 0x04AA:
        {
          return [0x04AB];
        }
      case 0x04AC:
        {
          return [0x04AD];
        }
      case 0x04AE:
        {
          return [0x04AF];
        }
      case 0x04B0:
        {
          return [0x04B1];
        }
      case 0x04B2:
        {
          return [0x04B3];
        }
      case 0x04B4:
        {
          return [0x04B5];
        }
      case 0x04B6:
        {
          return [0x04B7];
        }
      case 0x04B8:
        {
          return [0x04B9];
        }
      case 0x04BA:
        {
          return [0x04BB];
        }
      case 0x04BC:
        {
          return [0x04BD];
        }
      case 0x04BE:
        {
          return [0x04BF];
        }
      case 0x04C0:
        {
          return [0x04CF];
        }
      case 0x04C1:
        {
          return [0x04C2];
        }
      case 0x04C3:
        {
          return [0x04C4];
        }
      case 0x04C5:
        {
          return [0x04C6];
        }
      case 0x04C7:
        {
          return [0x04C8];
        }
      case 0x04C9:
        {
          return [0x04CA];
        }
      case 0x04CB:
        {
          return [0x04CC];
        }
      case 0x04CD:
        {
          return [0x04CE];
        }
      case 0x04D0:
        {
          return [0x04D1];
        }
      case 0x04D2:
        {
          return [0x04D3];
        }
      case 0x04D4:
        {
          return [0x04D5];
        }
      case 0x04D6:
        {
          return [0x04D7];
        }
      case 0x04D8:
        {
          return [0x04D9];
        }
      case 0x04DA:
        {
          return [0x04DB];
        }
      case 0x04DC:
        {
          return [0x04DD];
        }
      case 0x04DE:
        {
          return [0x04DF];
        }
      case 0x04E0:
        {
          return [0x04E1];
        }
      case 0x04E2:
        {
          return [0x04E3];
        }
      case 0x04E4:
        {
          return [0x04E5];
        }
      case 0x04E6:
        {
          return [0x04E7];
        }
      case 0x04E8:
        {
          return [0x04E9];
        }
      case 0x04EA:
        {
          return [0x04EB];
        }
      case 0x04EC:
        {
          return [0x04ED];
        }
      case 0x04EE:
        {
          return [0x04EF];
        }
      case 0x04F0:
        {
          return [0x04F1];
        }
      case 0x04F2:
        {
          return [0x04F3];
        }
      case 0x04F4:
        {
          return [0x04F5];
        }
      case 0x04F6:
        {
          return [0x04F7];
        }
      case 0x04F8:
        {
          return [0x04F9];
        }
      case 0x04FA:
        {
          return [0x04FB];
        }
      case 0x04FC:
        {
          return [0x04FD];
        }
      case 0x04FE:
        {
          return [0x04FF];
        }
      case 0x0500:
        {
          return [0x0501];
        }
      case 0x0502:
        {
          return [0x0503];
        }
      case 0x0504:
        {
          return [0x0505];
        }
      case 0x0506:
        {
          return [0x0507];
        }
      case 0x0508:
        {
          return [0x0509];
        }
      case 0x050A:
        {
          return [0x050B];
        }
      case 0x050C:
        {
          return [0x050D];
        }
      case 0x050E:
        {
          return [0x050F];
        }
      case 0x0510:
        {
          return [0x0511];
        }
      case 0x0512:
        {
          return [0x0513];
        }
      case 0x0531:
        {
          return [0x0561];
        }
      case 0x0532:
        {
          return [0x0562];
        }
      case 0x0533:
        {
          return [0x0563];
        }
      case 0x0534:
        {
          return [0x0564];
        }
      case 0x0535:
        {
          return [0x0565];
        }
      case 0x0536:
        {
          return [0x0566];
        }
      case 0x0537:
        {
          return [0x0567];
        }
      case 0x0538:
        {
          return [0x0568];
        }
      case 0x0539:
        {
          return [0x0569];
        }
      case 0x053A:
        {
          return [0x056A];
        }
      case 0x053B:
        {
          return [0x056B];
        }
      case 0x053C:
        {
          return [0x056C];
        }
      case 0x053D:
        {
          return [0x056D];
        }
      case 0x053E:
        {
          return [0x056E];
        }
      case 0x053F:
        {
          return [0x056F];
        }
      case 0x0540:
        {
          return [0x0570];
        }
      case 0x0541:
        {
          return [0x0571];
        }
      case 0x0542:
        {
          return [0x0572];
        }
      case 0x0543:
        {
          return [0x0573];
        }
      case 0x0544:
        {
          return [0x0574];
        }
      case 0x0545:
        {
          return [0x0575];
        }
      case 0x0546:
        {
          return [0x0576];
        }
      case 0x0547:
        {
          return [0x0577];
        }
      case 0x0548:
        {
          return [0x0578];
        }
      case 0x0549:
        {
          return [0x0579];
        }
      case 0x054A:
        {
          return [0x057A];
        }
      case 0x054B:
        {
          return [0x057B];
        }
      case 0x054C:
        {
          return [0x057C];
        }
      case 0x054D:
        {
          return [0x057D];
        }
      case 0x054E:
        {
          return [0x057E];
        }
      case 0x054F:
        {
          return [0x057F];
        }
      case 0x0550:
        {
          return [0x0580];
        }
      case 0x0551:
        {
          return [0x0581];
        }
      case 0x0552:
        {
          return [0x0582];
        }
      case 0x0553:
        {
          return [0x0583];
        }
      case 0x0554:
        {
          return [0x0584];
        }
      case 0x0555:
        {
          return [0x0585];
        }
      case 0x0556:
        {
          return [0x0586];
        }
      case 0x10A0:
        {
          return [0x2D00];
        }
      case 0x10A1:
        {
          return [0x2D01];
        }
      case 0x10A2:
        {
          return [0x2D02];
        }
      case 0x10A3:
        {
          return [0x2D03];
        }
      case 0x10A4:
        {
          return [0x2D04];
        }
      case 0x10A5:
        {
          return [0x2D05];
        }
      case 0x10A6:
        {
          return [0x2D06];
        }
      case 0x10A7:
        {
          return [0x2D07];
        }
      case 0x10A8:
        {
          return [0x2D08];
        }
      case 0x10A9:
        {
          return [0x2D09];
        }
      case 0x10AA:
        {
          return [0x2D0A];
        }
      case 0x10AB:
        {
          return [0x2D0B];
        }
      case 0x10AC:
        {
          return [0x2D0C];
        }
      case 0x10AD:
        {
          return [0x2D0D];
        }
      case 0x10AE:
        {
          return [0x2D0E];
        }
      case 0x10AF:
        {
          return [0x2D0F];
        }
      case 0x10B0:
        {
          return [0x2D10];
        }
      case 0x10B1:
        {
          return [0x2D11];
        }
      case 0x10B2:
        {
          return [0x2D12];
        }
      case 0x10B3:
        {
          return [0x2D13];
        }
      case 0x10B4:
        {
          return [0x2D14];
        }
      case 0x10B5:
        {
          return [0x2D15];
        }
      case 0x10B6:
        {
          return [0x2D16];
        }
      case 0x10B7:
        {
          return [0x2D17];
        }
      case 0x10B8:
        {
          return [0x2D18];
        }
      case 0x10B9:
        {
          return [0x2D19];
        }
      case 0x10BA:
        {
          return [0x2D1A];
        }
      case 0x10BB:
        {
          return [0x2D1B];
        }
      case 0x10BC:
        {
          return [0x2D1C];
        }
      case 0x10BD:
        {
          return [0x2D1D];
        }
      case 0x10BE:
        {
          return [0x2D1E];
        }
      case 0x10BF:
        {
          return [0x2D1F];
        }
      case 0x10C0:
        {
          return [0x2D20];
        }
      case 0x10C1:
        {
          return [0x2D21];
        }
      case 0x10C2:
        {
          return [0x2D22];
        }
      case 0x10C3:
        {
          return [0x2D23];
        }
      case 0x10C4:
        {
          return [0x2D24];
        }
      case 0x10C5:
        {
          return [0x2D25];
        }
      case 0x1E00:
        {
          return [0x1E01];
        }
      case 0x1E02:
        {
          return [0x1E03];
        }
      case 0x1E04:
        {
          return [0x1E05];
        }
      case 0x1E06:
        {
          return [0x1E07];
        }
      case 0x1E08:
        {
          return [0x1E09];
        }
      case 0x1E0A:
        {
          return [0x1E0B];
        }
      case 0x1E0C:
        {
          return [0x1E0D];
        }
      case 0x1E0E:
        {
          return [0x1E0F];
        }
      case 0x1E10:
        {
          return [0x1E11];
        }
      case 0x1E12:
        {
          return [0x1E13];
        }
      case 0x1E14:
        {
          return [0x1E15];
        }
      case 0x1E16:
        {
          return [0x1E17];
        }
      case 0x1E18:
        {
          return [0x1E19];
        }
      case 0x1E1A:
        {
          return [0x1E1B];
        }
      case 0x1E1C:
        {
          return [0x1E1D];
        }
      case 0x1E1E:
        {
          return [0x1E1F];
        }
      case 0x1E20:
        {
          return [0x1E21];
        }
      case 0x1E22:
        {
          return [0x1E23];
        }
      case 0x1E24:
        {
          return [0x1E25];
        }
      case 0x1E26:
        {
          return [0x1E27];
        }
      case 0x1E28:
        {
          return [0x1E29];
        }
      case 0x1E2A:
        {
          return [0x1E2B];
        }
      case 0x1E2C:
        {
          return [0x1E2D];
        }
      case 0x1E2E:
        {
          return [0x1E2F];
        }
      case 0x1E30:
        {
          return [0x1E31];
        }
      case 0x1E32:
        {
          return [0x1E33];
        }
      case 0x1E34:
        {
          return [0x1E35];
        }
      case 0x1E36:
        {
          return [0x1E37];
        }
      case 0x1E38:
        {
          return [0x1E39];
        }
      case 0x1E3A:
        {
          return [0x1E3B];
        }
      case 0x1E3C:
        {
          return [0x1E3D];
        }
      case 0x1E3E:
        {
          return [0x1E3F];
        }
      case 0x1E40:
        {
          return [0x1E41];
        }
      case 0x1E42:
        {
          return [0x1E43];
        }
      case 0x1E44:
        {
          return [0x1E45];
        }
      case 0x1E46:
        {
          return [0x1E47];
        }
      case 0x1E48:
        {
          return [0x1E49];
        }
      case 0x1E4A:
        {
          return [0x1E4B];
        }
      case 0x1E4C:
        {
          return [0x1E4D];
        }
      case 0x1E4E:
        {
          return [0x1E4F];
        }
      case 0x1E50:
        {
          return [0x1E51];
        }
      case 0x1E52:
        {
          return [0x1E53];
        }
      case 0x1E54:
        {
          return [0x1E55];
        }
      case 0x1E56:
        {
          return [0x1E57];
        }
      case 0x1E58:
        {
          return [0x1E59];
        }
      case 0x1E5A:
        {
          return [0x1E5B];
        }
      case 0x1E5C:
        {
          return [0x1E5D];
        }
      case 0x1E5E:
        {
          return [0x1E5F];
        }
      case 0x1E60:
        {
          return [0x1E61];
        }
      case 0x1E62:
        {
          return [0x1E63];
        }
      case 0x1E64:
        {
          return [0x1E65];
        }
      case 0x1E66:
        {
          return [0x1E67];
        }
      case 0x1E68:
        {
          return [0x1E69];
        }
      case 0x1E6A:
        {
          return [0x1E6B];
        }
      case 0x1E6C:
        {
          return [0x1E6D];
        }
      case 0x1E6E:
        {
          return [0x1E6F];
        }
      case 0x1E70:
        {
          return [0x1E71];
        }
      case 0x1E72:
        {
          return [0x1E73];
        }
      case 0x1E74:
        {
          return [0x1E75];
        }
      case 0x1E76:
        {
          return [0x1E77];
        }
      case 0x1E78:
        {
          return [0x1E79];
        }
      case 0x1E7A:
        {
          return [0x1E7B];
        }
      case 0x1E7C:
        {
          return [0x1E7D];
        }
      case 0x1E7E:
        {
          return [0x1E7F];
        }
      case 0x1E80:
        {
          return [0x1E81];
        }
      case 0x1E82:
        {
          return [0x1E83];
        }
      case 0x1E84:
        {
          return [0x1E85];
        }
      case 0x1E86:
        {
          return [0x1E87];
        }
      case 0x1E88:
        {
          return [0x1E89];
        }
      case 0x1E8A:
        {
          return [0x1E8B];
        }
      case 0x1E8C:
        {
          return [0x1E8D];
        }
      case 0x1E8E:
        {
          return [0x1E8F];
        }
      case 0x1E90:
        {
          return [0x1E91];
        }
      case 0x1E92:
        {
          return [0x1E93];
        }
      case 0x1E94:
        {
          return [0x1E95];
        }
      case 0x1EA0:
        {
          return [0x1EA1];
        }
      case 0x1EA2:
        {
          return [0x1EA3];
        }
      case 0x1EA4:
        {
          return [0x1EA5];
        }
      case 0x1EA6:
        {
          return [0x1EA7];
        }
      case 0x1EA8:
        {
          return [0x1EA9];
        }
      case 0x1EAA:
        {
          return [0x1EAB];
        }
      case 0x1EAC:
        {
          return [0x1EAD];
        }
      case 0x1EAE:
        {
          return [0x1EAF];
        }
      case 0x1EB0:
        {
          return [0x1EB1];
        }
      case 0x1EB2:
        {
          return [0x1EB3];
        }
      case 0x1EB4:
        {
          return [0x1EB5];
        }
      case 0x1EB6:
        {
          return [0x1EB7];
        }
      case 0x1EB8:
        {
          return [0x1EB9];
        }
      case 0x1EBA:
        {
          return [0x1EBB];
        }
      case 0x1EBC:
        {
          return [0x1EBD];
        }
      case 0x1EBE:
        {
          return [0x1EBF];
        }
      case 0x1EC0:
        {
          return [0x1EC1];
        }
      case 0x1EC2:
        {
          return [0x1EC3];
        }
      case 0x1EC4:
        {
          return [0x1EC5];
        }
      case 0x1EC6:
        {
          return [0x1EC7];
        }
      case 0x1EC8:
        {
          return [0x1EC9];
        }
      case 0x1ECA:
        {
          return [0x1ECB];
        }
      case 0x1ECC:
        {
          return [0x1ECD];
        }
      case 0x1ECE:
        {
          return [0x1ECF];
        }
      case 0x1ED0:
        {
          return [0x1ED1];
        }
      case 0x1ED2:
        {
          return [0x1ED3];
        }
      case 0x1ED4:
        {
          return [0x1ED5];
        }
      case 0x1ED6:
        {
          return [0x1ED7];
        }
      case 0x1ED8:
        {
          return [0x1ED9];
        }
      case 0x1EDA:
        {
          return [0x1EDB];
        }
      case 0x1EDC:
        {
          return [0x1EDD];
        }
      case 0x1EDE:
        {
          return [0x1EDF];
        }
      case 0x1EE0:
        {
          return [0x1EE1];
        }
      case 0x1EE2:
        {
          return [0x1EE3];
        }
      case 0x1EE4:
        {
          return [0x1EE5];
        }
      case 0x1EE6:
        {
          return [0x1EE7];
        }
      case 0x1EE8:
        {
          return [0x1EE9];
        }
      case 0x1EEA:
        {
          return [0x1EEB];
        }
      case 0x1EEC:
        {
          return [0x1EED];
        }
      case 0x1EEE:
        {
          return [0x1EEF];
        }
      case 0x1EF0:
        {
          return [0x1EF1];
        }
      case 0x1EF2:
        {
          return [0x1EF3];
        }
      case 0x1EF4:
        {
          return [0x1EF5];
        }
      case 0x1EF6:
        {
          return [0x1EF7];
        }
      case 0x1EF8:
        {
          return [0x1EF9];
        }
      case 0x1F08:
        {
          return [0x1F00];
        }
      case 0x1F09:
        {
          return [0x1F01];
        }
      case 0x1F0A:
        {
          return [0x1F02];
        }
      case 0x1F0B:
        {
          return [0x1F03];
        }
      case 0x1F0C:
        {
          return [0x1F04];
        }
      case 0x1F0D:
        {
          return [0x1F05];
        }
      case 0x1F0E:
        {
          return [0x1F06];
        }
      case 0x1F0F:
        {
          return [0x1F07];
        }
      case 0x1F18:
        {
          return [0x1F10];
        }
      case 0x1F19:
        {
          return [0x1F11];
        }
      case 0x1F1A:
        {
          return [0x1F12];
        }
      case 0x1F1B:
        {
          return [0x1F13];
        }
      case 0x1F1C:
        {
          return [0x1F14];
        }
      case 0x1F1D:
        {
          return [0x1F15];
        }
      case 0x1F28:
        {
          return [0x1F20];
        }
      case 0x1F29:
        {
          return [0x1F21];
        }
      case 0x1F2A:
        {
          return [0x1F22];
        }
      case 0x1F2B:
        {
          return [0x1F23];
        }
      case 0x1F2C:
        {
          return [0x1F24];
        }
      case 0x1F2D:
        {
          return [0x1F25];
        }
      case 0x1F2E:
        {
          return [0x1F26];
        }
      case 0x1F2F:
        {
          return [0x1F27];
        }
      case 0x1F38:
        {
          return [0x1F30];
        }
      case 0x1F39:
        {
          return [0x1F31];
        }
      case 0x1F3A:
        {
          return [0x1F32];
        }
      case 0x1F3B:
        {
          return [0x1F33];
        }
      case 0x1F3C:
        {
          return [0x1F34];
        }
      case 0x1F3D:
        {
          return [0x1F35];
        }
      case 0x1F3E:
        {
          return [0x1F36];
        }
      case 0x1F3F:
        {
          return [0x1F37];
        }
      case 0x1F48:
        {
          return [0x1F40];
        }
      case 0x1F49:
        {
          return [0x1F41];
        }
      case 0x1F4A:
        {
          return [0x1F42];
        }
      case 0x1F4B:
        {
          return [0x1F43];
        }
      case 0x1F4C:
        {
          return [0x1F44];
        }
      case 0x1F4D:
        {
          return [0x1F45];
        }
      case 0x1F59:
        {
          return [0x1F51];
        }
      case 0x1F5B:
        {
          return [0x1F53];
        }
      case 0x1F5D:
        {
          return [0x1F55];
        }
      case 0x1F5F:
        {
          return [0x1F57];
        }
      case 0x1F68:
        {
          return [0x1F60];
        }
      case 0x1F69:
        {
          return [0x1F61];
        }
      case 0x1F6A:
        {
          return [0x1F62];
        }
      case 0x1F6B:
        {
          return [0x1F63];
        }
      case 0x1F6C:
        {
          return [0x1F64];
        }
      case 0x1F6D:
        {
          return [0x1F65];
        }
      case 0x1F6E:
        {
          return [0x1F66];
        }
      case 0x1F6F:
        {
          return [0x1F67];
        }
      case 0x1F88:
        {
          return [0x1F80];
        }
      case 0x1F89:
        {
          return [0x1F81];
        }
      case 0x1F8A:
        {
          return [0x1F82];
        }
      case 0x1F8B:
        {
          return [0x1F83];
        }
      case 0x1F8C:
        {
          return [0x1F84];
        }
      case 0x1F8D:
        {
          return [0x1F85];
        }
      case 0x1F8E:
        {
          return [0x1F86];
        }
      case 0x1F8F:
        {
          return [0x1F87];
        }
      case 0x1F98:
        {
          return [0x1F90];
        }
      case 0x1F99:
        {
          return [0x1F91];
        }
      case 0x1F9A:
        {
          return [0x1F92];
        }
      case 0x1F9B:
        {
          return [0x1F93];
        }
      case 0x1F9C:
        {
          return [0x1F94];
        }
      case 0x1F9D:
        {
          return [0x1F95];
        }
      case 0x1F9E:
        {
          return [0x1F96];
        }
      case 0x1F9F:
        {
          return [0x1F97];
        }
      case 0x1FA8:
        {
          return [0x1FA0];
        }
      case 0x1FA9:
        {
          return [0x1FA1];
        }
      case 0x1FAA:
        {
          return [0x1FA2];
        }
      case 0x1FAB:
        {
          return [0x1FA3];
        }
      case 0x1FAC:
        {
          return [0x1FA4];
        }
      case 0x1FAD:
        {
          return [0x1FA5];
        }
      case 0x1FAE:
        {
          return [0x1FA6];
        }
      case 0x1FAF:
        {
          return [0x1FA7];
        }
      case 0x1FB8:
        {
          return [0x1FB0];
        }
      case 0x1FB9:
        {
          return [0x1FB1];
        }
      case 0x1FBA:
        {
          return [0x1F70];
        }
      case 0x1FBB:
        {
          return [0x1F71];
        }
      case 0x1FBC:
        {
          return [0x1FB3];
        }
      case 0x1FC8:
        {
          return [0x1F72];
        }
      case 0x1FC9:
        {
          return [0x1F73];
        }
      case 0x1FCA:
        {
          return [0x1F74];
        }
      case 0x1FCB:
        {
          return [0x1F75];
        }
      case 0x1FCC:
        {
          return [0x1FC3];
        }
      case 0x1FD8:
        {
          return [0x1FD0];
        }
      case 0x1FD9:
        {
          return [0x1FD1];
        }
      case 0x1FDA:
        {
          return [0x1F76];
        }
      case 0x1FDB:
        {
          return [0x1F77];
        }
      case 0x1FE8:
        {
          return [0x1FE0];
        }
      case 0x1FE9:
        {
          return [0x1FE1];
        }
      case 0x1FEA:
        {
          return [0x1F7A];
        }
      case 0x1FEB:
        {
          return [0x1F7B];
        }
      case 0x1FEC:
        {
          return [0x1FE5];
        }
      case 0x1FF8:
        {
          return [0x1F78];
        }
      case 0x1FF9:
        {
          return [0x1F79];
        }
      case 0x1FFA:
        {
          return [0x1F7C];
        }
      case 0x1FFB:
        {
          return [0x1F7D];
        }
      case 0x1FFC:
        {
          return [0x1FF3];
        }
      default:
        return null;
    }
  }
}
class LowercaseMachineBeta {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0x2126:
        {
          return [0x03C9];
        }
      case 0x212A:
        {
          return [0x006B];
        }
      case 0x212B:
        {
          return [0x00E5];
        }
      case 0x2132:
        {
          return [0x214E];
        }
      case 0x2160:
        {
          return [0x2170];
        }
      case 0x2161:
        {
          return [0x2171];
        }
      case 0x2162:
        {
          return [0x2172];
        }
      case 0x2163:
        {
          return [0x2173];
        }
      case 0x2164:
        {
          return [0x2174];
        }
      case 0x2165:
        {
          return [0x2175];
        }
      case 0x2166:
        {
          return [0x2176];
        }
      case 0x2167:
        {
          return [0x2177];
        }
      case 0x2168:
        {
          return [0x2178];
        }
      case 0x2169:
        {
          return [0x2179];
        }
      case 0x216A:
        {
          return [0x217A];
        }
      case 0x216B:
        {
          return [0x217B];
        }
      case 0x216C:
        {
          return [0x217C];
        }
      case 0x216D:
        {
          return [0x217D];
        }
      case 0x216E:
        {
          return [0x217E];
        }
      case 0x216F:
        {
          return [0x217F];
        }
      case 0x2183:
        {
          return [0x2184];
        }
      case 0x24B6:
        {
          return [0x24D0];
        }
      case 0x24B7:
        {
          return [0x24D1];
        }
      case 0x24B8:
        {
          return [0x24D2];
        }
      case 0x24B9:
        {
          return [0x24D3];
        }
      case 0x24BA:
        {
          return [0x24D4];
        }
      case 0x24BB:
        {
          return [0x24D5];
        }
      case 0x24BC:
        {
          return [0x24D6];
        }
      case 0x24BD:
        {
          return [0x24D7];
        }
      case 0x24BE:
        {
          return [0x24D8];
        }
      case 0x24BF:
        {
          return [0x24D9];
        }
      case 0x24C0:
        {
          return [0x24DA];
        }
      case 0x24C1:
        {
          return [0x24DB];
        }
      case 0x24C2:
        {
          return [0x24DC];
        }
      case 0x24C3:
        {
          return [0x24DD];
        }
      case 0x24C4:
        {
          return [0x24DE];
        }
      case 0x24C5:
        {
          return [0x24DF];
        }
      case 0x24C6:
        {
          return [0x24E0];
        }
      case 0x24C7:
        {
          return [0x24E1];
        }
      case 0x24C8:
        {
          return [0x24E2];
        }
      case 0x24C9:
        {
          return [0x24E3];
        }
      case 0x24CA:
        {
          return [0x24E4];
        }
      case 0x24CB:
        {
          return [0x24E5];
        }
      case 0x24CC:
        {
          return [0x24E6];
        }
      case 0x24CD:
        {
          return [0x24E7];
        }
      case 0x24CE:
        {
          return [0x24E8];
        }
      case 0x24CF:
        {
          return [0x24E9];
        }
      case 0x2C00:
        {
          return [0x2C30];
        }
      case 0x2C01:
        {
          return [0x2C31];
        }
      case 0x2C02:
        {
          return [0x2C32];
        }
      case 0x2C03:
        {
          return [0x2C33];
        }
      case 0x2C04:
        {
          return [0x2C34];
        }
      case 0x2C05:
        {
          return [0x2C35];
        }
      case 0x2C06:
        {
          return [0x2C36];
        }
      case 0x2C07:
        {
          return [0x2C37];
        }
      case 0x2C08:
        {
          return [0x2C38];
        }
      case 0x2C09:
        {
          return [0x2C39];
        }
      case 0x2C0A:
        {
          return [0x2C3A];
        }
      case 0x2C0B:
        {
          return [0x2C3B];
        }
      case 0x2C0C:
        {
          return [0x2C3C];
        }
      case 0x2C0D:
        {
          return [0x2C3D];
        }
      case 0x2C0E:
        {
          return [0x2C3E];
        }
      case 0x2C0F:
        {
          return [0x2C3F];
        }
      case 0x2C10:
        {
          return [0x2C40];
        }
      case 0x2C11:
        {
          return [0x2C41];
        }
      case 0x2C12:
        {
          return [0x2C42];
        }
      case 0x2C13:
        {
          return [0x2C43];
        }
      case 0x2C14:
        {
          return [0x2C44];
        }
      case 0x2C15:
        {
          return [0x2C45];
        }
      case 0x2C16:
        {
          return [0x2C46];
        }
      case 0x2C17:
        {
          return [0x2C47];
        }
      case 0x2C18:
        {
          return [0x2C48];
        }
      case 0x2C19:
        {
          return [0x2C49];
        }
      case 0x2C1A:
        {
          return [0x2C4A];
        }
      case 0x2C1B:
        {
          return [0x2C4B];
        }
      case 0x2C1C:
        {
          return [0x2C4C];
        }
      case 0x2C1D:
        {
          return [0x2C4D];
        }
      case 0x2C1E:
        {
          return [0x2C4E];
        }
      case 0x2C1F:
        {
          return [0x2C4F];
        }
      case 0x2C20:
        {
          return [0x2C50];
        }
      case 0x2C21:
        {
          return [0x2C51];
        }
      case 0x2C22:
        {
          return [0x2C52];
        }
      case 0x2C23:
        {
          return [0x2C53];
        }
      case 0x2C24:
        {
          return [0x2C54];
        }
      case 0x2C25:
        {
          return [0x2C55];
        }
      case 0x2C26:
        {
          return [0x2C56];
        }
      case 0x2C27:
        {
          return [0x2C57];
        }
      case 0x2C28:
        {
          return [0x2C58];
        }
      case 0x2C29:
        {
          return [0x2C59];
        }
      case 0x2C2A:
        {
          return [0x2C5A];
        }
      case 0x2C2B:
        {
          return [0x2C5B];
        }
      case 0x2C2C:
        {
          return [0x2C5C];
        }
      case 0x2C2D:
        {
          return [0x2C5D];
        }
      case 0x2C2E:
        {
          return [0x2C5E];
        }
      case 0x2C60:
        {
          return [0x2C61];
        }
      case 0x2C62:
        {
          return [0x026B];
        }
      case 0x2C63:
        {
          return [0x1D7D];
        }
      case 0x2C64:
        {
          return [0x027D];
        }
      case 0x2C67:
        {
          return [0x2C68];
        }
      case 0x2C69:
        {
          return [0x2C6A];
        }
      case 0x2C6B:
        {
          return [0x2C6C];
        }
      case 0x2C75:
        {
          return [0x2C76];
        }
      case 0x2C80:
        {
          return [0x2C81];
        }
      case 0x2C82:
        {
          return [0x2C83];
        }
      case 0x2C84:
        {
          return [0x2C85];
        }
      case 0x2C86:
        {
          return [0x2C87];
        }
      case 0x2C88:
        {
          return [0x2C89];
        }
      case 0x2C8A:
        {
          return [0x2C8B];
        }
      case 0x2C8C:
        {
          return [0x2C8D];
        }
      case 0x2C8E:
        {
          return [0x2C8F];
        }
      case 0x2C90:
        {
          return [0x2C91];
        }
      case 0x2C92:
        {
          return [0x2C93];
        }
      case 0x2C94:
        {
          return [0x2C95];
        }
      case 0x2C96:
        {
          return [0x2C97];
        }
      case 0x2C98:
        {
          return [0x2C99];
        }
      case 0x2C9A:
        {
          return [0x2C9B];
        }
      case 0x2C9C:
        {
          return [0x2C9D];
        }
      case 0x2C9E:
        {
          return [0x2C9F];
        }
      case 0x2CA0:
        {
          return [0x2CA1];
        }
      case 0x2CA2:
        {
          return [0x2CA3];
        }
      case 0x2CA4:
        {
          return [0x2CA5];
        }
      case 0x2CA6:
        {
          return [0x2CA7];
        }
      case 0x2CA8:
        {
          return [0x2CA9];
        }
      case 0x2CAA:
        {
          return [0x2CAB];
        }
      case 0x2CAC:
        {
          return [0x2CAD];
        }
      case 0x2CAE:
        {
          return [0x2CAF];
        }
      case 0x2CB0:
        {
          return [0x2CB1];
        }
      case 0x2CB2:
        {
          return [0x2CB3];
        }
      case 0x2CB4:
        {
          return [0x2CB5];
        }
      case 0x2CB6:
        {
          return [0x2CB7];
        }
      case 0x2CB8:
        {
          return [0x2CB9];
        }
      case 0x2CBA:
        {
          return [0x2CBB];
        }
      case 0x2CBC:
        {
          return [0x2CBD];
        }
      case 0x2CBE:
        {
          return [0x2CBF];
        }
      case 0x2CC0:
        {
          return [0x2CC1];
        }
      case 0x2CC2:
        {
          return [0x2CC3];
        }
      case 0x2CC4:
        {
          return [0x2CC5];
        }
      case 0x2CC6:
        {
          return [0x2CC7];
        }
      case 0x2CC8:
        {
          return [0x2CC9];
        }
      case 0x2CCA:
        {
          return [0x2CCB];
        }
      case 0x2CCC:
        {
          return [0x2CCD];
        }
      case 0x2CCE:
        {
          return [0x2CCF];
        }
      case 0x2CD0:
        {
          return [0x2CD1];
        }
      case 0x2CD2:
        {
          return [0x2CD3];
        }
      case 0x2CD4:
        {
          return [0x2CD5];
        }
      case 0x2CD6:
        {
          return [0x2CD7];
        }
      case 0x2CD8:
        {
          return [0x2CD9];
        }
      case 0x2CDA:
        {
          return [0x2CDB];
        }
      case 0x2CDC:
        {
          return [0x2CDD];
        }
      case 0x2CDE:
        {
          return [0x2CDF];
        }
      case 0x2CE0:
        {
          return [0x2CE1];
        }
      case 0x2CE2:
        {
          return [0x2CE3];
        }
      default:
        return null;
    }
  }
}
class DecompositionMachineTheta {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0xF900:
        {
          return [0x8C48];
        }
      case 0xF901:
        {
          return [0x66F4];
        }
      case 0xF902:
        {
          return [0x8ECA];
        }
      case 0xF903:
        {
          return [0x8CC8];
        }
      case 0xF904:
        {
          return [0x6ED1];
        }
      case 0xF905:
        {
          return [0x4E32];
        }
      case 0xF906:
        {
          return [0x53E5];
        }
      case 0xF907:
        {
          return [0x9F9C];
        }
      case 0xF908:
        {
          return [0x9F9C];
        }
      case 0xF909:
        {
          return [0x5951];
        }
      case 0xF90A:
        {
          return [0x91D1];
        }
      case 0xF90B:
        {
          return [0x5587];
        }
      case 0xF90C:
        {
          return [0x5948];
        }
      case 0xF90D:
        {
          return [0x61F6];
        }
      case 0xF90E:
        {
          return [0x7669];
        }
      case 0xF90F:
        {
          return [0x7F85];
        }
      case 0xF910:
        {
          return [0x863F];
        }
      case 0xF911:
        {
          return [0x87BA];
        }
      case 0xF912:
        {
          return [0x88F8];
        }
      case 0xF913:
        {
          return [0x908F];
        }
      case 0xF914:
        {
          return [0x6A02];
        }
      case 0xF915:
        {
          return [0x6D1B];
        }
      case 0xF916:
        {
          return [0x70D9];
        }
      case 0xF917:
        {
          return [0x73DE];
        }
      case 0xF918:
        {
          return [0x843D];
        }
      case 0xF919:
        {
          return [0x916A];
        }
      case 0xF91A:
        {
          return [0x99F1];
        }
      case 0xF91B:
        {
          return [0x4E82];
        }
      case 0xF91C:
        {
          return [0x5375];
        }
      case 0xF91D:
        {
          return [0x6B04];
        }
      case 0xF91E:
        {
          return [0x721B];
        }
      case 0xF91F:
        {
          return [0x862D];
        }
      case 0xF920:
        {
          return [0x9E1E];
        }
      case 0xF921:
        {
          return [0x5D50];
        }
      case 0xF922:
        {
          return [0x6FEB];
        }
      case 0xF923:
        {
          return [0x85CD];
        }
      case 0xF924:
        {
          return [0x8964];
        }
      case 0xF925:
        {
          return [0x62C9];
        }
      case 0xF926:
        {
          return [0x81D8];
        }
      case 0xF927:
        {
          return [0x881F];
        }
      case 0xF928:
        {
          return [0x5ECA];
        }
      case 0xF929:
        {
          return [0x6717];
        }
      case 0xF92A:
        {
          return [0x6D6A];
        }
      case 0xF92B:
        {
          return [0x72FC];
        }
      case 0xF92C:
        {
          return [0x90CE];
        }
      case 0xF92D:
        {
          return [0x4F86];
        }
      case 0xF92E:
        {
          return [0x51B7];
        }
      case 0xF92F:
        {
          return [0x52DE];
        }
      case 0xF930:
        {
          return [0x64C4];
        }
      case 0xF931:
        {
          return [0x6AD3];
        }
      case 0xF932:
        {
          return [0x7210];
        }
      case 0xF933:
        {
          return [0x76E7];
        }
      case 0xF934:
        {
          return [0x8001];
        }
      case 0xF935:
        {
          return [0x8606];
        }
      case 0xF936:
        {
          return [0x865C];
        }
      case 0xF937:
        {
          return [0x8DEF];
        }
      case 0xF938:
        {
          return [0x9732];
        }
      case 0xF939:
        {
          return [0x9B6F];
        }
      case 0xF93A:
        {
          return [0x9DFA];
        }
      case 0xF93B:
        {
          return [0x788C];
        }
      case 0xF93C:
        {
          return [0x797F];
        }
      case 0xF93D:
        {
          return [0x7DA0];
        }
      case 0xF93E:
        {
          return [0x83C9];
        }
      case 0xF93F:
        {
          return [0x9304];
        }
      case 0xF940:
        {
          return [0x9E7F];
        }
      case 0xF941:
        {
          return [0x8AD6];
        }
      case 0xF942:
        {
          return [0x58DF];
        }
      case 0xF943:
        {
          return [0x5F04];
        }
      case 0xF944:
        {
          return [0x7C60];
        }
      case 0xF945:
        {
          return [0x807E];
        }
      case 0xF946:
        {
          return [0x7262];
        }
      case 0xF947:
        {
          return [0x78CA];
        }
      case 0xF948:
        {
          return [0x8CC2];
        }
      case 0xF949:
        {
          return [0x96F7];
        }
      case 0xF94A:
        {
          return [0x58D8];
        }
      case 0xF94B:
        {
          return [0x5C62];
        }
      case 0xF94C:
        {
          return [0x6A13];
        }
      case 0xF94D:
        {
          return [0x6DDA];
        }
      case 0xF94E:
        {
          return [0x6F0F];
        }
      case 0xF94F:
        {
          return [0x7D2F];
        }
      case 0xF950:
        {
          return [0x7E37];
        }
      case 0xF951:
        {
          return [0x964B];
        }
      case 0xF952:
        {
          return [0x52D2];
        }
      case 0xF953:
        {
          return [0x808B];
        }
      case 0xF954:
        {
          return [0x51DC];
        }
      case 0xF955:
        {
          return [0x51CC];
        }
      case 0xF956:
        {
          return [0x7A1C];
        }
      case 0xF957:
        {
          return [0x7DBE];
        }
      case 0xF958:
        {
          return [0x83F1];
        }
      case 0xF959:
        {
          return [0x9675];
        }
      case 0xF95A:
        {
          return [0x8B80];
        }
      case 0xF95B:
        {
          return [0x62CF];
        }
      case 0xF95C:
        {
          return [0x6A02];
        }
      case 0xF95D:
        {
          return [0x8AFE];
        }
      case 0xF95E:
        {
          return [0x4E39];
        }
      case 0xF95F:
        {
          return [0x5BE7];
        }
      case 0xF960:
        {
          return [0x6012];
        }
      case 0xF961:
        {
          return [0x7387];
        }
      case 0xF962:
        {
          return [0x7570];
        }
      case 0xF963:
        {
          return [0x5317];
        }
      case 0xF964:
        {
          return [0x78FB];
        }
      case 0xF965:
        {
          return [0x4FBF];
        }
      case 0xF966:
        {
          return [0x5FA9];
        }
      case 0xF967:
        {
          return [0x4E0D];
        }
      case 0xF968:
        {
          return [0x6CCC];
        }
      case 0xF969:
        {
          return [0x6578];
        }
      case 0xF96A:
        {
          return [0x7D22];
        }
      case 0xF96B:
        {
          return [0x53C3];
        }
      case 0xF96C:
        {
          return [0x585E];
        }
      case 0xF96D:
        {
          return [0x7701];
        }
      case 0xF96E:
        {
          return [0x8449];
        }
      case 0xF96F:
        {
          return [0x8AAA];
        }
      case 0xF970:
        {
          return [0x6BBA];
        }
      case 0xF971:
        {
          return [0x8FB0];
        }
      case 0xF972:
        {
          return [0x6C88];
        }
      case 0xF973:
        {
          return [0x62FE];
        }
      case 0xF974:
        {
          return [0x82E5];
        }
      case 0xF975:
        {
          return [0x63A0];
        }
      case 0xF976:
        {
          return [0x7565];
        }
      case 0xF977:
        {
          return [0x4EAE];
        }
      case 0xF978:
        {
          return [0x5169];
        }
      case 0xF979:
        {
          return [0x51C9];
        }
      case 0xF97A:
        {
          return [0x6881];
        }
      case 0xF97B:
        {
          return [0x7CE7];
        }
      case 0xF97C:
        {
          return [0x826F];
        }
      case 0xF97D:
        {
          return [0x8AD2];
        }
      case 0xF97E:
        {
          return [0x91CF];
        }
      case 0xF97F:
        {
          return [0x52F5];
        }
      case 0xF980:
        {
          return [0x5442];
        }
      case 0xF981:
        {
          return [0x5973];
        }
      case 0xF982:
        {
          return [0x5EEC];
        }
      case 0xF983:
        {
          return [0x65C5];
        }
      case 0xF984:
        {
          return [0x6FFE];
        }
      case 0xF985:
        {
          return [0x792A];
        }
      case 0xF986:
        {
          return [0x95AD];
        }
      case 0xF987:
        {
          return [0x9A6A];
        }
      case 0xF988:
        {
          return [0x9E97];
        }
      case 0xF989:
        {
          return [0x9ECE];
        }
      case 0xF98A:
        {
          return [0x529B];
        }
      case 0xF98B:
        {
          return [0x66C6];
        }
      case 0xF98C:
        {
          return [0x6B77];
        }
      case 0xF98D:
        {
          return [0x8F62];
        }
      case 0xF98E:
        {
          return [0x5E74];
        }
      case 0xF98F:
        {
          return [0x6190];
        }
      case 0xF990:
        {
          return [0x6200];
        }
      case 0xF991:
        {
          return [0x649A];
        }
      case 0xF992:
        {
          return [0x6F23];
        }
      case 0xF993:
        {
          return [0x7149];
        }
      case 0xF994:
        {
          return [0x7489];
        }
      case 0xF995:
        {
          return [0x79CA];
        }
      case 0xF996:
        {
          return [0x7DF4];
        }
      case 0xF997:
        {
          return [0x806F];
        }
      case 0xF998:
        {
          return [0x8F26];
        }
      case 0xF999:
        {
          return [0x84EE];
        }
      case 0xF99A:
        {
          return [0x9023];
        }
      case 0xF99B:
        {
          return [0x934A];
        }
      case 0xF99C:
        {
          return [0x5217];
        }
      case 0xF99D:
        {
          return [0x52A3];
        }
      case 0xF99E:
        {
          return [0x54BD];
        }
      case 0xF99F:
        {
          return [0x70C8];
        }
      case 0xF9A0:
        {
          return [0x88C2];
        }
      case 0xF9A1:
        {
          return [0x8AAA];
        }
      case 0xF9A2:
        {
          return [0x5EC9];
        }
      case 0xF9A3:
        {
          return [0x5FF5];
        }
      case 0xF9A4:
        {
          return [0x637B];
        }
      case 0xF9A5:
        {
          return [0x6BAE];
        }
      case 0xF9A6:
        {
          return [0x7C3E];
        }
      case 0xF9A7:
        {
          return [0x7375];
        }
      case 0xF9A8:
        {
          return [0x4EE4];
        }
      case 0xF9A9:
        {
          return [0x56F9];
        }
      case 0xF9AA:
        {
          return [0x5BE7];
        }
      case 0xF9AB:
        {
          return [0x5DBA];
        }
      case 0xF9AC:
        {
          return [0x601C];
        }
      case 0xF9AD:
        {
          return [0x73B2];
        }
      case 0xF9AE:
        {
          return [0x7469];
        }
      case 0xF9AF:
        {
          return [0x7F9A];
        }
      case 0xF9B0:
        {
          return [0x8046];
        }
      case 0xF9B1:
        {
          return [0x9234];
        }
      case 0xF9B2:
        {
          return [0x96F6];
        }
      case 0xF9B3:
        {
          return [0x9748];
        }
      case 0xF9B4:
        {
          return [0x9818];
        }
      case 0xF9B5:
        {
          return [0x4F8B];
        }
      case 0xF9B6:
        {
          return [0x79AE];
        }
      case 0xF9B7:
        {
          return [0x91B4];
        }
      case 0xF9B8:
        {
          return [0x96B8];
        }
      case 0xF9B9:
        {
          return [0x60E1];
        }
      case 0xF9BA:
        {
          return [0x4E86];
        }
      case 0xF9BB:
        {
          return [0x50DA];
        }
      case 0xF9BC:
        {
          return [0x5BEE];
        }
      case 0xF9BD:
        {
          return [0x5C3F];
        }
      case 0xF9BE:
        {
          return [0x6599];
        }
      case 0xF9BF:
        {
          return [0x6A02];
        }
      case 0xF9C0:
        {
          return [0x71CE];
        }
      case 0xF9C1:
        {
          return [0x7642];
        }
      case 0xF9C2:
        {
          return [0x84FC];
        }
      case 0xF9C3:
        {
          return [0x907C];
        }
      case 0xF9C4:
        {
          return [0x9F8D];
        }
      case 0xF9C5:
        {
          return [0x6688];
        }
      case 0xF9C6:
        {
          return [0x962E];
        }
      case 0xF9C7:
        {
          return [0x5289];
        }
      case 0xF9C8:
        {
          return [0x677B];
        }
      case 0xF9C9:
        {
          return [0x67F3];
        }
      case 0xF9CA:
        {
          return [0x6D41];
        }
      case 0xF9CB:
        {
          return [0x6E9C];
        }
      case 0xF9CC:
        {
          return [0x7409];
        }
      case 0xF9CD:
        {
          return [0x7559];
        }
      case 0xF9CE:
        {
          return [0x786B];
        }
      case 0xF9CF:
        {
          return [0x7D10];
        }
      case 0xF9D0:
        {
          return [0x985E];
        }
      case 0xF9D1:
        {
          return [0x516D];
        }
      case 0xF9D2:
        {
          return [0x622E];
        }
      case 0xF9D3:
        {
          return [0x9678];
        }
      case 0xF9D4:
        {
          return [0x502B];
        }
      case 0xF9D5:
        {
          return [0x5D19];
        }
      case 0xF9D6:
        {
          return [0x6DEA];
        }
      case 0xF9D7:
        {
          return [0x8F2A];
        }
      case 0xF9D8:
        {
          return [0x5F8B];
        }
      case 0xF9D9:
        {
          return [0x6144];
        }
      case 0xF9DA:
        {
          return [0x6817];
        }
      case 0xF9DB:
        {
          return [0x7387];
        }
      case 0xF9DC:
        {
          return [0x9686];
        }
      case 0xF9DD:
        {
          return [0x5229];
        }
      case 0xF9DE:
        {
          return [0x540F];
        }
      case 0xF9DF:
        {
          return [0x5C65];
        }
      case 0xF9E0:
        {
          return [0x6613];
        }
      case 0xF9E1:
        {
          return [0x674E];
        }
      case 0xF9E2:
        {
          return [0x68A8];
        }
      case 0xF9E3:
        {
          return [0x6CE5];
        }
      case 0xF9E4:
        {
          return [0x7406];
        }
      case 0xF9E5:
        {
          return [0x75E2];
        }
      case 0xF9E6:
        {
          return [0x7F79];
        }
      case 0xF9E7:
        {
          return [0x88CF];
        }
      case 0xF9E8:
        {
          return [0x88E1];
        }
      case 0xF9E9:
        {
          return [0x91CC];
        }
      case 0xF9EA:
        {
          return [0x96E2];
        }
      case 0xF9EB:
        {
          return [0x533F];
        }
      case 0xF9EC:
        {
          return [0x6EBA];
        }
      case 0xF9ED:
        {
          return [0x541D];
        }
      case 0xF9EE:
        {
          return [0x71D0];
        }
      case 0xF9EF:
        {
          return [0x7498];
        }
      case 0xF9F0:
        {
          return [0x85FA];
        }
      case 0xF9F1:
        {
          return [0x96A3];
        }
      case 0xF9F2:
        {
          return [0x9C57];
        }
      case 0xF9F3:
        {
          return [0x9E9F];
        }
      case 0xF9F4:
        {
          return [0x6797];
        }
      case 0xF9F5:
        {
          return [0x6DCB];
        }
      case 0xF9F6:
        {
          return [0x81E8];
        }
      case 0xF9F7:
        {
          return [0x7ACB];
        }
      case 0xF9F8:
        {
          return [0x7B20];
        }
      case 0xF9F9:
        {
          return [0x7C92];
        }
      case 0xF9FA:
        {
          return [0x72C0];
        }
      case 0xF9FB:
        {
          return [0x7099];
        }
      case 0xF9FC:
        {
          return [0x8B58];
        }
      case 0xF9FD:
        {
          return [0x4EC0];
        }
      case 0xF9FE:
        {
          return [0x8336];
        }
      case 0xF9FF:
        {
          return [0x523A];
        }
      case 0xFA00:
        {
          return [0x5207];
        }
      case 0xFA01:
        {
          return [0x5EA6];
        }
      case 0xFA02:
        {
          return [0x62D3];
        }
      case 0xFA03:
        {
          return [0x7CD6];
        }
      case 0xFA04:
        {
          return [0x5B85];
        }
      case 0xFA05:
        {
          return [0x6D1E];
        }
      case 0xFA06:
        {
          return [0x66B4];
        }
      case 0xFA07:
        {
          return [0x8F3B];
        }
      case 0xFA08:
        {
          return [0x884C];
        }
      case 0xFA09:
        {
          return [0x964D];
        }
      case 0xFA0A:
        {
          return [0x898B];
        }
      case 0xFA0B:
        {
          return [0x5ED3];
        }
      case 0xFA0C:
        {
          return [0x5140];
        }
      case 0xFA0D:
        {
          return [0x55C0];
        }
      case 0xFA10:
        {
          return [0x585A];
        }
      case 0xFA12:
        {
          return [0x6674];
        }
      case 0xFA15:
        {
          return [0x51DE];
        }
      case 0xFA16:
        {
          return [0x732A];
        }
      case 0xFA17:
        {
          return [0x76CA];
        }
      case 0xFA18:
        {
          return [0x793C];
        }
      case 0xFA19:
        {
          return [0x795E];
        }
      case 0xFA1A:
        {
          return [0x7965];
        }
      case 0xFA1B:
        {
          return [0x798F];
        }
      case 0xFA1C:
        {
          return [0x9756];
        }
      case 0xFA1D:
        {
          return [0x7CBE];
        }
      case 0xFA1E:
        {
          return [0x7FBD];
        }
      case 0xFA20:
        {
          return [0x8612];
        }
      case 0xFA22:
        {
          return [0x8AF8];
        }
      case 0xFA25:
        {
          return [0x9038];
        }
      case 0xFA26:
        {
          return [0x90FD];
        }
      case 0xFA2A:
        {
          return [0x98EF];
        }
      case 0xFA2B:
        {
          return [0x98FC];
        }
      case 0xFA2C:
        {
          return [0x9928];
        }
      case 0xFA2D:
        {
          return [0x9DB4];
        }
      case 0xFA30:
        {
          return [0x4FAE];
        }
      case 0xFA31:
        {
          return [0x50E7];
        }
      case 0xFA32:
        {
          return [0x514D];
        }
      case 0xFA33:
        {
          return [0x52C9];
        }
      case 0xFA34:
        {
          return [0x52E4];
        }
      case 0xFA35:
        {
          return [0x5351];
        }
      case 0xFA36:
        {
          return [0x559D];
        }
      case 0xFA37:
        {
          return [0x5606];
        }
      case 0xFA38:
        {
          return [0x5668];
        }
      case 0xFA39:
        {
          return [0x5840];
        }
      case 0xFA3A:
        {
          return [0x58A8];
        }
      case 0xFA3B:
        {
          return [0x5C64];
        }
      case 0xFA3C:
        {
          return [0x5C6E];
        }
      case 0xFA3D:
        {
          return [0x6094];
        }
      case 0xFA3E:
        {
          return [0x6168];
        }
      case 0xFA3F:
        {
          return [0x618E];
        }
      case 0xFA40:
        {
          return [0x61F2];
        }
      case 0xFA41:
        {
          return [0x654F];
        }
      case 0xFA42:
        {
          return [0x65E2];
        }
      case 0xFA43:
        {
          return [0x6691];
        }
      case 0xFA44:
        {
          return [0x6885];
        }
      case 0xFA45:
        {
          return [0x6D77];
        }
      case 0xFA46:
        {
          return [0x6E1A];
        }
      case 0xFA47:
        {
          return [0x6F22];
        }
      case 0xFA48:
        {
          return [0x716E];
        }
      case 0xFA49:
        {
          return [0x722B];
        }
      case 0xFA4A:
        {
          return [0x7422];
        }
      case 0xFA4B:
        {
          return [0x7891];
        }
      case 0xFA4C:
        {
          return [0x793E];
        }
      case 0xFA4D:
        {
          return [0x7949];
        }
      case 0xFA4E:
        {
          return [0x7948];
        }
      case 0xFA4F:
        {
          return [0x7950];
        }
      case 0xFA50:
        {
          return [0x7956];
        }
      case 0xFA51:
        {
          return [0x795D];
        }
      case 0xFA52:
        {
          return [0x798D];
        }
      case 0xFA53:
        {
          return [0x798E];
        }
      case 0xFA54:
        {
          return [0x7A40];
        }
      case 0xFA55:
        {
          return [0x7A81];
        }
      case 0xFA56:
        {
          return [0x7BC0];
        }
      case 0xFA57:
        {
          return [0x7DF4];
        }
      case 0xFA58:
        {
          return [0x7E09];
        }
      case 0xFA59:
        {
          return [0x7E41];
        }
      case 0xFA5A:
        {
          return [0x7F72];
        }
      case 0xFA5B:
        {
          return [0x8005];
        }
      case 0xFA5C:
        {
          return [0x81ED];
        }
      case 0xFA5D:
        {
          return [0x8279];
        }
      case 0xFA5E:
        {
          return [0x8279];
        }
      case 0xFA5F:
        {
          return [0x8457];
        }
      case 0xFA60:
        {
          return [0x8910];
        }
      case 0xFA61:
        {
          return [0x8996];
        }
      case 0xFA62:
        {
          return [0x8B01];
        }
      case 0xFA63:
        {
          return [0x8B39];
        }
      case 0xFA64:
        {
          return [0x8CD3];
        }
      case 0xFA65:
        {
          return [0x8D08];
        }
      case 0xFA66:
        {
          return [0x8FB6];
        }
      case 0xFA67:
        {
          return [0x9038];
        }
      case 0xFA68:
        {
          return [0x96E3];
        }
      case 0xFA69:
        {
          return [0x97FF];
        }
      case 0xFA6A:
        {
          return [0x983B];
        }
      case 0xFA70:
        {
          return [0x4E26];
        }
      case 0xFA71:
        {
          return [0x51B5];
        }
      case 0xFA72:
        {
          return [0x5168];
        }
      case 0xFA73:
        {
          return [0x4F80];
        }
      case 0xFA74:
        {
          return [0x5145];
        }
      case 0xFA75:
        {
          return [0x5180];
        }
      case 0xFA76:
        {
          return [0x52C7];
        }
      case 0xFA77:
        {
          return [0x52FA];
        }
      case 0xFA78:
        {
          return [0x559D];
        }
      case 0xFA79:
        {
          return [0x5555];
        }
      case 0xFA7A:
        {
          return [0x5599];
        }
      case 0xFA7B:
        {
          return [0x55E2];
        }
      case 0xFA7C:
        {
          return [0x585A];
        }
      case 0xFA7D:
        {
          return [0x58B3];
        }
      case 0xFA7E:
        {
          return [0x5944];
        }
      case 0xFA7F:
        {
          return [0x5954];
        }
      case 0xFA80:
        {
          return [0x5A62];
        }
      case 0xFA81:
        {
          return [0x5B28];
        }
      case 0xFA82:
        {
          return [0x5ED2];
        }
      case 0xFA83:
        {
          return [0x5ED9];
        }
      case 0xFA84:
        {
          return [0x5F69];
        }
      case 0xFA85:
        {
          return [0x5FAD];
        }
      case 0xFA86:
        {
          return [0x60D8];
        }
      case 0xFA87:
        {
          return [0x614E];
        }
      case 0xFA88:
        {
          return [0x6108];
        }
      case 0xFA89:
        {
          return [0x618E];
        }
      case 0xFA8A:
        {
          return [0x6160];
        }
      case 0xFA8B:
        {
          return [0x61F2];
        }
      case 0xFA8C:
        {
          return [0x6234];
        }
      case 0xFA8D:
        {
          return [0x63C4];
        }
      case 0xFA8E:
        {
          return [0x641C];
        }
      case 0xFA8F:
        {
          return [0x6452];
        }
      case 0xFA90:
        {
          return [0x6556];
        }
      case 0xFA91:
        {
          return [0x6674];
        }
      case 0xFA92:
        {
          return [0x6717];
        }
      case 0xFA93:
        {
          return [0x671B];
        }
      case 0xFA94:
        {
          return [0x6756];
        }
      case 0xFA95:
        {
          return [0x6B79];
        }
      case 0xFA96:
        {
          return [0x6BBA];
        }
      case 0xFA97:
        {
          return [0x6D41];
        }
      case 0xFA98:
        {
          return [0x6EDB];
        }
      case 0xFA99:
        {
          return [0x6ECB];
        }
      case 0xFA9A:
        {
          return [0x6F22];
        }
      case 0xFA9B:
        {
          return [0x701E];
        }
      case 0xFA9C:
        {
          return [0x716E];
        }
      case 0xFA9D:
        {
          return [0x77A7];
        }
      case 0xFA9E:
        {
          return [0x7235];
        }
      case 0xFA9F:
        {
          return [0x72AF];
        }
      case 0xFAA0:
        {
          return [0x732A];
        }
      case 0xFAA1:
        {
          return [0x7471];
        }
      case 0xFAA2:
        {
          return [0x7506];
        }
      case 0xFAA3:
        {
          return [0x753B];
        }
      case 0xFAA4:
        {
          return [0x761D];
        }
      case 0xFAA5:
        {
          return [0x761F];
        }
      case 0xFAA6:
        {
          return [0x76CA];
        }
      case 0xFAA7:
        {
          return [0x76DB];
        }
      case 0xFAA8:
        {
          return [0x76F4];
        }
      case 0xFAA9:
        {
          return [0x774A];
        }
      case 0xFAAA:
        {
          return [0x7740];
        }
      case 0xFAAB:
        {
          return [0x78CC];
        }
      case 0xFAAC:
        {
          return [0x7AB1];
        }
      case 0xFAAD:
        {
          return [0x7BC0];
        }
      case 0xFAAE:
        {
          return [0x7C7B];
        }
      case 0xFAAF:
        {
          return [0x7D5B];
        }
      case 0xFAB0:
        {
          return [0x7DF4];
        }
      case 0xFAB1:
        {
          return [0x7F3E];
        }
      case 0xFAB2:
        {
          return [0x8005];
        }
      case 0xFAB3:
        {
          return [0x8352];
        }
      case 0xFAB4:
        {
          return [0x83EF];
        }
      case 0xFAB5:
        {
          return [0x8779];
        }
      case 0xFAB6:
        {
          return [0x8941];
        }
      case 0xFAB7:
        {
          return [0x8986];
        }
      case 0xFAB8:
        {
          return [0x8996];
        }
      case 0xFAB9:
        {
          return [0x8ABF];
        }
      case 0xFABA:
        {
          return [0x8AF8];
        }
      case 0xFABB:
        {
          return [0x8ACB];
        }
      case 0xFABC:
        {
          return [0x8B01];
        }
      case 0xFABD:
        {
          return [0x8AFE];
        }
      case 0xFABE:
        {
          return [0x8AED];
        }
      case 0xFABF:
        {
          return [0x8B39];
        }
      case 0xFAC0:
        {
          return [0x8B8A];
        }
      case 0xFAC1:
        {
          return [0x8D08];
        }
      case 0xFAC2:
        {
          return [0x8F38];
        }
      case 0xFAC3:
        {
          return [0x9072];
        }
      case 0xFAC4:
        {
          return [0x9199];
        }
      case 0xFAC5:
        {
          return [0x9276];
        }
      case 0xFAC6:
        {
          return [0x967C];
        }
      case 0xFAC7:
        {
          return [0x96E3];
        }
      case 0xFAC8:
        {
          return [0x9756];
        }
      case 0xFAC9:
        {
          return [0x97DB];
        }
      case 0xFACA:
        {
          return [0x97FF];
        }
      case 0xFACB:
        {
          return [0x980B];
        }
      case 0xFACC:
        {
          return [0x983B];
        }
      case 0xFACD:
        {
          return [0x9B12];
        }
      case 0xFACE:
        {
          return [0x9F9C];
        }
      case 0xFACF:
        {
          return [0x2284A];
        }
      case 0xFAD0:
        {
          return [0x22844];
        }
      case 0xFAD1:
        {
          return [0x233D5];
        }
      case 0xFAD2:
        {
          return [0x3B9D];
        }
      case 0xFAD3:
        {
          return [0x4018];
        }
      case 0xFAD4:
        {
          return [0x4039];
        }
      case 0xFAD5:
        {
          return [0x25249];
        }
      case 0xFAD6:
        {
          return [0x25CD0];
        }
      case 0xFAD7:
        {
          return [0x27ED3];
        }
      case 0xFAD8:
        {
          return [0x9F43];
        }
      case 0xFAD9:
        {
          return [0x9F8E];
        }
      case 0xFB00:
        {
          return [0x0066, 0x0066];
        }
      case 0xFB01:
        {
          return [0x0066, 0x0069];
        }
      case 0xFB02:
        {
          return [0x0066, 0x006C];
        }
      case 0xFB03:
        {
          return [0x0066, 0x0066, 0x0069];
        }
      case 0xFB04:
        {
          return [0x0066, 0x0066, 0x006C];
        }
      case 0xFB05:
        {
          return [0x017F, 0x0074];
        }
      case 0xFB06:
        {
          return [0x0073, 0x0074];
        }
      case 0xFB13:
        {
          return [0x0574, 0x0576];
        }
      case 0xFB14:
        {
          return [0x0574, 0x0565];
        }
      case 0xFB15:
        {
          return [0x0574, 0x056B];
        }
      case 0xFB16:
        {
          return [0x057E, 0x0576];
        }
      case 0xFB17:
        {
          return [0x0574, 0x056D];
        }
      case 0xFB1D:
        {
          return [0x05D9, 0x05B4];
        }
      case 0xFB1F:
        {
          return [0x05F2, 0x05B7];
        }
      case 0xFB20:
        {
          return [0x05E2];
        }
      case 0xFB21:
        {
          return [0x05D0];
        }
      case 0xFB22:
        {
          return [0x05D3];
        }
      case 0xFB23:
        {
          return [0x05D4];
        }
      case 0xFB24:
        {
          return [0x05DB];
        }
      case 0xFB25:
        {
          return [0x05DC];
        }
      case 0xFB26:
        {
          return [0x05DD];
        }
      case 0xFB27:
        {
          return [0x05E8];
        }
      case 0xFB28:
        {
          return [0x05EA];
        }
      case 0xFB29:
        {
          return [0x002B];
        }
      case 0xFB2A:
        {
          return [0x05E9, 0x05C1];
        }
      case 0xFB2B:
        {
          return [0x05E9, 0x05C2];
        }
      case 0xFB2C:
        {
          return [0xFB49, 0x05C1];
        }
      case 0xFB2D:
        {
          return [0xFB49, 0x05C2];
        }
      case 0xFB2E:
        {
          return [0x05D0, 0x05B7];
        }
      case 0xFB2F:
        {
          return [0x05D0, 0x05B8];
        }
      case 0xFB30:
        {
          return [0x05D0, 0x05BC];
        }
      case 0xFB31:
        {
          return [0x05D1, 0x05BC];
        }
      case 0xFB32:
        {
          return [0x05D2, 0x05BC];
        }
      case 0xFB33:
        {
          return [0x05D3, 0x05BC];
        }
      case 0xFB34:
        {
          return [0x05D4, 0x05BC];
        }
      case 0xFB35:
        {
          return [0x05D5, 0x05BC];
        }
      case 0xFB36:
        {
          return [0x05D6, 0x05BC];
        }
      case 0xFB38:
        {
          return [0x05D8, 0x05BC];
        }
      case 0xFB39:
        {
          return [0x05D9, 0x05BC];
        }
      case 0xFB3A:
        {
          return [0x05DA, 0x05BC];
        }
      case 0xFB3B:
        {
          return [0x05DB, 0x05BC];
        }
      case 0xFB3C:
        {
          return [0x05DC, 0x05BC];
        }
      case 0xFB3E:
        {
          return [0x05DE, 0x05BC];
        }
      case 0xFB40:
        {
          return [0x05E0, 0x05BC];
        }
      case 0xFB41:
        {
          return [0x05E1, 0x05BC];
        }
      case 0xFB43:
        {
          return [0x05E3, 0x05BC];
        }
      case 0xFB44:
        {
          return [0x05E4, 0x05BC];
        }
      case 0xFB46:
        {
          return [0x05E6, 0x05BC];
        }
      case 0xFB47:
        {
          return [0x05E7, 0x05BC];
        }
      case 0xFB48:
        {
          return [0x05E8, 0x05BC];
        }
      case 0xFB49:
        {
          return [0x05E9, 0x05BC];
        }
      case 0xFB4A:
        {
          return [0x05EA, 0x05BC];
        }
      case 0xFB4B:
        {
          return [0x05D5, 0x05B9];
        }
      case 0xFB4C:
        {
          return [0x05D1, 0x05BF];
        }
      case 0xFB4D:
        {
          return [0x05DB, 0x05BF];
        }
      case 0xFB4E:
        {
          return [0x05E4, 0x05BF];
        }
      case 0xFB4F:
        {
          return [0x05D0, 0x05DC];
        }
      case 0xFB50:
        {
          return [0x0671];
        }
      case 0xFB51:
        {
          return [0x0671];
        }
      case 0xFB52:
        {
          return [0x067B];
        }
      case 0xFB53:
        {
          return [0x067B];
        }
      case 0xFB54:
        {
          return [0x067B];
        }
      case 0xFB55:
        {
          return [0x067B];
        }
      case 0xFB56:
        {
          return [0x067E];
        }
      case 0xFB57:
        {
          return [0x067E];
        }
      case 0xFB58:
        {
          return [0x067E];
        }
      case 0xFB59:
        {
          return [0x067E];
        }
      case 0xFB5A:
        {
          return [0x0680];
        }
      case 0xFB5B:
        {
          return [0x0680];
        }
      case 0xFB5C:
        {
          return [0x0680];
        }
      case 0xFB5D:
        {
          return [0x0680];
        }
      case 0xFB5E:
        {
          return [0x067A];
        }
      case 0xFB5F:
        {
          return [0x067A];
        }
      case 0xFB60:
        {
          return [0x067A];
        }
      case 0xFB61:
        {
          return [0x067A];
        }
      case 0xFB62:
        {
          return [0x067F];
        }
      case 0xFB63:
        {
          return [0x067F];
        }
      case 0xFB64:
        {
          return [0x067F];
        }
      case 0xFB65:
        {
          return [0x067F];
        }
      case 0xFB66:
        {
          return [0x0679];
        }
      case 0xFB67:
        {
          return [0x0679];
        }
      case 0xFB68:
        {
          return [0x0679];
        }
      case 0xFB69:
        {
          return [0x0679];
        }
      case 0xFB6A:
        {
          return [0x06A4];
        }
      case 0xFB6B:
        {
          return [0x06A4];
        }
      case 0xFB6C:
        {
          return [0x06A4];
        }
      case 0xFB6D:
        {
          return [0x06A4];
        }
      case 0xFB6E:
        {
          return [0x06A6];
        }
      case 0xFB6F:
        {
          return [0x06A6];
        }
      case 0xFB70:
        {
          return [0x06A6];
        }
      case 0xFB71:
        {
          return [0x06A6];
        }
      case 0xFB72:
        {
          return [0x0684];
        }
      case 0xFB73:
        {
          return [0x0684];
        }
      case 0xFB74:
        {
          return [0x0684];
        }
      case 0xFB75:
        {
          return [0x0684];
        }
      case 0xFB76:
        {
          return [0x0683];
        }
      case 0xFB77:
        {
          return [0x0683];
        }
      case 0xFB78:
        {
          return [0x0683];
        }
      case 0xFB79:
        {
          return [0x0683];
        }
      case 0xFB7A:
        {
          return [0x0686];
        }
      case 0xFB7B:
        {
          return [0x0686];
        }
      case 0xFB7C:
        {
          return [0x0686];
        }
      case 0xFB7D:
        {
          return [0x0686];
        }
      case 0xFB7E:
        {
          return [0x0687];
        }
      case 0xFB7F:
        {
          return [0x0687];
        }
      case 0xFB80:
        {
          return [0x0687];
        }
      case 0xFB81:
        {
          return [0x0687];
        }
      case 0xFB82:
        {
          return [0x068D];
        }
      case 0xFB83:
        {
          return [0x068D];
        }
      case 0xFB84:
        {
          return [0x068C];
        }
      case 0xFB85:
        {
          return [0x068C];
        }
      case 0xFB86:
        {
          return [0x068E];
        }
      case 0xFB87:
        {
          return [0x068E];
        }
      case 0xFB88:
        {
          return [0x0688];
        }
      case 0xFB89:
        {
          return [0x0688];
        }
      case 0xFB8A:
        {
          return [0x0698];
        }
      case 0xFB8B:
        {
          return [0x0698];
        }
      case 0xFB8C:
        {
          return [0x0691];
        }
      case 0xFB8D:
        {
          return [0x0691];
        }
      case 0xFB8E:
        {
          return [0x06A9];
        }
      case 0xFB8F:
        {
          return [0x06A9];
        }
      case 0xFB90:
        {
          return [0x06A9];
        }
      case 0xFB91:
        {
          return [0x06A9];
        }
      case 0xFB92:
        {
          return [0x06AF];
        }
      case 0xFB93:
        {
          return [0x06AF];
        }
      case 0xFB94:
        {
          return [0x06AF];
        }
      case 0xFB95:
        {
          return [0x06AF];
        }
      case 0xFB96:
        {
          return [0x06B3];
        }
      case 0xFB97:
        {
          return [0x06B3];
        }
      case 0xFB98:
        {
          return [0x06B3];
        }
      case 0xFB99:
        {
          return [0x06B3];
        }
      case 0xFB9A:
        {
          return [0x06B1];
        }
      case 0xFB9B:
        {
          return [0x06B1];
        }
      case 0xFB9C:
        {
          return [0x06B1];
        }
      case 0xFB9D:
        {
          return [0x06B1];
        }
      case 0xFB9E:
        {
          return [0x06BA];
        }
      case 0xFB9F:
        {
          return [0x06BA];
        }
      case 0xFBA0:
        {
          return [0x06BB];
        }
      case 0xFBA1:
        {
          return [0x06BB];
        }
      case 0xFBA2:
        {
          return [0x06BB];
        }
      case 0xFBA3:
        {
          return [0x06BB];
        }
      case 0xFBA4:
        {
          return [0x06C0];
        }
      case 0xFBA5:
        {
          return [0x06C0];
        }
      case 0xFBA6:
        {
          return [0x06C1];
        }
      case 0xFBA7:
        {
          return [0x06C1];
        }
      case 0xFBA8:
        {
          return [0x06C1];
        }
      case 0xFBA9:
        {
          return [0x06C1];
        }
      case 0xFBAA:
        {
          return [0x06BE];
        }
      case 0xFBAB:
        {
          return [0x06BE];
        }
      case 0xFBAC:
        {
          return [0x06BE];
        }
      case 0xFBAD:
        {
          return [0x06BE];
        }
      case 0xFBAE:
        {
          return [0x06D2];
        }
      case 0xFBAF:
        {
          return [0x06D2];
        }
      case 0xFBB0:
        {
          return [0x06D3];
        }
      case 0xFBB1:
        {
          return [0x06D3];
        }
      case 0xFBD3:
        {
          return [0x06AD];
        }
      case 0xFBD4:
        {
          return [0x06AD];
        }
      case 0xFBD5:
        {
          return [0x06AD];
        }
      case 0xFBD6:
        {
          return [0x06AD];
        }
      case 0xFBD7:
        {
          return [0x06C7];
        }
      case 0xFBD8:
        {
          return [0x06C7];
        }
      case 0xFBD9:
        {
          return [0x06C6];
        }
      case 0xFBDA:
        {
          return [0x06C6];
        }
      case 0xFBDB:
        {
          return [0x06C8];
        }
      case 0xFBDC:
        {
          return [0x06C8];
        }
      case 0xFBDD:
        {
          return [0x0677];
        }
      case 0xFBDE:
        {
          return [0x06CB];
        }
      case 0xFBDF:
        {
          return [0x06CB];
        }
      case 0xFBE0:
        {
          return [0x06C5];
        }
      case 0xFBE1:
        {
          return [0x06C5];
        }
      case 0xFBE2:
        {
          return [0x06C9];
        }
      case 0xFBE3:
        {
          return [0x06C9];
        }
      case 0xFBE4:
        {
          return [0x06D0];
        }
      case 0xFBE5:
        {
          return [0x06D0];
        }
      case 0xFBE6:
        {
          return [0x06D0];
        }
      case 0xFBE7:
        {
          return [0x06D0];
        }
      case 0xFBE8:
        {
          return [0x0649];
        }
      case 0xFBE9:
        {
          return [0x0649];
        }
      case 0xFBEA:
        {
          return [0x0626, 0x0627];
        }
      case 0xFBEB:
        {
          return [0x0626, 0x0627];
        }
      case 0xFBEC:
        {
          return [0x0626, 0x06D5];
        }
      case 0xFBED:
        {
          return [0x0626, 0x06D5];
        }
      case 0xFBEE:
        {
          return [0x0626, 0x0648];
        }
      case 0xFBEF:
        {
          return [0x0626, 0x0648];
        }
      case 0xFBF0:
        {
          return [0x0626, 0x06C7];
        }
      case 0xFBF1:
        {
          return [0x0626, 0x06C7];
        }
      case 0xFBF2:
        {
          return [0x0626, 0x06C6];
        }
      case 0xFBF3:
        {
          return [0x0626, 0x06C6];
        }
      case 0xFBF4:
        {
          return [0x0626, 0x06C8];
        }
      case 0xFBF5:
        {
          return [0x0626, 0x06C8];
        }
      case 0xFBF6:
        {
          return [0x0626, 0x06D0];
        }
      case 0xFBF7:
        {
          return [0x0626, 0x06D0];
        }
      case 0xFBF8:
        {
          return [0x0626, 0x06D0];
        }
      case 0xFBF9:
        {
          return [0x0626, 0x0649];
        }
      case 0xFBFA:
        {
          return [0x0626, 0x0649];
        }
      case 0xFBFB:
        {
          return [0x0626, 0x0649];
        }
      case 0xFBFC:
        {
          return [0x06CC];
        }
      case 0xFBFD:
        {
          return [0x06CC];
        }
      case 0xFBFE:
        {
          return [0x06CC];
        }
      case 0xFBFF:
        {
          return [0x06CC];
        }
      case 0xFC00:
        {
          return [0x0626, 0x062C];
        }
      case 0xFC01:
        {
          return [0x0626, 0x062D];
        }
      case 0xFC02:
        {
          return [0x0626, 0x0645];
        }
      case 0xFC03:
        {
          return [0x0626, 0x0649];
        }
      case 0xFC04:
        {
          return [0x0626, 0x064A];
        }
      case 0xFC05:
        {
          return [0x0628, 0x062C];
        }
      case 0xFC06:
        {
          return [0x0628, 0x062D];
        }
      case 0xFC07:
        {
          return [0x0628, 0x062E];
        }
      case 0xFC08:
        {
          return [0x0628, 0x0645];
        }
      case 0xFC09:
        {
          return [0x0628, 0x0649];
        }
      case 0xFC0A:
        {
          return [0x0628, 0x064A];
        }
      case 0xFC0B:
        {
          return [0x062A, 0x062C];
        }
      case 0xFC0C:
        {
          return [0x062A, 0x062D];
        }
      case 0xFC0D:
        {
          return [0x062A, 0x062E];
        }
      case 0xFC0E:
        {
          return [0x062A, 0x0645];
        }
      case 0xFC0F:
        {
          return [0x062A, 0x0649];
        }
      case 0xFC10:
        {
          return [0x062A, 0x064A];
        }
      case 0xFC11:
        {
          return [0x062B, 0x062C];
        }
      case 0xFC12:
        {
          return [0x062B, 0x0645];
        }
      case 0xFC13:
        {
          return [0x062B, 0x0649];
        }
      case 0xFC14:
        {
          return [0x062B, 0x064A];
        }
      case 0xFC15:
        {
          return [0x062C, 0x062D];
        }
      case 0xFC16:
        {
          return [0x062C, 0x0645];
        }
      case 0xFC17:
        {
          return [0x062D, 0x062C];
        }
      case 0xFC18:
        {
          return [0x062D, 0x0645];
        }
      case 0xFC19:
        {
          return [0x062E, 0x062C];
        }
      case 0xFC1A:
        {
          return [0x062E, 0x062D];
        }
      case 0xFC1B:
        {
          return [0x062E, 0x0645];
        }
      case 0xFC1C:
        {
          return [0x0633, 0x062C];
        }
      case 0xFC1D:
        {
          return [0x0633, 0x062D];
        }
      case 0xFC1E:
        {
          return [0x0633, 0x062E];
        }
      case 0xFC1F:
        {
          return [0x0633, 0x0645];
        }
      case 0xFC20:
        {
          return [0x0635, 0x062D];
        }
      case 0xFC21:
        {
          return [0x0635, 0x0645];
        }
      case 0xFC22:
        {
          return [0x0636, 0x062C];
        }
      case 0xFC23:
        {
          return [0x0636, 0x062D];
        }
      case 0xFC24:
        {
          return [0x0636, 0x062E];
        }
      case 0xFC25:
        {
          return [0x0636, 0x0645];
        }
      case 0xFC26:
        {
          return [0x0637, 0x062D];
        }
      case 0xFC27:
        {
          return [0x0637, 0x0645];
        }
      case 0xFC28:
        {
          return [0x0638, 0x0645];
        }
      case 0xFC29:
        {
          return [0x0639, 0x062C];
        }
      case 0xFC2A:
        {
          return [0x0639, 0x0645];
        }
      case 0xFC2B:
        {
          return [0x063A, 0x062C];
        }
      case 0xFC2C:
        {
          return [0x063A, 0x0645];
        }
      case 0xFC2D:
        {
          return [0x0641, 0x062C];
        }
      case 0xFC2E:
        {
          return [0x0641, 0x062D];
        }
      case 0xFC2F:
        {
          return [0x0641, 0x062E];
        }
      case 0xFC30:
        {
          return [0x0641, 0x0645];
        }
      case 0xFC31:
        {
          return [0x0641, 0x0649];
        }
      case 0xFC32:
        {
          return [0x0641, 0x064A];
        }
      case 0xFC33:
        {
          return [0x0642, 0x062D];
        }
      case 0xFC34:
        {
          return [0x0642, 0x0645];
        }
      case 0xFC35:
        {
          return [0x0642, 0x0649];
        }
      case 0xFC36:
        {
          return [0x0642, 0x064A];
        }
      case 0xFC37:
        {
          return [0x0643, 0x0627];
        }
      case 0xFC38:
        {
          return [0x0643, 0x062C];
        }
      case 0xFC39:
        {
          return [0x0643, 0x062D];
        }
      case 0xFC3A:
        {
          return [0x0643, 0x062E];
        }
      case 0xFC3B:
        {
          return [0x0643, 0x0644];
        }
      case 0xFC3C:
        {
          return [0x0643, 0x0645];
        }
      case 0xFC3D:
        {
          return [0x0643, 0x0649];
        }
      case 0xFC3E:
        {
          return [0x0643, 0x064A];
        }
      case 0xFC3F:
        {
          return [0x0644, 0x062C];
        }
      case 0xFC40:
        {
          return [0x0644, 0x062D];
        }
      case 0xFC41:
        {
          return [0x0644, 0x062E];
        }
      case 0xFC42:
        {
          return [0x0644, 0x0645];
        }
      case 0xFC43:
        {
          return [0x0644, 0x0649];
        }
      case 0xFC44:
        {
          return [0x0644, 0x064A];
        }
      case 0xFC45:
        {
          return [0x0645, 0x062C];
        }
      case 0xFC46:
        {
          return [0x0645, 0x062D];
        }
      case 0xFC47:
        {
          return [0x0645, 0x062E];
        }
      case 0xFC48:
        {
          return [0x0645, 0x0645];
        }
      case 0xFC49:
        {
          return [0x0645, 0x0649];
        }
      case 0xFC4A:
        {
          return [0x0645, 0x064A];
        }
      case 0xFC4B:
        {
          return [0x0646, 0x062C];
        }
      case 0xFC4C:
        {
          return [0x0646, 0x062D];
        }
      case 0xFC4D:
        {
          return [0x0646, 0x062E];
        }
      case 0xFC4E:
        {
          return [0x0646, 0x0645];
        }
      case 0xFC4F:
        {
          return [0x0646, 0x0649];
        }
      case 0xFC50:
        {
          return [0x0646, 0x064A];
        }
      case 0xFC51:
        {
          return [0x0647, 0x062C];
        }
      case 0xFC52:
        {
          return [0x0647, 0x0645];
        }
      case 0xFC53:
        {
          return [0x0647, 0x0649];
        }
      case 0xFC54:
        {
          return [0x0647, 0x064A];
        }
      case 0xFC55:
        {
          return [0x064A, 0x062C];
        }
      case 0xFC56:
        {
          return [0x064A, 0x062D];
        }
      case 0xFC57:
        {
          return [0x064A, 0x062E];
        }
      case 0xFC58:
        {
          return [0x064A, 0x0645];
        }
      case 0xFC59:
        {
          return [0x064A, 0x0649];
        }
      case 0xFC5A:
        {
          return [0x064A, 0x064A];
        }
      case 0xFC5B:
        {
          return [0x0630, 0x0670];
        }
      case 0xFC5C:
        {
          return [0x0631, 0x0670];
        }
      case 0xFC5D:
        {
          return [0x0649, 0x0670];
        }
      case 0xFC5E:
        {
          return [0x0020, 0x064C, 0x0651];
        }
      case 0xFC5F:
        {
          return [0x0020, 0x064D, 0x0651];
        }
      case 0xFC60:
        {
          return [0x0020, 0x064E, 0x0651];
        }
      case 0xFC61:
        {
          return [0x0020, 0x064F, 0x0651];
        }
      case 0xFC62:
        {
          return [0x0020, 0x0650, 0x0651];
        }
      case 0xFC63:
        {
          return [0x0020, 0x0651, 0x0670];
        }
      case 0xFC64:
        {
          return [0x0626, 0x0631];
        }
      case 0xFC65:
        {
          return [0x0626, 0x0632];
        }
      case 0xFC66:
        {
          return [0x0626, 0x0645];
        }
      case 0xFC67:
        {
          return [0x0626, 0x0646];
        }
      case 0xFC68:
        {
          return [0x0626, 0x0649];
        }
      case 0xFC69:
        {
          return [0x0626, 0x064A];
        }
      case 0xFC6A:
        {
          return [0x0628, 0x0631];
        }
      case 0xFC6B:
        {
          return [0x0628, 0x0632];
        }
      case 0xFC6C:
        {
          return [0x0628, 0x0645];
        }
      case 0xFC6D:
        {
          return [0x0628, 0x0646];
        }
      case 0xFC6E:
        {
          return [0x0628, 0x0649];
        }
      case 0xFC6F:
        {
          return [0x0628, 0x064A];
        }
      case 0xFC70:
        {
          return [0x062A, 0x0631];
        }
      case 0xFC71:
        {
          return [0x062A, 0x0632];
        }
      case 0xFC72:
        {
          return [0x062A, 0x0645];
        }
      case 0xFC73:
        {
          return [0x062A, 0x0646];
        }
      case 0xFC74:
        {
          return [0x062A, 0x0649];
        }
      case 0xFC75:
        {
          return [0x062A, 0x064A];
        }
      case 0xFC76:
        {
          return [0x062B, 0x0631];
        }
      case 0xFC77:
        {
          return [0x062B, 0x0632];
        }
      case 0xFC78:
        {
          return [0x062B, 0x0645];
        }
      case 0xFC79:
        {
          return [0x062B, 0x0646];
        }
      case 0xFC7A:
        {
          return [0x062B, 0x0649];
        }
      case 0xFC7B:
        {
          return [0x062B, 0x064A];
        }
      case 0xFC7C:
        {
          return [0x0641, 0x0649];
        }
      case 0xFC7D:
        {
          return [0x0641, 0x064A];
        }
      case 0xFC7E:
        {
          return [0x0642, 0x0649];
        }
      case 0xFC7F:
        {
          return [0x0642, 0x064A];
        }
      case 0xFC80:
        {
          return [0x0643, 0x0627];
        }
      case 0xFC81:
        {
          return [0x0643, 0x0644];
        }
      case 0xFC82:
        {
          return [0x0643, 0x0645];
        }
      case 0xFC83:
        {
          return [0x0643, 0x0649];
        }
      case 0xFC84:
        {
          return [0x0643, 0x064A];
        }
      case 0xFC85:
        {
          return [0x0644, 0x0645];
        }
      case 0xFC86:
        {
          return [0x0644, 0x0649];
        }
      case 0xFC87:
        {
          return [0x0644, 0x064A];
        }
      case 0xFC88:
        {
          return [0x0645, 0x0627];
        }
      case 0xFC89:
        {
          return [0x0645, 0x0645];
        }
      case 0xFC8A:
        {
          return [0x0646, 0x0631];
        }
      case 0xFC8B:
        {
          return [0x0646, 0x0632];
        }
      case 0xFC8C:
        {
          return [0x0646, 0x0645];
        }
      case 0xFC8D:
        {
          return [0x0646, 0x0646];
        }
      case 0xFC8E:
        {
          return [0x0646, 0x0649];
        }
      case 0xFC8F:
        {
          return [0x0646, 0x064A];
        }
      case 0xFC90:
        {
          return [0x0649, 0x0670];
        }
      case 0xFC91:
        {
          return [0x064A, 0x0631];
        }
      case 0xFC92:
        {
          return [0x064A, 0x0632];
        }
      case 0xFC93:
        {
          return [0x064A, 0x0645];
        }
      case 0xFC94:
        {
          return [0x064A, 0x0646];
        }
      case 0xFC95:
        {
          return [0x064A, 0x0649];
        }
      case 0xFC96:
        {
          return [0x064A, 0x064A];
        }
      case 0xFC97:
        {
          return [0x0626, 0x062C];
        }
      case 0xFC98:
        {
          return [0x0626, 0x062D];
        }
      case 0xFC99:
        {
          return [0x0626, 0x062E];
        }
      case 0xFC9A:
        {
          return [0x0626, 0x0645];
        }
      case 0xFC9B:
        {
          return [0x0626, 0x0647];
        }
      case 0xFC9C:
        {
          return [0x0628, 0x062C];
        }
      case 0xFC9D:
        {
          return [0x0628, 0x062D];
        }
      case 0xFC9E:
        {
          return [0x0628, 0x062E];
        }
      case 0xFC9F:
        {
          return [0x0628, 0x0645];
        }
      case 0xFCA0:
        {
          return [0x0628, 0x0647];
        }
      case 0xFCA1:
        {
          return [0x062A, 0x062C];
        }
      case 0xFCA2:
        {
          return [0x062A, 0x062D];
        }
      case 0xFCA3:
        {
          return [0x062A, 0x062E];
        }
      case 0xFCA4:
        {
          return [0x062A, 0x0645];
        }
      case 0xFCA5:
        {
          return [0x062A, 0x0647];
        }
      case 0xFCA6:
        {
          return [0x062B, 0x0645];
        }
      case 0xFCA7:
        {
          return [0x062C, 0x062D];
        }
      case 0xFCA8:
        {
          return [0x062C, 0x0645];
        }
      case 0xFCA9:
        {
          return [0x062D, 0x062C];
        }
      case 0xFCAA:
        {
          return [0x062D, 0x0645];
        }
      case 0xFCAB:
        {
          return [0x062E, 0x062C];
        }
      case 0xFCAC:
        {
          return [0x062E, 0x0645];
        }
      case 0xFCAD:
        {
          return [0x0633, 0x062C];
        }
      case 0xFCAE:
        {
          return [0x0633, 0x062D];
        }
      case 0xFCAF:
        {
          return [0x0633, 0x062E];
        }
      case 0xFCB0:
        {
          return [0x0633, 0x0645];
        }
      case 0xFCB1:
        {
          return [0x0635, 0x062D];
        }
      case 0xFCB2:
        {
          return [0x0635, 0x062E];
        }
      case 0xFCB3:
        {
          return [0x0635, 0x0645];
        }
      case 0xFCB4:
        {
          return [0x0636, 0x062C];
        }
      case 0xFCB5:
        {
          return [0x0636, 0x062D];
        }
      case 0xFCB6:
        {
          return [0x0636, 0x062E];
        }
      case 0xFCB7:
        {
          return [0x0636, 0x0645];
        }
      case 0xFCB8:
        {
          return [0x0637, 0x062D];
        }
      case 0xFCB9:
        {
          return [0x0638, 0x0645];
        }
      case 0xFCBA:
        {
          return [0x0639, 0x062C];
        }
      case 0xFCBB:
        {
          return [0x0639, 0x0645];
        }
      case 0xFCBC:
        {
          return [0x063A, 0x062C];
        }
      case 0xFCBD:
        {
          return [0x063A, 0x0645];
        }
      case 0xFCBE:
        {
          return [0x0641, 0x062C];
        }
      case 0xFCBF:
        {
          return [0x0641, 0x062D];
        }
      case 0xFCC0:
        {
          return [0x0641, 0x062E];
        }
      case 0xFCC1:
        {
          return [0x0641, 0x0645];
        }
      case 0xFCC2:
        {
          return [0x0642, 0x062D];
        }
      case 0xFCC3:
        {
          return [0x0642, 0x0645];
        }
      case 0xFCC4:
        {
          return [0x0643, 0x062C];
        }
      case 0xFCC5:
        {
          return [0x0643, 0x062D];
        }
      case 0xFCC6:
        {
          return [0x0643, 0x062E];
        }
      case 0xFCC7:
        {
          return [0x0643, 0x0644];
        }
      case 0xFCC8:
        {
          return [0x0643, 0x0645];
        }
      case 0xFCC9:
        {
          return [0x0644, 0x062C];
        }
      case 0xFCCA:
        {
          return [0x0644, 0x062D];
        }
      case 0xFCCB:
        {
          return [0x0644, 0x062E];
        }
      case 0xFCCC:
        {
          return [0x0644, 0x0645];
        }
      case 0xFCCD:
        {
          return [0x0644, 0x0647];
        }
      case 0xFCCE:
        {
          return [0x0645, 0x062C];
        }
      case 0xFCCF:
        {
          return [0x0645, 0x062D];
        }
      case 0xFCD0:
        {
          return [0x0645, 0x062E];
        }
      case 0xFCD1:
        {
          return [0x0645, 0x0645];
        }
      case 0xFCD2:
        {
          return [0x0646, 0x062C];
        }
      case 0xFCD3:
        {
          return [0x0646, 0x062D];
        }
      case 0xFCD4:
        {
          return [0x0646, 0x062E];
        }
      case 0xFCD5:
        {
          return [0x0646, 0x0645];
        }
      case 0xFCD6:
        {
          return [0x0646, 0x0647];
        }
      case 0xFCD7:
        {
          return [0x0647, 0x062C];
        }
      case 0xFCD8:
        {
          return [0x0647, 0x0645];
        }
      case 0xFCD9:
        {
          return [0x0647, 0x0670];
        }
      case 0xFCDA:
        {
          return [0x064A, 0x062C];
        }
      case 0xFCDB:
        {
          return [0x064A, 0x062D];
        }
      case 0xFCDC:
        {
          return [0x064A, 0x062E];
        }
      case 0xFCDD:
        {
          return [0x064A, 0x0645];
        }
      case 0xFCDE:
        {
          return [0x064A, 0x0647];
        }
      case 0xFCDF:
        {
          return [0x0626, 0x0645];
        }
      case 0xFCE0:
        {
          return [0x0626, 0x0647];
        }
      case 0xFCE1:
        {
          return [0x0628, 0x0645];
        }
      case 0xFCE2:
        {
          return [0x0628, 0x0647];
        }
      case 0xFCE3:
        {
          return [0x062A, 0x0645];
        }
      case 0xFCE4:
        {
          return [0x062A, 0x0647];
        }
      case 0xFCE5:
        {
          return [0x062B, 0x0645];
        }
      case 0xFCE6:
        {
          return [0x062B, 0x0647];
        }
      case 0xFCE7:
        {
          return [0x0633, 0x0645];
        }
      case 0xFCE8:
        {
          return [0x0633, 0x0647];
        }
      case 0xFCE9:
        {
          return [0x0634, 0x0645];
        }
      case 0xFCEA:
        {
          return [0x0634, 0x0647];
        }
      case 0xFCEB:
        {
          return [0x0643, 0x0644];
        }
      case 0xFCEC:
        {
          return [0x0643, 0x0645];
        }
      case 0xFCED:
        {
          return [0x0644, 0x0645];
        }
      case 0xFCEE:
        {
          return [0x0646, 0x0645];
        }
      case 0xFCEF:
        {
          return [0x0646, 0x0647];
        }
      case 0xFCF0:
        {
          return [0x064A, 0x0645];
        }
      case 0xFCF1:
        {
          return [0x064A, 0x0647];
        }
      case 0xFCF2:
        {
          return [0x0640, 0x064E, 0x0651];
        }
      case 0xFCF3:
        {
          return [0x0640, 0x064F, 0x0651];
        }
      case 0xFCF4:
        {
          return [0x0640, 0x0650, 0x0651];
        }
      case 0xFCF5:
        {
          return [0x0637, 0x0649];
        }
      case 0xFCF6:
        {
          return [0x0637, 0x064A];
        }
      case 0xFCF7:
        {
          return [0x0639, 0x0649];
        }
      case 0xFCF8:
        {
          return [0x0639, 0x064A];
        }
      case 0xFCF9:
        {
          return [0x063A, 0x0649];
        }
      case 0xFCFA:
        {
          return [0x063A, 0x064A];
        }
      case 0xFCFB:
        {
          return [0x0633, 0x0649];
        }
      case 0xFCFC:
        {
          return [0x0633, 0x064A];
        }
      case 0xFCFD:
        {
          return [0x0634, 0x0649];
        }
      case 0xFCFE:
        {
          return [0x0634, 0x064A];
        }
      case 0xFCFF:
        {
          return [0x062D, 0x0649];
        }
      case 0xFD00:
        {
          return [0x062D, 0x064A];
        }
      case 0xFD01:
        {
          return [0x062C, 0x0649];
        }
      case 0xFD02:
        {
          return [0x062C, 0x064A];
        }
      case 0xFD03:
        {
          return [0x062E, 0x0649];
        }
      case 0xFD04:
        {
          return [0x062E, 0x064A];
        }
      case 0xFD05:
        {
          return [0x0635, 0x0649];
        }
      case 0xFD06:
        {
          return [0x0635, 0x064A];
        }
      case 0xFD07:
        {
          return [0x0636, 0x0649];
        }
      case 0xFD08:
        {
          return [0x0636, 0x064A];
        }
      case 0xFD09:
        {
          return [0x0634, 0x062C];
        }
      case 0xFD0A:
        {
          return [0x0634, 0x062D];
        }
      case 0xFD0B:
        {
          return [0x0634, 0x062E];
        }
      case 0xFD0C:
        {
          return [0x0634, 0x0645];
        }
      case 0xFD0D:
        {
          return [0x0634, 0x0631];
        }
      case 0xFD0E:
        {
          return [0x0633, 0x0631];
        }
      case 0xFD0F:
        {
          return [0x0635, 0x0631];
        }
      case 0xFD10:
        {
          return [0x0636, 0x0631];
        }
      case 0xFD11:
        {
          return [0x0637, 0x0649];
        }
      case 0xFD12:
        {
          return [0x0637, 0x064A];
        }
      case 0xFD13:
        {
          return [0x0639, 0x0649];
        }
      case 0xFD14:
        {
          return [0x0639, 0x064A];
        }
      case 0xFD15:
        {
          return [0x063A, 0x0649];
        }
      case 0xFD16:
        {
          return [0x063A, 0x064A];
        }
      case 0xFD17:
        {
          return [0x0633, 0x0649];
        }
      case 0xFD18:
        {
          return [0x0633, 0x064A];
        }
      case 0xFD19:
        {
          return [0x0634, 0x0649];
        }
      case 0xFD1A:
        {
          return [0x0634, 0x064A];
        }
      case 0xFD1B:
        {
          return [0x062D, 0x0649];
        }
      case 0xFD1C:
        {
          return [0x062D, 0x064A];
        }
      case 0xFD1D:
        {
          return [0x062C, 0x0649];
        }
      case 0xFD1E:
        {
          return [0x062C, 0x064A];
        }
      case 0xFD1F:
        {
          return [0x062E, 0x0649];
        }
      case 0xFD20:
        {
          return [0x062E, 0x064A];
        }
      case 0xFD21:
        {
          return [0x0635, 0x0649];
        }
      case 0xFD22:
        {
          return [0x0635, 0x064A];
        }
      case 0xFD23:
        {
          return [0x0636, 0x0649];
        }
      case 0xFD24:
        {
          return [0x0636, 0x064A];
        }
      case 0xFD25:
        {
          return [0x0634, 0x062C];
        }
      case 0xFD26:
        {
          return [0x0634, 0x062D];
        }
      case 0xFD27:
        {
          return [0x0634, 0x062E];
        }
      case 0xFD28:
        {
          return [0x0634, 0x0645];
        }
      case 0xFD29:
        {
          return [0x0634, 0x0631];
        }
      case 0xFD2A:
        {
          return [0x0633, 0x0631];
        }
      case 0xFD2B:
        {
          return [0x0635, 0x0631];
        }
      case 0xFD2C:
        {
          return [0x0636, 0x0631];
        }
      case 0xFD2D:
        {
          return [0x0634, 0x062C];
        }
      case 0xFD2E:
        {
          return [0x0634, 0x062D];
        }
      case 0xFD2F:
        {
          return [0x0634, 0x062E];
        }
      case 0xFD30:
        {
          return [0x0634, 0x0645];
        }
      case 0xFD31:
        {
          return [0x0633, 0x0647];
        }
      case 0xFD32:
        {
          return [0x0634, 0x0647];
        }
      case 0xFD33:
        {
          return [0x0637, 0x0645];
        }
      case 0xFD34:
        {
          return [0x0633, 0x062C];
        }
      case 0xFD35:
        {
          return [0x0633, 0x062D];
        }
      case 0xFD36:
        {
          return [0x0633, 0x062E];
        }
      case 0xFD37:
        {
          return [0x0634, 0x062C];
        }
      case 0xFD38:
        {
          return [0x0634, 0x062D];
        }
      case 0xFD39:
        {
          return [0x0634, 0x062E];
        }
      case 0xFD3A:
        {
          return [0x0637, 0x0645];
        }
      case 0xFD3B:
        {
          return [0x0638, 0x0645];
        }
      case 0xFD3C:
        {
          return [0x0627, 0x064B];
        }
      case 0xFD3D:
        {
          return [0x0627, 0x064B];
        }
      case 0xFD50:
        {
          return [0x062A, 0x062C, 0x0645];
        }
      case 0xFD51:
        {
          return [0x062A, 0x062D, 0x062C];
        }
      case 0xFD52:
        {
          return [0x062A, 0x062D, 0x062C];
        }
      case 0xFD53:
        {
          return [0x062A, 0x062D, 0x0645];
        }
      case 0xFD54:
        {
          return [0x062A, 0x062E, 0x0645];
        }
      case 0xFD55:
        {
          return [0x062A, 0x0645, 0x062C];
        }
      case 0xFD56:
        {
          return [0x062A, 0x0645, 0x062D];
        }
      case 0xFD57:
        {
          return [0x062A, 0x0645, 0x062E];
        }
      case 0xFD58:
        {
          return [0x062C, 0x0645, 0x062D];
        }
      case 0xFD59:
        {
          return [0x062C, 0x0645, 0x062D];
        }
      case 0xFD5A:
        {
          return [0x062D, 0x0645, 0x064A];
        }
      case 0xFD5B:
        {
          return [0x062D, 0x0645, 0x0649];
        }
      case 0xFD5C:
        {
          return [0x0633, 0x062D, 0x062C];
        }
      case 0xFD5D:
        {
          return [0x0633, 0x062C, 0x062D];
        }
      case 0xFD5E:
        {
          return [0x0633, 0x062C, 0x0649];
        }
      case 0xFD5F:
        {
          return [0x0633, 0x0645, 0x062D];
        }
      case 0xFD60:
        {
          return [0x0633, 0x0645, 0x062D];
        }
      case 0xFD61:
        {
          return [0x0633, 0x0645, 0x062C];
        }
      case 0xFD62:
        {
          return [0x0633, 0x0645, 0x0645];
        }
      case 0xFD63:
        {
          return [0x0633, 0x0645, 0x0645];
        }
      case 0xFD64:
        {
          return [0x0635, 0x062D, 0x062D];
        }
      case 0xFD65:
        {
          return [0x0635, 0x062D, 0x062D];
        }
      case 0xFD66:
        {
          return [0x0635, 0x0645, 0x0645];
        }
      case 0xFD67:
        {
          return [0x0634, 0x062D, 0x0645];
        }
      case 0xFD68:
        {
          return [0x0634, 0x062D, 0x0645];
        }
      case 0xFD69:
        {
          return [0x0634, 0x062C, 0x064A];
        }
      case 0xFD6A:
        {
          return [0x0634, 0x0645, 0x062E];
        }
      case 0xFD6B:
        {
          return [0x0634, 0x0645, 0x062E];
        }
      case 0xFD6C:
        {
          return [0x0634, 0x0645, 0x0645];
        }
      case 0xFD6D:
        {
          return [0x0634, 0x0645, 0x0645];
        }
      case 0xFD6E:
        {
          return [0x0636, 0x062D, 0x0649];
        }
      case 0xFD6F:
        {
          return [0x0636, 0x062E, 0x0645];
        }
      case 0xFD70:
        {
          return [0x0636, 0x062E, 0x0645];
        }
      case 0xFD71:
        {
          return [0x0637, 0x0645, 0x062D];
        }
      case 0xFD72:
        {
          return [0x0637, 0x0645, 0x062D];
        }
      case 0xFD73:
        {
          return [0x0637, 0x0645, 0x0645];
        }
      case 0xFD74:
        {
          return [0x0637, 0x0645, 0x064A];
        }
      case 0xFD75:
        {
          return [0x0639, 0x062C, 0x0645];
        }
      case 0xFD76:
        {
          return [0x0639, 0x0645, 0x0645];
        }
      case 0xFD77:
        {
          return [0x0639, 0x0645, 0x0645];
        }
      case 0xFD78:
        {
          return [0x0639, 0x0645, 0x0649];
        }
      case 0xFD79:
        {
          return [0x063A, 0x0645, 0x0645];
        }
      case 0xFD7A:
        {
          return [0x063A, 0x0645, 0x064A];
        }
      case 0xFD7B:
        {
          return [0x063A, 0x0645, 0x0649];
        }
      case 0xFD7C:
        {
          return [0x0641, 0x062E, 0x0645];
        }
      case 0xFD7D:
        {
          return [0x0641, 0x062E, 0x0645];
        }
      case 0xFD7E:
        {
          return [0x0642, 0x0645, 0x062D];
        }
      case 0xFD7F:
        {
          return [0x0642, 0x0645, 0x0645];
        }
      case 0xFD80:
        {
          return [0x0644, 0x062D, 0x0645];
        }
      case 0xFD81:
        {
          return [0x0644, 0x062D, 0x064A];
        }
      case 0xFD82:
        {
          return [0x0644, 0x062D, 0x0649];
        }
      case 0xFD83:
        {
          return [0x0644, 0x062C, 0x062C];
        }
      case 0xFD84:
        {
          return [0x0644, 0x062C, 0x062C];
        }
      case 0xFD85:
        {
          return [0x0644, 0x062E, 0x0645];
        }
      case 0xFD86:
        {
          return [0x0644, 0x062E, 0x0645];
        }
      case 0xFD87:
        {
          return [0x0644, 0x0645, 0x062D];
        }
      case 0xFD88:
        {
          return [0x0644, 0x0645, 0x062D];
        }
      case 0xFD89:
        {
          return [0x0645, 0x062D, 0x062C];
        }
      case 0xFD8A:
        {
          return [0x0645, 0x062D, 0x0645];
        }
      case 0xFD8B:
        {
          return [0x0645, 0x062D, 0x064A];
        }
      case 0xFD8C:
        {
          return [0x0645, 0x062C, 0x062D];
        }
      case 0xFD8D:
        {
          return [0x0645, 0x062C, 0x0645];
        }
      case 0xFD8E:
        {
          return [0x0645, 0x062E, 0x062C];
        }
      case 0xFD8F:
        {
          return [0x0645, 0x062E, 0x0645];
        }
      case 0xFD92:
        {
          return [0x0645, 0x062C, 0x062E];
        }
      case 0xFD93:
        {
          return [0x0647, 0x0645, 0x062C];
        }
      case 0xFD94:
        {
          return [0x0647, 0x0645, 0x0645];
        }
      case 0xFD95:
        {
          return [0x0646, 0x062D, 0x0645];
        }
      case 0xFD96:
        {
          return [0x0646, 0x062D, 0x0649];
        }
      case 0xFD97:
        {
          return [0x0646, 0x062C, 0x0645];
        }
      case 0xFD98:
        {
          return [0x0646, 0x062C, 0x0645];
        }
      case 0xFD99:
        {
          return [0x0646, 0x062C, 0x0649];
        }
      case 0xFD9A:
        {
          return [0x0646, 0x0645, 0x064A];
        }
      case 0xFD9B:
        {
          return [0x0646, 0x0645, 0x0649];
        }
      case 0xFD9C:
        {
          return [0x064A, 0x0645, 0x0645];
        }
      case 0xFD9D:
        {
          return [0x064A, 0x0645, 0x0645];
        }
      case 0xFD9E:
        {
          return [0x0628, 0x062E, 0x064A];
        }
      case 0xFD9F:
        {
          return [0x062A, 0x062C, 0x064A];
        }
      case 0xFDA0:
        {
          return [0x062A, 0x062C, 0x0649];
        }
      case 0xFDA1:
        {
          return [0x062A, 0x062E, 0x064A];
        }
      case 0xFDA2:
        {
          return [0x062A, 0x062E, 0x0649];
        }
      case 0xFDA3:
        {
          return [0x062A, 0x0645, 0x064A];
        }
      case 0xFDA4:
        {
          return [0x062A, 0x0645, 0x0649];
        }
      case 0xFDA5:
        {
          return [0x062C, 0x0645, 0x064A];
        }
      case 0xFDA6:
        {
          return [0x062C, 0x062D, 0x0649];
        }
      case 0xFDA7:
        {
          return [0x062C, 0x0645, 0x0649];
        }
      case 0xFDA8:
        {
          return [0x0633, 0x062E, 0x0649];
        }
      case 0xFDA9:
        {
          return [0x0635, 0x062D, 0x064A];
        }
      case 0xFDAA:
        {
          return [0x0634, 0x062D, 0x064A];
        }
      case 0xFDAB:
        {
          return [0x0636, 0x062D, 0x064A];
        }
      case 0xFDAC:
        {
          return [0x0644, 0x062C, 0x064A];
        }
      case 0xFDAD:
        {
          return [0x0644, 0x0645, 0x064A];
        }
      case 0xFDAE:
        {
          return [0x064A, 0x062D, 0x064A];
        }
      case 0xFDAF:
        {
          return [0x064A, 0x062C, 0x064A];
        }
      case 0xFDB0:
        {
          return [0x064A, 0x0645, 0x064A];
        }
      case 0xFDB1:
        {
          return [0x0645, 0x0645, 0x064A];
        }
      case 0xFDB2:
        {
          return [0x0642, 0x0645, 0x064A];
        }
      case 0xFDB3:
        {
          return [0x0646, 0x062D, 0x064A];
        }
      case 0xFDB4:
        {
          return [0x0642, 0x0645, 0x062D];
        }
      case 0xFDB5:
        {
          return [0x0644, 0x062D, 0x0645];
        }
      case 0xFDB6:
        {
          return [0x0639, 0x0645, 0x064A];
        }
      case 0xFDB7:
        {
          return [0x0643, 0x0645, 0x064A];
        }
      case 0xFDB8:
        {
          return [0x0646, 0x062C, 0x062D];
        }
      case 0xFDB9:
        {
          return [0x0645, 0x062E, 0x064A];
        }
      case 0xFDBA:
        {
          return [0x0644, 0x062C, 0x0645];
        }
      case 0xFDBB:
        {
          return [0x0643, 0x0645, 0x0645];
        }
      case 0xFDBC:
        {
          return [0x0644, 0x062C, 0x0645];
        }
      case 0xFDBD:
        {
          return [0x0646, 0x062C, 0x062D];
        }
      case 0xFDBE:
        {
          return [0x062C, 0x062D, 0x064A];
        }
      case 0xFDBF:
        {
          return [0x062D, 0x062C, 0x064A];
        }
      case 0xFDC0:
        {
          return [0x0645, 0x062C, 0x064A];
        }
      case 0xFDC1:
        {
          return [0x0641, 0x0645, 0x064A];
        }
      case 0xFDC2:
        {
          return [0x0628, 0x062D, 0x064A];
        }
      case 0xFDC3:
        {
          return [0x0643, 0x0645, 0x0645];
        }
      case 0xFDC4:
        {
          return [0x0639, 0x062C, 0x0645];
        }
      case 0xFDC5:
        {
          return [0x0635, 0x0645, 0x0645];
        }
      case 0xFDC6:
        {
          return [0x0633, 0x062E, 0x064A];
        }
      case 0xFDC7:
        {
          return [0x0646, 0x062C, 0x064A];
        }
      case 0xFDF0:
        {
          return [0x0635, 0x0644, 0x06D2];
        }
      case 0xFDF1:
        {
          return [0x0642, 0x0644, 0x06D2];
        }
      case 0xFDF2:
        {
          return [0x0627, 0x0644, 0x0644, 0x0647];
        }
      case 0xFDF3:
        {
          return [0x0627, 0x0643, 0x0628, 0x0631];
        }
      case 0xFDF4:
        {
          return [0x0645, 0x062D, 0x0645, 0x062F];
        }
      case 0xFDF5:
        {
          return [0x0635, 0x0644, 0x0639, 0x0645];
        }
      case 0xFDF6:
        {
          return [0x0631, 0x0633, 0x0648, 0x0644];
        }
      case 0xFDF7:
        {
          return [0x0639, 0x0644, 0x064A, 0x0647];
        }
      case 0xFDF8:
        {
          return [0x0648, 0x0633, 0x0644, 0x0645];
        }
      case 0xFDF9:
        {
          return [0x0635, 0x0644, 0x0649];
        }
      case 0xFDFA:
        {
          return [0x0635, 0x0644, 0x0649, 0x0020, 0x0627, 0x0644, 0x0644, 0x0647, 0x0020, 0x0639, 0x0644, 0x064A, 0x0647, 0x0020, 0x0648, 0x0633, 0x0644, 0x0645];
        }
      case 0xFDFB:
        {
          return [0x062C, 0x0644, 0x0020, 0x062C, 0x0644, 0x0627, 0x0644, 0x0647];
        }
      case 0xFDFC:
        {
          return [0x0631, 0x06CC, 0x0627, 0x0644];
        }
      case 0xFE10:
        {
          return [0x002C];
        }
      case 0xFE11:
        {
          return [0x3001];
        }
      case 0xFE12:
        {
          return [0x3002];
        }
      case 0xFE13:
        {
          return [0x003A];
        }
      case 0xFE14:
        {
          return [0x003B];
        }
      case 0xFE15:
        {
          return [0x0021];
        }
      case 0xFE16:
        {
          return [0x003F];
        }
      case 0xFE17:
        {
          return [0x3016];
        }
      case 0xFE18:
        {
          return [0x3017];
        }
      case 0xFE19:
        {
          return [0x2026];
        }
      case 0xFE30:
        {
          return [0x2025];
        }
      case 0xFE31:
        {
          return [0x2014];
        }
      case 0xFE32:
        {
          return [0x2013];
        }
      case 0xFE33:
        {
          return [0x005F];
        }
      case 0xFE34:
        {
          return [0x005F];
        }
      case 0xFE35:
        {
          return [0x0028];
        }
      case 0xFE36:
        {
          return [0x0029];
        }
      case 0xFE37:
        {
          return [0x007B];
        }
      case 0xFE38:
        {
          return [0x007D];
        }
      case 0xFE39:
        {
          return [0x3014];
        }
      case 0xFE3A:
        {
          return [0x3015];
        }
      case 0xFE3B:
        {
          return [0x3010];
        }
      case 0xFE3C:
        {
          return [0x3011];
        }
      case 0xFE3D:
        {
          return [0x300A];
        }
      case 0xFE3E:
        {
          return [0x300B];
        }
      case 0xFE3F:
        {
          return [0x3008];
        }
      case 0xFE40:
        {
          return [0x3009];
        }
      case 0xFE41:
        {
          return [0x300C];
        }
      case 0xFE42:
        {
          return [0x300D];
        }
      case 0xFE43:
        {
          return [0x300E];
        }
      case 0xFE44:
        {
          return [0x300F];
        }
      case 0xFE47:
        {
          return [0x005B];
        }
      case 0xFE48:
        {
          return [0x005D];
        }
      case 0xFE49:
        {
          return [0x203E];
        }
      case 0xFE4A:
        {
          return [0x203E];
        }
      case 0xFE4B:
        {
          return [0x203E];
        }
      case 0xFE4C:
        {
          return [0x203E];
        }
      case 0xFE4D:
        {
          return [0x005F];
        }
      case 0xFE4E:
        {
          return [0x005F];
        }
      case 0xFE4F:
        {
          return [0x005F];
        }
      case 0xFE50:
        {
          return [0x002C];
        }
      case 0xFE51:
        {
          return [0x3001];
        }
      case 0xFE52:
        {
          return [0x002E];
        }
      case 0xFE54:
        {
          return [0x003B];
        }
      case 0xFE55:
        {
          return [0x003A];
        }
      case 0xFE56:
        {
          return [0x003F];
        }
      case 0xFE57:
        {
          return [0x0021];
        }
      case 0xFE58:
        {
          return [0x2014];
        }
      case 0xFE59:
        {
          return [0x0028];
        }
      case 0xFE5A:
        {
          return [0x0029];
        }
      case 0xFE5B:
        {
          return [0x007B];
        }
      case 0xFE5C:
        {
          return [0x007D];
        }
      case 0xFE5D:
        {
          return [0x3014];
        }
      case 0xFE5E:
        {
          return [0x3015];
        }
      case 0xFE5F:
        {
          return [0x0023];
        }
      case 0xFE60:
        {
          return [0x0026];
        }
      case 0xFE61:
        {
          return [0x002A];
        }
      case 0xFE62:
        {
          return [0x002B];
        }
      case 0xFE63:
        {
          return [0x002D];
        }
      case 0xFE64:
        {
          return [0x003C];
        }
      case 0xFE65:
        {
          return [0x003E];
        }
      case 0xFE66:
        {
          return [0x003D];
        }
      case 0xFE68:
        {
          return [0x005C];
        }
      case 0xFE69:
        {
          return [0x0024];
        }
      case 0xFE6A:
        {
          return [0x0025];
        }
      case 0xFE6B:
        {
          return [0x0040];
        }
      case 0xFE70:
        {
          return [0x0020, 0x064B];
        }
      case 0xFE71:
        {
          return [0x0640, 0x064B];
        }
      case 0xFE72:
        {
          return [0x0020, 0x064C];
        }
      case 0xFE74:
        {
          return [0x0020, 0x064D];
        }
      case 0xFE76:
        {
          return [0x0020, 0x064E];
        }
      case 0xFE77:
        {
          return [0x0640, 0x064E];
        }
      case 0xFE78:
        {
          return [0x0020, 0x064F];
        }
      case 0xFE79:
        {
          return [0x0640, 0x064F];
        }
      case 0xFE7A:
        {
          return [0x0020, 0x0650];
        }
      case 0xFE7B:
        {
          return [0x0640, 0x0650];
        }
      case 0xFE7C:
        {
          return [0x0020, 0x0651];
        }
      case 0xFE7D:
        {
          return [0x0640, 0x0651];
        }
      case 0xFE7E:
        {
          return [0x0020, 0x0652];
        }
      case 0xFE7F:
        {
          return [0x0640, 0x0652];
        }
      case 0xFE80:
        {
          return [0x0621];
        }
      case 0xFE81:
        {
          return [0x0622];
        }
      case 0xFE82:
        {
          return [0x0622];
        }
      case 0xFE83:
        {
          return [0x0623];
        }
      case 0xFE84:
        {
          return [0x0623];
        }
      case 0xFE85:
        {
          return [0x0624];
        }
      case 0xFE86:
        {
          return [0x0624];
        }
      case 0xFE87:
        {
          return [0x0625];
        }
      case 0xFE88:
        {
          return [0x0625];
        }
      case 0xFE89:
        {
          return [0x0626];
        }
      case 0xFE8A:
        {
          return [0x0626];
        }
      case 0xFE8B:
        {
          return [0x0626];
        }
      case 0xFE8C:
        {
          return [0x0626];
        }
      case 0xFE8D:
        {
          return [0x0627];
        }
      case 0xFE8E:
        {
          return [0x0627];
        }
      case 0xFE8F:
        {
          return [0x0628];
        }
      case 0xFE90:
        {
          return [0x0628];
        }
      case 0xFE91:
        {
          return [0x0628];
        }
      case 0xFE92:
        {
          return [0x0628];
        }
      case 0xFE93:
        {
          return [0x0629];
        }
      case 0xFE94:
        {
          return [0x0629];
        }
      case 0xFE95:
        {
          return [0x062A];
        }
      case 0xFE96:
        {
          return [0x062A];
        }
      case 0xFE97:
        {
          return [0x062A];
        }
      case 0xFE98:
        {
          return [0x062A];
        }
      case 0xFE99:
        {
          return [0x062B];
        }
      case 0xFE9A:
        {
          return [0x062B];
        }
      case 0xFE9B:
        {
          return [0x062B];
        }
      case 0xFE9C:
        {
          return [0x062B];
        }
      case 0xFE9D:
        {
          return [0x062C];
        }
      case 0xFE9E:
        {
          return [0x062C];
        }
      case 0xFE9F:
        {
          return [0x062C];
        }
      case 0xFEA0:
        {
          return [0x062C];
        }
      case 0xFEA1:
        {
          return [0x062D];
        }
      case 0xFEA2:
        {
          return [0x062D];
        }
      case 0xFEA3:
        {
          return [0x062D];
        }
      case 0xFEA4:
        {
          return [0x062D];
        }
      case 0xFEA5:
        {
          return [0x062E];
        }
      case 0xFEA6:
        {
          return [0x062E];
        }
      case 0xFEA7:
        {
          return [0x062E];
        }
      case 0xFEA8:
        {
          return [0x062E];
        }
      case 0xFEA9:
        {
          return [0x062F];
        }
      case 0xFEAA:
        {
          return [0x062F];
        }
      case 0xFEAB:
        {
          return [0x0630];
        }
      case 0xFEAC:
        {
          return [0x0630];
        }
      case 0xFEAD:
        {
          return [0x0631];
        }
      case 0xFEAE:
        {
          return [0x0631];
        }
      case 0xFEAF:
        {
          return [0x0632];
        }
      case 0xFEB0:
        {
          return [0x0632];
        }
      case 0xFEB1:
        {
          return [0x0633];
        }
      case 0xFEB2:
        {
          return [0x0633];
        }
      case 0xFEB3:
        {
          return [0x0633];
        }
      case 0xFEB4:
        {
          return [0x0633];
        }
      case 0xFEB5:
        {
          return [0x0634];
        }
      case 0xFEB6:
        {
          return [0x0634];
        }
      case 0xFEB7:
        {
          return [0x0634];
        }
      case 0xFEB8:
        {
          return [0x0634];
        }
      case 0xFEB9:
        {
          return [0x0635];
        }
      case 0xFEBA:
        {
          return [0x0635];
        }
      case 0xFEBB:
        {
          return [0x0635];
        }
      case 0xFEBC:
        {
          return [0x0635];
        }
      case 0xFEBD:
        {
          return [0x0636];
        }
      case 0xFEBE:
        {
          return [0x0636];
        }
      case 0xFEBF:
        {
          return [0x0636];
        }
      case 0xFEC0:
        {
          return [0x0636];
        }
      case 0xFEC1:
        {
          return [0x0637];
        }
      case 0xFEC2:
        {
          return [0x0637];
        }
      case 0xFEC3:
        {
          return [0x0637];
        }
      case 0xFEC4:
        {
          return [0x0637];
        }
      case 0xFEC5:
        {
          return [0x0638];
        }
      case 0xFEC6:
        {
          return [0x0638];
        }
      case 0xFEC7:
        {
          return [0x0638];
        }
      case 0xFEC8:
        {
          return [0x0638];
        }
      case 0xFEC9:
        {
          return [0x0639];
        }
      case 0xFECA:
        {
          return [0x0639];
        }
      case 0xFECB:
        {
          return [0x0639];
        }
      case 0xFECC:
        {
          return [0x0639];
        }
      case 0xFECD:
        {
          return [0x063A];
        }
      case 0xFECE:
        {
          return [0x063A];
        }
      case 0xFECF:
        {
          return [0x063A];
        }
      case 0xFED0:
        {
          return [0x063A];
        }
      case 0xFED1:
        {
          return [0x0641];
        }
      case 0xFED2:
        {
          return [0x0641];
        }
      case 0xFED3:
        {
          return [0x0641];
        }
      case 0xFED4:
        {
          return [0x0641];
        }
      case 0xFED5:
        {
          return [0x0642];
        }
      case 0xFED6:
        {
          return [0x0642];
        }
      case 0xFED7:
        {
          return [0x0642];
        }
      case 0xFED8:
        {
          return [0x0642];
        }
      case 0xFED9:
        {
          return [0x0643];
        }
      case 0xFEDA:
        {
          return [0x0643];
        }
      case 0xFEDB:
        {
          return [0x0643];
        }
      case 0xFEDC:
        {
          return [0x0643];
        }
      case 0xFEDD:
        {
          return [0x0644];
        }
      case 0xFEDE:
        {
          return [0x0644];
        }
      case 0xFEDF:
        {
          return [0x0644];
        }
      case 0xFEE0:
        {
          return [0x0644];
        }
      case 0xFEE1:
        {
          return [0x0645];
        }
      case 0xFEE2:
        {
          return [0x0645];
        }
      case 0xFEE3:
        {
          return [0x0645];
        }
      case 0xFEE4:
        {
          return [0x0645];
        }
      case 0xFEE5:
        {
          return [0x0646];
        }
      case 0xFEE6:
        {
          return [0x0646];
        }
      case 0xFEE7:
        {
          return [0x0646];
        }
      case 0xFEE8:
        {
          return [0x0646];
        }
      case 0xFEE9:
        {
          return [0x0647];
        }
      case 0xFEEA:
        {
          return [0x0647];
        }
      case 0xFEEB:
        {
          return [0x0647];
        }
      case 0xFEEC:
        {
          return [0x0647];
        }
      case 0xFEED:
        {
          return [0x0648];
        }
      case 0xFEEE:
        {
          return [0x0648];
        }
      case 0xFEEF:
        {
          return [0x0649];
        }
      case 0xFEF0:
        {
          return [0x0649];
        }
      case 0xFEF1:
        {
          return [0x064A];
        }
      case 0xFEF2:
        {
          return [0x064A];
        }
      case 0xFEF3:
        {
          return [0x064A];
        }
      case 0xFEF4:
        {
          return [0x064A];
        }
      case 0xFEF5:
        {
          return [0x0644, 0x0622];
        }
      case 0xFEF6:
        {
          return [0x0644, 0x0622];
        }
      case 0xFEF7:
        {
          return [0x0644, 0x0623];
        }
      case 0xFEF8:
        {
          return [0x0644, 0x0623];
        }
      case 0xFEF9:
        {
          return [0x0644, 0x0625];
        }
      case 0xFEFA:
        {
          return [0x0644, 0x0625];
        }
      case 0xFEFB:
        {
          return [0x0644, 0x0627];
        }
      case 0xFEFC:
        {
          return [0x0644, 0x0627];
        }
      case 0xFF01:
        {
          return [0x0021];
        }
      case 0xFF02:
        {
          return [0x0022];
        }
      case 0xFF03:
        {
          return [0x0023];
        }
      case 0xFF04:
        {
          return [0x0024];
        }
      case 0xFF05:
        {
          return [0x0025];
        }
      case 0xFF06:
        {
          return [0x0026];
        }
      case 0xFF07:
        {
          return [0x0027];
        }
      case 0xFF08:
        {
          return [0x0028];
        }
      case 0xFF09:
        {
          return [0x0029];
        }
      case 0xFF0A:
        {
          return [0x002A];
        }
      case 0xFF0B:
        {
          return [0x002B];
        }
      case 0xFF0C:
        {
          return [0x002C];
        }
      case 0xFF0D:
        {
          return [0x002D];
        }
      case 0xFF0E:
        {
          return [0x002E];
        }
      case 0xFF0F:
        {
          return [0x002F];
        }
      case 0xFF10:
        {
          return [0x0030];
        }
      case 0xFF11:
        {
          return [0x0031];
        }
      case 0xFF12:
        {
          return [0x0032];
        }
      case 0xFF13:
        {
          return [0x0033];
        }
      case 0xFF14:
        {
          return [0x0034];
        }
      case 0xFF15:
        {
          return [0x0035];
        }
      case 0xFF16:
        {
          return [0x0036];
        }
      case 0xFF17:
        {
          return [0x0037];
        }
      case 0xFF18:
        {
          return [0x0038];
        }
      case 0xFF19:
        {
          return [0x0039];
        }
      case 0xFF1A:
        {
          return [0x003A];
        }
      case 0xFF1B:
        {
          return [0x003B];
        }
      case 0xFF1C:
        {
          return [0x003C];
        }
      case 0xFF1D:
        {
          return [0x003D];
        }
      case 0xFF1E:
        {
          return [0x003E];
        }
      case 0xFF1F:
        {
          return [0x003F];
        }
      case 0xFF20:
        {
          return [0x0040];
        }
      case 0xFF21:
        {
          return [0x0041];
        }
      case 0xFF22:
        {
          return [0x0042];
        }
      case 0xFF23:
        {
          return [0x0043];
        }
      case 0xFF24:
        {
          return [0x0044];
        }
      case 0xFF25:
        {
          return [0x0045];
        }
      case 0xFF26:
        {
          return [0x0046];
        }
      case 0xFF27:
        {
          return [0x0047];
        }
      case 0xFF28:
        {
          return [0x0048];
        }
      case 0xFF29:
        {
          return [0x0049];
        }
      case 0xFF2A:
        {
          return [0x004A];
        }
      case 0xFF2B:
        {
          return [0x004B];
        }
      case 0xFF2C:
        {
          return [0x004C];
        }
      case 0xFF2D:
        {
          return [0x004D];
        }
      case 0xFF2E:
        {
          return [0x004E];
        }
      case 0xFF2F:
        {
          return [0x004F];
        }
      case 0xFF30:
        {
          return [0x0050];
        }
      case 0xFF31:
        {
          return [0x0051];
        }
      case 0xFF32:
        {
          return [0x0052];
        }
      case 0xFF33:
        {
          return [0x0053];
        }
      case 0xFF34:
        {
          return [0x0054];
        }
      case 0xFF35:
        {
          return [0x0055];
        }
      case 0xFF36:
        {
          return [0x0056];
        }
      case 0xFF37:
        {
          return [0x0057];
        }
      case 0xFF38:
        {
          return [0x0058];
        }
      case 0xFF39:
        {
          return [0x0059];
        }
      case 0xFF3A:
        {
          return [0x005A];
        }
      case 0xFF3B:
        {
          return [0x005B];
        }
      case 0xFF3C:
        {
          return [0x005C];
        }
      case 0xFF3D:
        {
          return [0x005D];
        }
      case 0xFF3E:
        {
          return [0x005E];
        }
      case 0xFF3F:
        {
          return [0x005F];
        }
      case 0xFF40:
        {
          return [0x0060];
        }
      case 0xFF41:
        {
          return [0x0061];
        }
      case 0xFF42:
        {
          return [0x0062];
        }
      case 0xFF43:
        {
          return [0x0063];
        }
      case 0xFF44:
        {
          return [0x0064];
        }
      case 0xFF45:
        {
          return [0x0065];
        }
      case 0xFF46:
        {
          return [0x0066];
        }
      case 0xFF47:
        {
          return [0x0067];
        }
      case 0xFF48:
        {
          return [0x0068];
        }
      case 0xFF49:
        {
          return [0x0069];
        }
      case 0xFF4A:
        {
          return [0x006A];
        }
      case 0xFF4B:
        {
          return [0x006B];
        }
      case 0xFF4C:
        {
          return [0x006C];
        }
      case 0xFF4D:
        {
          return [0x006D];
        }
      case 0xFF4E:
        {
          return [0x006E];
        }
      case 0xFF4F:
        {
          return [0x006F];
        }
      case 0xFF50:
        {
          return [0x0070];
        }
      case 0xFF51:
        {
          return [0x0071];
        }
      case 0xFF52:
        {
          return [0x0072];
        }
      case 0xFF53:
        {
          return [0x0073];
        }
      case 0xFF54:
        {
          return [0x0074];
        }
      case 0xFF55:
        {
          return [0x0075];
        }
      case 0xFF56:
        {
          return [0x0076];
        }
      case 0xFF57:
        {
          return [0x0077];
        }
      case 0xFF58:
        {
          return [0x0078];
        }
      case 0xFF59:
        {
          return [0x0079];
        }
      case 0xFF5A:
        {
          return [0x007A];
        }
      case 0xFF5B:
        {
          return [0x007B];
        }
      case 0xFF5C:
        {
          return [0x007C];
        }
      case 0xFF5D:
        {
          return [0x007D];
        }
      case 0xFF5E:
        {
          return [0x007E];
        }
      case 0xFF5F:
        {
          return [0x2985];
        }
      case 0xFF60:
        {
          return [0x2986];
        }
      case 0xFF61:
        {
          return [0x3002];
        }
      case 0xFF62:
        {
          return [0x300C];
        }
      case 0xFF63:
        {
          return [0x300D];
        }
      case 0xFF64:
        {
          return [0x3001];
        }
      case 0xFF65:
        {
          return [0x30FB];
        }
      case 0xFF66:
        {
          return [0x30F2];
        }
      case 0xFF67:
        {
          return [0x30A1];
        }
      case 0xFF68:
        {
          return [0x30A3];
        }
      case 0xFF69:
        {
          return [0x30A5];
        }
      case 0xFF6A:
        {
          return [0x30A7];
        }
      case 0xFF6B:
        {
          return [0x30A9];
        }
      case 0xFF6C:
        {
          return [0x30E3];
        }
      case 0xFF6D:
        {
          return [0x30E5];
        }
      case 0xFF6E:
        {
          return [0x30E7];
        }
      case 0xFF6F:
        {
          return [0x30C3];
        }
      case 0xFF70:
        {
          return [0x30FC];
        }
      case 0xFF71:
        {
          return [0x30A2];
        }
      case 0xFF72:
        {
          return [0x30A4];
        }
      case 0xFF73:
        {
          return [0x30A6];
        }
      case 0xFF74:
        {
          return [0x30A8];
        }
      case 0xFF75:
        {
          return [0x30AA];
        }
      case 0xFF76:
        {
          return [0x30AB];
        }
      case 0xFF77:
        {
          return [0x30AD];
        }
      case 0xFF78:
        {
          return [0x30AF];
        }
      case 0xFF79:
        {
          return [0x30B1];
        }
      case 0xFF7A:
        {
          return [0x30B3];
        }
      case 0xFF7B:
        {
          return [0x30B5];
        }
      case 0xFF7C:
        {
          return [0x30B7];
        }
      case 0xFF7D:
        {
          return [0x30B9];
        }
      case 0xFF7E:
        {
          return [0x30BB];
        }
      case 0xFF7F:
        {
          return [0x30BD];
        }
      case 0xFF80:
        {
          return [0x30BF];
        }
      case 0xFF81:
        {
          return [0x30C1];
        }
      case 0xFF82:
        {
          return [0x30C4];
        }
      case 0xFF83:
        {
          return [0x30C6];
        }
      case 0xFF84:
        {
          return [0x30C8];
        }
      case 0xFF85:
        {
          return [0x30CA];
        }
      case 0xFF86:
        {
          return [0x30CB];
        }
      case 0xFF87:
        {
          return [0x30CC];
        }
      case 0xFF88:
        {
          return [0x30CD];
        }
      case 0xFF89:
        {
          return [0x30CE];
        }
      case 0xFF8A:
        {
          return [0x30CF];
        }
      case 0xFF8B:
        {
          return [0x30D2];
        }
      case 0xFF8C:
        {
          return [0x30D5];
        }
      case 0xFF8D:
        {
          return [0x30D8];
        }
      case 0xFF8E:
        {
          return [0x30DB];
        }
      case 0xFF8F:
        {
          return [0x30DE];
        }
      case 0xFF90:
        {
          return [0x30DF];
        }
      case 0xFF91:
        {
          return [0x30E0];
        }
      case 0xFF92:
        {
          return [0x30E1];
        }
      case 0xFF93:
        {
          return [0x30E2];
        }
      case 0xFF94:
        {
          return [0x30E4];
        }
      case 0xFF95:
        {
          return [0x30E6];
        }
      case 0xFF96:
        {
          return [0x30E8];
        }
      case 0xFF97:
        {
          return [0x30E9];
        }
      case 0xFF98:
        {
          return [0x30EA];
        }
      case 0xFF99:
        {
          return [0x30EB];
        }
      case 0xFF9A:
        {
          return [0x30EC];
        }
      case 0xFF9B:
        {
          return [0x30ED];
        }
      case 0xFF9C:
        {
          return [0x30EF];
        }
      case 0xFF9D:
        {
          return [0x30F3];
        }
      case 0xFF9E:
        {
          return [0x3099];
        }
      case 0xFF9F:
        {
          return [0x309A];
        }
      case 0xFFA0:
        {
          return [0x3164];
        }
      case 0xFFA1:
        {
          return [0x3131];
        }
      case 0xFFA2:
        {
          return [0x3132];
        }
      case 0xFFA3:
        {
          return [0x3133];
        }
      case 0xFFA4:
        {
          return [0x3134];
        }
      case 0xFFA5:
        {
          return [0x3135];
        }
      case 0xFFA6:
        {
          return [0x3136];
        }
      case 0xFFA7:
        {
          return [0x3137];
        }
      case 0xFFA8:
        {
          return [0x3138];
        }
      case 0xFFA9:
        {
          return [0x3139];
        }
      case 0xFFAA:
        {
          return [0x313A];
        }
      case 0xFFAB:
        {
          return [0x313B];
        }
      case 0xFFAC:
        {
          return [0x313C];
        }
      case 0xFFAD:
        {
          return [0x313D];
        }
      case 0xFFAE:
        {
          return [0x313E];
        }
      case 0xFFAF:
        {
          return [0x313F];
        }
      case 0xFFB0:
        {
          return [0x3140];
        }
      case 0xFFB1:
        {
          return [0x3141];
        }
      case 0xFFB2:
        {
          return [0x3142];
        }
      case 0xFFB3:
        {
          return [0x3143];
        }
      case 0xFFB4:
        {
          return [0x3144];
        }
      case 0xFFB5:
        {
          return [0x3145];
        }
      case 0xFFB6:
        {
          return [0x3146];
        }
      case 0xFFB7:
        {
          return [0x3147];
        }
      case 0xFFB8:
        {
          return [0x3148];
        }
      case 0xFFB9:
        {
          return [0x3149];
        }
      case 0xFFBA:
        {
          return [0x314A];
        }
      case 0xFFBB:
        {
          return [0x314B];
        }
      case 0xFFBC:
        {
          return [0x314C];
        }
      case 0xFFBD:
        {
          return [0x314D];
        }
      case 0xFFBE:
        {
          return [0x314E];
        }
      case 0xFFC2:
        {
          return [0x314F];
        }
      case 0xFFC3:
        {
          return [0x3150];
        }
      case 0xFFC4:
        {
          return [0x3151];
        }
      case 0xFFC5:
        {
          return [0x3152];
        }
      case 0xFFC6:
        {
          return [0x3153];
        }
      case 0xFFC7:
        {
          return [0x3154];
        }
      case 0xFFCA:
        {
          return [0x3155];
        }
      case 0xFFCB:
        {
          return [0x3156];
        }
      case 0xFFCC:
        {
          return [0x3157];
        }
      case 0xFFCD:
        {
          return [0x3158];
        }
      case 0xFFCE:
        {
          return [0x3159];
        }
      case 0xFFCF:
        {
          return [0x315A];
        }
      case 0xFFD2:
        {
          return [0x315B];
        }
      case 0xFFD3:
        {
          return [0x315C];
        }
      case 0xFFD4:
        {
          return [0x315D];
        }
      case 0xFFD5:
        {
          return [0x315E];
        }
      case 0xFFD6:
        {
          return [0x315F];
        }
      case 0xFFD7:
        {
          return [0x3160];
        }
      case 0xFFDA:
        {
          return [0x3161];
        }
      case 0xFFDB:
        {
          return [0x3162];
        }
      case 0xFFDC:
        {
          return [0x3163];
        }
      case 0xFFE0:
        {
          return [0x00A2];
        }
      case 0xFFE1:
        {
          return [0x00A3];
        }
      case 0xFFE2:
        {
          return [0x00AC];
        }
      case 0xFFE3:
        {
          return [0x00AF];
        }
      case 0xFFE4:
        {
          return [0x00A6];
        }
      case 0xFFE5:
        {
          return [0x00A5];
        }
      case 0xFFE6:
        {
          return [0x20A9];
        }
      case 0xFFE8:
        {
          return [0x2502];
        }
      case 0xFFE9:
        {
          return [0x2190];
        }
      case 0xFFEA:
        {
          return [0x2191];
        }
      case 0xFFEB:
        {
          return [0x2192];
        }
      case 0xFFEC:
        {
          return [0x2193];
        }
      case 0xFFED:
        {
          return [0x25A0];
        }
      case 0xFFEE:
        {
          return [0x25CB];
        }
      default:
        return null;
    }
  }
}
class DecompositionMachineBeta {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0x2000:
        {
          return [0x2002];
        }
      case 0x2001:
        {
          return [0x2003];
        }
      case 0x2002:
        {
          return [0x0020];
        }
      case 0x2003:
        {
          return [0x0020];
        }
      case 0x2004:
        {
          return [0x0020];
        }
      case 0x2005:
        {
          return [0x0020];
        }
      case 0x2006:
        {
          return [0x0020];
        }
      case 0x2007:
        {
          return [0x0020];
        }
      case 0x2008:
        {
          return [0x0020];
        }
      case 0x2009:
        {
          return [0x0020];
        }
      case 0x200A:
        {
          return [0x0020];
        }
      case 0x2011:
        {
          return [0x2010];
        }
      case 0x2017:
        {
          return [0x0020, 0x0333];
        }
      case 0x2024:
        {
          return [0x002E];
        }
      case 0x2025:
        {
          return [0x002E, 0x002E];
        }
      case 0x2026:
        {
          return [0x002E, 0x002E, 0x002E];
        }
      case 0x202F:
        {
          return [0x0020];
        }
      case 0x2033:
        {
          return [0x2032, 0x2032];
        }
      case 0x2034:
        {
          return [0x2032, 0x2032, 0x2032];
        }
      case 0x2036:
        {
          return [0x2035, 0x2035];
        }
      case 0x2037:
        {
          return [0x2035, 0x2035, 0x2035];
        }
      case 0x203C:
        {
          return [0x0021, 0x0021];
        }
      case 0x203E:
        {
          return [0x0020, 0x0305];
        }
      case 0x2047:
        {
          return [0x003F, 0x003F];
        }
      case 0x2048:
        {
          return [0x003F, 0x0021];
        }
      case 0x2049:
        {
          return [0x0021, 0x003F];
        }
      case 0x2057:
        {
          return [0x2032, 0x2032, 0x2032, 0x2032];
        }
      case 0x205F:
        {
          return [0x0020];
        }
      case 0x2070:
        {
          return [0x0030];
        }
      case 0x2071:
        {
          return [0x0069];
        }
      case 0x2074:
        {
          return [0x0034];
        }
      case 0x2075:
        {
          return [0x0035];
        }
      case 0x2076:
        {
          return [0x0036];
        }
      case 0x2077:
        {
          return [0x0037];
        }
      case 0x2078:
        {
          return [0x0038];
        }
      case 0x2079:
        {
          return [0x0039];
        }
      case 0x207A:
        {
          return [0x002B];
        }
      case 0x207B:
        {
          return [0x2212];
        }
      case 0x207C:
        {
          return [0x003D];
        }
      case 0x207D:
        {
          return [0x0028];
        }
      case 0x207E:
        {
          return [0x0029];
        }
      case 0x207F:
        {
          return [0x006E];
        }
      case 0x2080:
        {
          return [0x0030];
        }
      case 0x2081:
        {
          return [0x0031];
        }
      case 0x2082:
        {
          return [0x0032];
        }
      case 0x2083:
        {
          return [0x0033];
        }
      case 0x2084:
        {
          return [0x0034];
        }
      case 0x2085:
        {
          return [0x0035];
        }
      case 0x2086:
        {
          return [0x0036];
        }
      case 0x2087:
        {
          return [0x0037];
        }
      case 0x2088:
        {
          return [0x0038];
        }
      case 0x2089:
        {
          return [0x0039];
        }
      case 0x208A:
        {
          return [0x002B];
        }
      case 0x208B:
        {
          return [0x2212];
        }
      case 0x208C:
        {
          return [0x003D];
        }
      case 0x208D:
        {
          return [0x0028];
        }
      case 0x208E:
        {
          return [0x0029];
        }
      case 0x2090:
        {
          return [0x0061];
        }
      case 0x2091:
        {
          return [0x0065];
        }
      case 0x2092:
        {
          return [0x006F];
        }
      case 0x2093:
        {
          return [0x0078];
        }
      case 0x2094:
        {
          return [0x0259];
        }
      case 0x20A8:
        {
          return [0x0052, 0x0073];
        }
      case 0x2100:
        {
          return [0x0061, 0x002F, 0x0063];
        }
      case 0x2101:
        {
          return [0x0061, 0x002F, 0x0073];
        }
      case 0x2102:
        {
          return [0x0043];
        }
      case 0x2103:
        {
          return [0x00B0, 0x0043];
        }
      case 0x2105:
        {
          return [0x0063, 0x002F, 0x006F];
        }
      case 0x2106:
        {
          return [0x0063, 0x002F, 0x0075];
        }
      case 0x2107:
        {
          return [0x0190];
        }
      case 0x2109:
        {
          return [0x00B0, 0x0046];
        }
      case 0x210A:
        {
          return [0x0067];
        }
      case 0x210B:
        {
          return [0x0048];
        }
      case 0x210C:
        {
          return [0x0048];
        }
      case 0x210D:
        {
          return [0x0048];
        }
      case 0x210E:
        {
          return [0x0068];
        }
      case 0x210F:
        {
          return [0x0127];
        }
      case 0x2110:
        {
          return [0x0049];
        }
      case 0x2111:
        {
          return [0x0049];
        }
      case 0x2112:
        {
          return [0x004C];
        }
      case 0x2113:
        {
          return [0x006C];
        }
      case 0x2115:
        {
          return [0x004E];
        }
      case 0x2116:
        {
          return [0x004E, 0x006F];
        }
      case 0x2119:
        {
          return [0x0050];
        }
      case 0x211A:
        {
          return [0x0051];
        }
      case 0x211B:
        {
          return [0x0052];
        }
      case 0x211C:
        {
          return [0x0052];
        }
      case 0x211D:
        {
          return [0x0052];
        }
      case 0x2120:
        {
          return [0x0053, 0x004D];
        }
      case 0x2121:
        {
          return [0x0054, 0x0045, 0x004C];
        }
      case 0x2122:
        {
          return [0x0054, 0x004D];
        }
      case 0x2124:
        {
          return [0x005A];
        }
      case 0x2126:
        {
          return [0x03A9];
        }
      case 0x2128:
        {
          return [0x005A];
        }
      case 0x212A:
        {
          return [0x004B];
        }
      case 0x212B:
        {
          return [0x00C5];
        }
      case 0x212C:
        {
          return [0x0042];
        }
      case 0x212D:
        {
          return [0x0043];
        }
      case 0x212F:
        {
          return [0x0065];
        }
      case 0x2130:
        {
          return [0x0045];
        }
      case 0x2131:
        {
          return [0x0046];
        }
      case 0x2133:
        {
          return [0x004D];
        }
      case 0x2134:
        {
          return [0x006F];
        }
      case 0x2135:
        {
          return [0x05D0];
        }
      case 0x2136:
        {
          return [0x05D1];
        }
      case 0x2137:
        {
          return [0x05D2];
        }
      case 0x2138:
        {
          return [0x05D3];
        }
      case 0x2139:
        {
          return [0x0069];
        }
      case 0x213B:
        {
          return [0x0046, 0x0041, 0x0058];
        }
      case 0x213C:
        {
          return [0x03C0];
        }
      case 0x213D:
        {
          return [0x03B3];
        }
      case 0x213E:
        {
          return [0x0393];
        }
      case 0x213F:
        {
          return [0x03A0];
        }
      case 0x2140:
        {
          return [0x2211];
        }
      case 0x2145:
        {
          return [0x0044];
        }
      case 0x2146:
        {
          return [0x0064];
        }
      case 0x2147:
        {
          return [0x0065];
        }
      case 0x2148:
        {
          return [0x0069];
        }
      case 0x2149:
        {
          return [0x006A];
        }
      case 0x2153:
        {
          return [0x0031, 0x2044, 0x0033];
        }
      case 0x2154:
        {
          return [0x0032, 0x2044, 0x0033];
        }
      case 0x2155:
        {
          return [0x0031, 0x2044, 0x0035];
        }
      case 0x2156:
        {
          return [0x0032, 0x2044, 0x0035];
        }
      case 0x2157:
        {
          return [0x0033, 0x2044, 0x0035];
        }
      case 0x2158:
        {
          return [0x0034, 0x2044, 0x0035];
        }
      case 0x2159:
        {
          return [0x0031, 0x2044, 0x0036];
        }
      case 0x215A:
        {
          return [0x0035, 0x2044, 0x0036];
        }
      case 0x215B:
        {
          return [0x0031, 0x2044, 0x0038];
        }
      case 0x215C:
        {
          return [0x0033, 0x2044, 0x0038];
        }
      case 0x215D:
        {
          return [0x0035, 0x2044, 0x0038];
        }
      case 0x215E:
        {
          return [0x0037, 0x2044, 0x0038];
        }
      case 0x215F:
        {
          return [0x0031, 0x2044];
        }
      case 0x2160:
        {
          return [0x0049];
        }
      case 0x2161:
        {
          return [0x0049, 0x0049];
        }
      case 0x2162:
        {
          return [0x0049, 0x0049, 0x0049];
        }
      case 0x2163:
        {
          return [0x0049, 0x0056];
        }
      case 0x2164:
        {
          return [0x0056];
        }
      case 0x2165:
        {
          return [0x0056, 0x0049];
        }
      case 0x2166:
        {
          return [0x0056, 0x0049, 0x0049];
        }
      case 0x2167:
        {
          return [0x0056, 0x0049, 0x0049, 0x0049];
        }
      case 0x2168:
        {
          return [0x0049, 0x0058];
        }
      case 0x2169:
        {
          return [0x0058];
        }
      case 0x216A:
        {
          return [0x0058, 0x0049];
        }
      case 0x216B:
        {
          return [0x0058, 0x0049, 0x0049];
        }
      case 0x216C:
        {
          return [0x004C];
        }
      case 0x216D:
        {
          return [0x0043];
        }
      case 0x216E:
        {
          return [0x0044];
        }
      case 0x216F:
        {
          return [0x004D];
        }
      case 0x2170:
        {
          return [0x0069];
        }
      case 0x2171:
        {
          return [0x0069, 0x0069];
        }
      case 0x2172:
        {
          return [0x0069, 0x0069, 0x0069];
        }
      case 0x2173:
        {
          return [0x0069, 0x0076];
        }
      case 0x2174:
        {
          return [0x0076];
        }
      case 0x2175:
        {
          return [0x0076, 0x0069];
        }
      case 0x2176:
        {
          return [0x0076, 0x0069, 0x0069];
        }
      case 0x2177:
        {
          return [0x0076, 0x0069, 0x0069, 0x0069];
        }
      case 0x2178:
        {
          return [0x0069, 0x0078];
        }
      case 0x2179:
        {
          return [0x0078];
        }
      case 0x217A:
        {
          return [0x0078, 0x0069];
        }
      case 0x217B:
        {
          return [0x0078, 0x0069, 0x0069];
        }
      case 0x217C:
        {
          return [0x006C];
        }
      case 0x217D:
        {
          return [0x0063];
        }
      case 0x217E:
        {
          return [0x0064];
        }
      case 0x217F:
        {
          return [0x006D];
        }
      case 0x219A:
        {
          return [0x2190, 0x0338];
        }
      case 0x219B:
        {
          return [0x2192, 0x0338];
        }
      case 0x21AE:
        {
          return [0x2194, 0x0338];
        }
      case 0x21CD:
        {
          return [0x21D0, 0x0338];
        }
      case 0x21CE:
        {
          return [0x21D4, 0x0338];
        }
      case 0x21CF:
        {
          return [0x21D2, 0x0338];
        }
      case 0x2204:
        {
          return [0x2203, 0x0338];
        }
      case 0x2209:
        {
          return [0x2208, 0x0338];
        }
      case 0x220C:
        {
          return [0x220B, 0x0338];
        }
      case 0x2224:
        {
          return [0x2223, 0x0338];
        }
      case 0x2226:
        {
          return [0x2225, 0x0338];
        }
      case 0x222C:
        {
          return [0x222B, 0x222B];
        }
      case 0x222D:
        {
          return [0x222B, 0x222B, 0x222B];
        }
      case 0x222F:
        {
          return [0x222E, 0x222E];
        }
      case 0x2230:
        {
          return [0x222E, 0x222E, 0x222E];
        }
      case 0x2241:
        {
          return [0x223C, 0x0338];
        }
      case 0x2244:
        {
          return [0x2243, 0x0338];
        }
      case 0x2247:
        {
          return [0x2245, 0x0338];
        }
      case 0x2249:
        {
          return [0x2248, 0x0338];
        }
      case 0x2260:
        {
          return [0x003D, 0x0338];
        }
      case 0x2262:
        {
          return [0x2261, 0x0338];
        }
      case 0x226D:
        {
          return [0x224D, 0x0338];
        }
      case 0x226E:
        {
          return [0x003C, 0x0338];
        }
      case 0x226F:
        {
          return [0x003E, 0x0338];
        }
      case 0x2270:
        {
          return [0x2264, 0x0338];
        }
      case 0x2271:
        {
          return [0x2265, 0x0338];
        }
      case 0x2274:
        {
          return [0x2272, 0x0338];
        }
      case 0x2275:
        {
          return [0x2273, 0x0338];
        }
      case 0x2278:
        {
          return [0x2276, 0x0338];
        }
      case 0x2279:
        {
          return [0x2277, 0x0338];
        }
      case 0x2280:
        {
          return [0x227A, 0x0338];
        }
      case 0x2281:
        {
          return [0x227B, 0x0338];
        }
      case 0x2284:
        {
          return [0x2282, 0x0338];
        }
      case 0x2285:
        {
          return [0x2283, 0x0338];
        }
      case 0x2288:
        {
          return [0x2286, 0x0338];
        }
      case 0x2289:
        {
          return [0x2287, 0x0338];
        }
      case 0x22AC:
        {
          return [0x22A2, 0x0338];
        }
      case 0x22AD:
        {
          return [0x22A8, 0x0338];
        }
      case 0x22AE:
        {
          return [0x22A9, 0x0338];
        }
      case 0x22AF:
        {
          return [0x22AB, 0x0338];
        }
      case 0x22E0:
        {
          return [0x227C, 0x0338];
        }
      case 0x22E1:
        {
          return [0x227D, 0x0338];
        }
      case 0x22E2:
        {
          return [0x2291, 0x0338];
        }
      case 0x22E3:
        {
          return [0x2292, 0x0338];
        }
      case 0x22EA:
        {
          return [0x22B2, 0x0338];
        }
      case 0x22EB:
        {
          return [0x22B3, 0x0338];
        }
      case 0x22EC:
        {
          return [0x22B4, 0x0338];
        }
      case 0x22ED:
        {
          return [0x22B5, 0x0338];
        }
      case 0x2329:
        {
          return [0x3008];
        }
      case 0x232A:
        {
          return [0x3009];
        }
      case 0x2460:
        {
          return [0x0031];
        }
      case 0x2461:
        {
          return [0x0032];
        }
      case 0x2462:
        {
          return [0x0033];
        }
      case 0x2463:
        {
          return [0x0034];
        }
      case 0x2464:
        {
          return [0x0035];
        }
      case 0x2465:
        {
          return [0x0036];
        }
      case 0x2466:
        {
          return [0x0037];
        }
      case 0x2467:
        {
          return [0x0038];
        }
      case 0x2468:
        {
          return [0x0039];
        }
      case 0x2469:
        {
          return [0x0031, 0x0030];
        }
      case 0x246A:
        {
          return [0x0031, 0x0031];
        }
      case 0x246B:
        {
          return [0x0031, 0x0032];
        }
      case 0x246C:
        {
          return [0x0031, 0x0033];
        }
      case 0x246D:
        {
          return [0x0031, 0x0034];
        }
      case 0x246E:
        {
          return [0x0031, 0x0035];
        }
      case 0x246F:
        {
          return [0x0031, 0x0036];
        }
      case 0x2470:
        {
          return [0x0031, 0x0037];
        }
      case 0x2471:
        {
          return [0x0031, 0x0038];
        }
      case 0x2472:
        {
          return [0x0031, 0x0039];
        }
      case 0x2473:
        {
          return [0x0032, 0x0030];
        }
      case 0x2474:
        {
          return [0x0028, 0x0031, 0x0029];
        }
      case 0x2475:
        {
          return [0x0028, 0x0032, 0x0029];
        }
      case 0x2476:
        {
          return [0x0028, 0x0033, 0x0029];
        }
      case 0x2477:
        {
          return [0x0028, 0x0034, 0x0029];
        }
      case 0x2478:
        {
          return [0x0028, 0x0035, 0x0029];
        }
      case 0x2479:
        {
          return [0x0028, 0x0036, 0x0029];
        }
      case 0x247A:
        {
          return [0x0028, 0x0037, 0x0029];
        }
      case 0x247B:
        {
          return [0x0028, 0x0038, 0x0029];
        }
      case 0x247C:
        {
          return [0x0028, 0x0039, 0x0029];
        }
      case 0x247D:
        {
          return [0x0028, 0x0031, 0x0030, 0x0029];
        }
      case 0x247E:
        {
          return [0x0028, 0x0031, 0x0031, 0x0029];
        }
      case 0x247F:
        {
          return [0x0028, 0x0031, 0x0032, 0x0029];
        }
      case 0x2480:
        {
          return [0x0028, 0x0031, 0x0033, 0x0029];
        }
      case 0x2481:
        {
          return [0x0028, 0x0031, 0x0034, 0x0029];
        }
      case 0x2482:
        {
          return [0x0028, 0x0031, 0x0035, 0x0029];
        }
      case 0x2483:
        {
          return [0x0028, 0x0031, 0x0036, 0x0029];
        }
      case 0x2484:
        {
          return [0x0028, 0x0031, 0x0037, 0x0029];
        }
      case 0x2485:
        {
          return [0x0028, 0x0031, 0x0038, 0x0029];
        }
      case 0x2486:
        {
          return [0x0028, 0x0031, 0x0039, 0x0029];
        }
      case 0x2487:
        {
          return [0x0028, 0x0032, 0x0030, 0x0029];
        }
      case 0x2488:
        {
          return [0x0031, 0x002E];
        }
      case 0x2489:
        {
          return [0x0032, 0x002E];
        }
      case 0x248A:
        {
          return [0x0033, 0x002E];
        }
      case 0x248B:
        {
          return [0x0034, 0x002E];
        }
      case 0x248C:
        {
          return [0x0035, 0x002E];
        }
      case 0x248D:
        {
          return [0x0036, 0x002E];
        }
      case 0x248E:
        {
          return [0x0037, 0x002E];
        }
      case 0x248F:
        {
          return [0x0038, 0x002E];
        }
      case 0x2490:
        {
          return [0x0039, 0x002E];
        }
      case 0x2491:
        {
          return [0x0031, 0x0030, 0x002E];
        }
      case 0x2492:
        {
          return [0x0031, 0x0031, 0x002E];
        }
      case 0x2493:
        {
          return [0x0031, 0x0032, 0x002E];
        }
      case 0x2494:
        {
          return [0x0031, 0x0033, 0x002E];
        }
      case 0x2495:
        {
          return [0x0031, 0x0034, 0x002E];
        }
      case 0x2496:
        {
          return [0x0031, 0x0035, 0x002E];
        }
      case 0x2497:
        {
          return [0x0031, 0x0036, 0x002E];
        }
      case 0x2498:
        {
          return [0x0031, 0x0037, 0x002E];
        }
      case 0x2499:
        {
          return [0x0031, 0x0038, 0x002E];
        }
      case 0x249A:
        {
          return [0x0031, 0x0039, 0x002E];
        }
      case 0x249B:
        {
          return [0x0032, 0x0030, 0x002E];
        }
      case 0x249C:
        {
          return [0x0028, 0x0061, 0x0029];
        }
      case 0x249D:
        {
          return [0x0028, 0x0062, 0x0029];
        }
      case 0x249E:
        {
          return [0x0028, 0x0063, 0x0029];
        }
      case 0x249F:
        {
          return [0x0028, 0x0064, 0x0029];
        }
      case 0x24A0:
        {
          return [0x0028, 0x0065, 0x0029];
        }
      case 0x24A1:
        {
          return [0x0028, 0x0066, 0x0029];
        }
      case 0x24A2:
        {
          return [0x0028, 0x0067, 0x0029];
        }
      case 0x24A3:
        {
          return [0x0028, 0x0068, 0x0029];
        }
      case 0x24A4:
        {
          return [0x0028, 0x0069, 0x0029];
        }
      case 0x24A5:
        {
          return [0x0028, 0x006A, 0x0029];
        }
      case 0x24A6:
        {
          return [0x0028, 0x006B, 0x0029];
        }
      case 0x24A7:
        {
          return [0x0028, 0x006C, 0x0029];
        }
      case 0x24A8:
        {
          return [0x0028, 0x006D, 0x0029];
        }
      case 0x24A9:
        {
          return [0x0028, 0x006E, 0x0029];
        }
      case 0x24AA:
        {
          return [0x0028, 0x006F, 0x0029];
        }
      case 0x24AB:
        {
          return [0x0028, 0x0070, 0x0029];
        }
      case 0x24AC:
        {
          return [0x0028, 0x0071, 0x0029];
        }
      case 0x24AD:
        {
          return [0x0028, 0x0072, 0x0029];
        }
      case 0x24AE:
        {
          return [0x0028, 0x0073, 0x0029];
        }
      case 0x24AF:
        {
          return [0x0028, 0x0074, 0x0029];
        }
      case 0x24B0:
        {
          return [0x0028, 0x0075, 0x0029];
        }
      case 0x24B1:
        {
          return [0x0028, 0x0076, 0x0029];
        }
      case 0x24B2:
        {
          return [0x0028, 0x0077, 0x0029];
        }
      case 0x24B3:
        {
          return [0x0028, 0x0078, 0x0029];
        }
      case 0x24B4:
        {
          return [0x0028, 0x0079, 0x0029];
        }
      case 0x24B5:
        {
          return [0x0028, 0x007A, 0x0029];
        }
      case 0x24B6:
        {
          return [0x0041];
        }
      case 0x24B7:
        {
          return [0x0042];
        }
      case 0x24B8:
        {
          return [0x0043];
        }
      case 0x24B9:
        {
          return [0x0044];
        }
      case 0x24BA:
        {
          return [0x0045];
        }
      case 0x24BB:
        {
          return [0x0046];
        }
      case 0x24BC:
        {
          return [0x0047];
        }
      case 0x24BD:
        {
          return [0x0048];
        }
      case 0x24BE:
        {
          return [0x0049];
        }
      case 0x24BF:
        {
          return [0x004A];
        }
      case 0x24C0:
        {
          return [0x004B];
        }
      case 0x24C1:
        {
          return [0x004C];
        }
      case 0x24C2:
        {
          return [0x004D];
        }
      case 0x24C3:
        {
          return [0x004E];
        }
      case 0x24C4:
        {
          return [0x004F];
        }
      case 0x24C5:
        {
          return [0x0050];
        }
      case 0x24C6:
        {
          return [0x0051];
        }
      case 0x24C7:
        {
          return [0x0052];
        }
      case 0x24C8:
        {
          return [0x0053];
        }
      case 0x24C9:
        {
          return [0x0054];
        }
      case 0x24CA:
        {
          return [0x0055];
        }
      case 0x24CB:
        {
          return [0x0056];
        }
      case 0x24CC:
        {
          return [0x0057];
        }
      case 0x24CD:
        {
          return [0x0058];
        }
      case 0x24CE:
        {
          return [0x0059];
        }
      case 0x24CF:
        {
          return [0x005A];
        }
      case 0x24D0:
        {
          return [0x0061];
        }
      case 0x24D1:
        {
          return [0x0062];
        }
      case 0x24D2:
        {
          return [0x0063];
        }
      case 0x24D3:
        {
          return [0x0064];
        }
      case 0x24D4:
        {
          return [0x0065];
        }
      case 0x24D5:
        {
          return [0x0066];
        }
      case 0x24D6:
        {
          return [0x0067];
        }
      case 0x24D7:
        {
          return [0x0068];
        }
      case 0x24D8:
        {
          return [0x0069];
        }
      case 0x24D9:
        {
          return [0x006A];
        }
      case 0x24DA:
        {
          return [0x006B];
        }
      case 0x24DB:
        {
          return [0x006C];
        }
      case 0x24DC:
        {
          return [0x006D];
        }
      case 0x24DD:
        {
          return [0x006E];
        }
      case 0x24DE:
        {
          return [0x006F];
        }
      case 0x24DF:
        {
          return [0x0070];
        }
      case 0x24E0:
        {
          return [0x0071];
        }
      case 0x24E1:
        {
          return [0x0072];
        }
      case 0x24E2:
        {
          return [0x0073];
        }
      case 0x24E3:
        {
          return [0x0074];
        }
      case 0x24E4:
        {
          return [0x0075];
        }
      case 0x24E5:
        {
          return [0x0076];
        }
      case 0x24E6:
        {
          return [0x0077];
        }
      case 0x24E7:
        {
          return [0x0078];
        }
      case 0x24E8:
        {
          return [0x0079];
        }
      case 0x24E9:
        {
          return [0x007A];
        }
      case 0x24EA:
        {
          return [0x0030];
        }
      case 0x2A0C:
        {
          return [0x222B, 0x222B, 0x222B, 0x222B];
        }
      case 0x2A74:
        {
          return [0x003A, 0x003A, 0x003D];
        }
      case 0x2A75:
        {
          return [0x003D, 0x003D];
        }
      case 0x2A76:
        {
          return [0x003D, 0x003D, 0x003D];
        }
      case 0x2ADC:
        {
          return [0x2ADD, 0x0338];
        }
      case 0x2D6F:
        {
          return [0x2D61];
        }
      case 0x2E9F:
        {
          return [0x6BCD];
        }
      case 0x2EF3:
        {
          return [0x9F9F];
        }
      case 0x2F00:
        {
          return [0x4E00];
        }
      case 0x2F01:
        {
          return [0x4E28];
        }
      case 0x2F02:
        {
          return [0x4E36];
        }
      case 0x2F03:
        {
          return [0x4E3F];
        }
      case 0x2F04:
        {
          return [0x4E59];
        }
      case 0x2F05:
        {
          return [0x4E85];
        }
      case 0x2F06:
        {
          return [0x4E8C];
        }
      case 0x2F07:
        {
          return [0x4EA0];
        }
      case 0x2F08:
        {
          return [0x4EBA];
        }
      case 0x2F09:
        {
          return [0x513F];
        }
      case 0x2F0A:
        {
          return [0x5165];
        }
      case 0x2F0B:
        {
          return [0x516B];
        }
      case 0x2F0C:
        {
          return [0x5182];
        }
      case 0x2F0D:
        {
          return [0x5196];
        }
      case 0x2F0E:
        {
          return [0x51AB];
        }
      case 0x2F0F:
        {
          return [0x51E0];
        }
      case 0x2F10:
        {
          return [0x51F5];
        }
      case 0x2F11:
        {
          return [0x5200];
        }
      case 0x2F12:
        {
          return [0x529B];
        }
      case 0x2F13:
        {
          return [0x52F9];
        }
      case 0x2F14:
        {
          return [0x5315];
        }
      case 0x2F15:
        {
          return [0x531A];
        }
      case 0x2F16:
        {
          return [0x5338];
        }
      case 0x2F17:
        {
          return [0x5341];
        }
      case 0x2F18:
        {
          return [0x535C];
        }
      case 0x2F19:
        {
          return [0x5369];
        }
      case 0x2F1A:
        {
          return [0x5382];
        }
      case 0x2F1B:
        {
          return [0x53B6];
        }
      case 0x2F1C:
        {
          return [0x53C8];
        }
      case 0x2F1D:
        {
          return [0x53E3];
        }
      case 0x2F1E:
        {
          return [0x56D7];
        }
      case 0x2F1F:
        {
          return [0x571F];
        }
      case 0x2F20:
        {
          return [0x58EB];
        }
      case 0x2F21:
        {
          return [0x5902];
        }
      case 0x2F22:
        {
          return [0x590A];
        }
      case 0x2F23:
        {
          return [0x5915];
        }
      case 0x2F24:
        {
          return [0x5927];
        }
      case 0x2F25:
        {
          return [0x5973];
        }
      case 0x2F26:
        {
          return [0x5B50];
        }
      case 0x2F27:
        {
          return [0x5B80];
        }
      case 0x2F28:
        {
          return [0x5BF8];
        }
      case 0x2F29:
        {
          return [0x5C0F];
        }
      case 0x2F2A:
        {
          return [0x5C22];
        }
      case 0x2F2B:
        {
          return [0x5C38];
        }
      case 0x2F2C:
        {
          return [0x5C6E];
        }
      case 0x2F2D:
        {
          return [0x5C71];
        }
      case 0x2F2E:
        {
          return [0x5DDB];
        }
      case 0x2F2F:
        {
          return [0x5DE5];
        }
      case 0x2F30:
        {
          return [0x5DF1];
        }
      case 0x2F31:
        {
          return [0x5DFE];
        }
      case 0x2F32:
        {
          return [0x5E72];
        }
      case 0x2F33:
        {
          return [0x5E7A];
        }
      case 0x2F34:
        {
          return [0x5E7F];
        }
      case 0x2F35:
        {
          return [0x5EF4];
        }
      case 0x2F36:
        {
          return [0x5EFE];
        }
      case 0x2F37:
        {
          return [0x5F0B];
        }
      case 0x2F38:
        {
          return [0x5F13];
        }
      case 0x2F39:
        {
          return [0x5F50];
        }
      case 0x2F3A:
        {
          return [0x5F61];
        }
      case 0x2F3B:
        {
          return [0x5F73];
        }
      case 0x2F3C:
        {
          return [0x5FC3];
        }
      case 0x2F3D:
        {
          return [0x6208];
        }
      case 0x2F3E:
        {
          return [0x6236];
        }
      case 0x2F3F:
        {
          return [0x624B];
        }
      case 0x2F40:
        {
          return [0x652F];
        }
      case 0x2F41:
        {
          return [0x6534];
        }
      case 0x2F42:
        {
          return [0x6587];
        }
      case 0x2F43:
        {
          return [0x6597];
        }
      case 0x2F44:
        {
          return [0x65A4];
        }
      case 0x2F45:
        {
          return [0x65B9];
        }
      case 0x2F46:
        {
          return [0x65E0];
        }
      case 0x2F47:
        {
          return [0x65E5];
        }
      case 0x2F48:
        {
          return [0x66F0];
        }
      case 0x2F49:
        {
          return [0x6708];
        }
      case 0x2F4A:
        {
          return [0x6728];
        }
      case 0x2F4B:
        {
          return [0x6B20];
        }
      case 0x2F4C:
        {
          return [0x6B62];
        }
      case 0x2F4D:
        {
          return [0x6B79];
        }
      case 0x2F4E:
        {
          return [0x6BB3];
        }
      case 0x2F4F:
        {
          return [0x6BCB];
        }
      case 0x2F50:
        {
          return [0x6BD4];
        }
      case 0x2F51:
        {
          return [0x6BDB];
        }
      case 0x2F52:
        {
          return [0x6C0F];
        }
      case 0x2F53:
        {
          return [0x6C14];
        }
      case 0x2F54:
        {
          return [0x6C34];
        }
      case 0x2F55:
        {
          return [0x706B];
        }
      case 0x2F56:
        {
          return [0x722A];
        }
      case 0x2F57:
        {
          return [0x7236];
        }
      case 0x2F58:
        {
          return [0x723B];
        }
      case 0x2F59:
        {
          return [0x723F];
        }
      case 0x2F5A:
        {
          return [0x7247];
        }
      case 0x2F5B:
        {
          return [0x7259];
        }
      case 0x2F5C:
        {
          return [0x725B];
        }
      case 0x2F5D:
        {
          return [0x72AC];
        }
      case 0x2F5E:
        {
          return [0x7384];
        }
      case 0x2F5F:
        {
          return [0x7389];
        }
      case 0x2F60:
        {
          return [0x74DC];
        }
      case 0x2F61:
        {
          return [0x74E6];
        }
      case 0x2F62:
        {
          return [0x7518];
        }
      case 0x2F63:
        {
          return [0x751F];
        }
      case 0x2F64:
        {
          return [0x7528];
        }
      case 0x2F65:
        {
          return [0x7530];
        }
      case 0x2F66:
        {
          return [0x758B];
        }
      case 0x2F67:
        {
          return [0x7592];
        }
      case 0x2F68:
        {
          return [0x7676];
        }
      case 0x2F69:
        {
          return [0x767D];
        }
      case 0x2F6A:
        {
          return [0x76AE];
        }
      case 0x2F6B:
        {
          return [0x76BF];
        }
      case 0x2F6C:
        {
          return [0x76EE];
        }
      case 0x2F6D:
        {
          return [0x77DB];
        }
      case 0x2F6E:
        {
          return [0x77E2];
        }
      case 0x2F6F:
        {
          return [0x77F3];
        }
      case 0x2F70:
        {
          return [0x793A];
        }
      case 0x2F71:
        {
          return [0x79B8];
        }
      case 0x2F72:
        {
          return [0x79BE];
        }
      case 0x2F73:
        {
          return [0x7A74];
        }
      case 0x2F74:
        {
          return [0x7ACB];
        }
      case 0x2F75:
        {
          return [0x7AF9];
        }
      case 0x2F76:
        {
          return [0x7C73];
        }
      case 0x2F77:
        {
          return [0x7CF8];
        }
      case 0x2F78:
        {
          return [0x7F36];
        }
      case 0x2F79:
        {
          return [0x7F51];
        }
      case 0x2F7A:
        {
          return [0x7F8A];
        }
      case 0x2F7B:
        {
          return [0x7FBD];
        }
      case 0x2F7C:
        {
          return [0x8001];
        }
      case 0x2F7D:
        {
          return [0x800C];
        }
      case 0x2F7E:
        {
          return [0x8012];
        }
      case 0x2F7F:
        {
          return [0x8033];
        }
      case 0x2F80:
        {
          return [0x807F];
        }
      case 0x2F81:
        {
          return [0x8089];
        }
      case 0x2F82:
        {
          return [0x81E3];
        }
      case 0x2F83:
        {
          return [0x81EA];
        }
      case 0x2F84:
        {
          return [0x81F3];
        }
      case 0x2F85:
        {
          return [0x81FC];
        }
      case 0x2F86:
        {
          return [0x820C];
        }
      case 0x2F87:
        {
          return [0x821B];
        }
      case 0x2F88:
        {
          return [0x821F];
        }
      case 0x2F89:
        {
          return [0x826E];
        }
      case 0x2F8A:
        {
          return [0x8272];
        }
      case 0x2F8B:
        {
          return [0x8278];
        }
      case 0x2F8C:
        {
          return [0x864D];
        }
      case 0x2F8D:
        {
          return [0x866B];
        }
      case 0x2F8E:
        {
          return [0x8840];
        }
      case 0x2F8F:
        {
          return [0x884C];
        }
      case 0x2F90:
        {
          return [0x8863];
        }
      case 0x2F91:
        {
          return [0x897E];
        }
      case 0x2F92:
        {
          return [0x898B];
        }
      case 0x2F93:
        {
          return [0x89D2];
        }
      case 0x2F94:
        {
          return [0x8A00];
        }
      case 0x2F95:
        {
          return [0x8C37];
        }
      case 0x2F96:
        {
          return [0x8C46];
        }
      case 0x2F97:
        {
          return [0x8C55];
        }
      case 0x2F98:
        {
          return [0x8C78];
        }
      case 0x2F99:
        {
          return [0x8C9D];
        }
      case 0x2F9A:
        {
          return [0x8D64];
        }
      case 0x2F9B:
        {
          return [0x8D70];
        }
      case 0x2F9C:
        {
          return [0x8DB3];
        }
      case 0x2F9D:
        {
          return [0x8EAB];
        }
      case 0x2F9E:
        {
          return [0x8ECA];
        }
      case 0x2F9F:
        {
          return [0x8F9B];
        }
      case 0x2FA0:
        {
          return [0x8FB0];
        }
      case 0x2FA1:
        {
          return [0x8FB5];
        }
      case 0x2FA2:
        {
          return [0x9091];
        }
      case 0x2FA3:
        {
          return [0x9149];
        }
      case 0x2FA4:
        {
          return [0x91C6];
        }
      case 0x2FA5:
        {
          return [0x91CC];
        }
      case 0x2FA6:
        {
          return [0x91D1];
        }
      case 0x2FA7:
        {
          return [0x9577];
        }
      case 0x2FA8:
        {
          return [0x9580];
        }
      case 0x2FA9:
        {
          return [0x961C];
        }
      case 0x2FAA:
        {
          return [0x96B6];
        }
      case 0x2FAB:
        {
          return [0x96B9];
        }
      case 0x2FAC:
        {
          return [0x96E8];
        }
      case 0x2FAD:
        {
          return [0x9751];
        }
      case 0x2FAE:
        {
          return [0x975E];
        }
      case 0x2FAF:
        {
          return [0x9762];
        }
      case 0x2FB0:
        {
          return [0x9769];
        }
      case 0x2FB1:
        {
          return [0x97CB];
        }
      case 0x2FB2:
        {
          return [0x97ED];
        }
      case 0x2FB3:
        {
          return [0x97F3];
        }
      case 0x2FB4:
        {
          return [0x9801];
        }
      case 0x2FB5:
        {
          return [0x98A8];
        }
      case 0x2FB6:
        {
          return [0x98DB];
        }
      case 0x2FB7:
        {
          return [0x98DF];
        }
      case 0x2FB8:
        {
          return [0x9996];
        }
      case 0x2FB9:
        {
          return [0x9999];
        }
      case 0x2FBA:
        {
          return [0x99AC];
        }
      case 0x2FBB:
        {
          return [0x9AA8];
        }
      case 0x2FBC:
        {
          return [0x9AD8];
        }
      case 0x2FBD:
        {
          return [0x9ADF];
        }
      case 0x2FBE:
        {
          return [0x9B25];
        }
      case 0x2FBF:
        {
          return [0x9B2F];
        }
      case 0x2FC0:
        {
          return [0x9B32];
        }
      case 0x2FC1:
        {
          return [0x9B3C];
        }
      case 0x2FC2:
        {
          return [0x9B5A];
        }
      case 0x2FC3:
        {
          return [0x9CE5];
        }
      case 0x2FC4:
        {
          return [0x9E75];
        }
      case 0x2FC5:
        {
          return [0x9E7F];
        }
      case 0x2FC6:
        {
          return [0x9EA5];
        }
      case 0x2FC7:
        {
          return [0x9EBB];
        }
      case 0x2FC8:
        {
          return [0x9EC3];
        }
      case 0x2FC9:
        {
          return [0x9ECD];
        }
      case 0x2FCA:
        {
          return [0x9ED1];
        }
      case 0x2FCB:
        {
          return [0x9EF9];
        }
      case 0x2FCC:
        {
          return [0x9EFD];
        }
      case 0x2FCD:
        {
          return [0x9F0E];
        }
      case 0x2FCE:
        {
          return [0x9F13];
        }
      case 0x2FCF:
        {
          return [0x9F20];
        }
      case 0x2FD0:
        {
          return [0x9F3B];
        }
      case 0x2FD1:
        {
          return [0x9F4A];
        }
      case 0x2FD2:
        {
          return [0x9F52];
        }
      case 0x2FD3:
        {
          return [0x9F8D];
        }
      case 0x2FD4:
        {
          return [0x9F9C];
        }
      case 0x2FD5:
        {
          return [0x9FA0];
        }
      case 0x3000:
        {
          return [0x0020];
        }
      case 0x3036:
        {
          return [0x3012];
        }
      case 0x3038:
        {
          return [0x5341];
        }
      case 0x3039:
        {
          return [0x5344];
        }
      case 0x303A:
        {
          return [0x5345];
        }
      case 0x304C:
        {
          return [0x304B, 0x3099];
        }
      case 0x304E:
        {
          return [0x304D, 0x3099];
        }
      case 0x3050:
        {
          return [0x304F, 0x3099];
        }
      case 0x3052:
        {
          return [0x3051, 0x3099];
        }
      case 0x3054:
        {
          return [0x3053, 0x3099];
        }
      case 0x3056:
        {
          return [0x3055, 0x3099];
        }
      case 0x3058:
        {
          return [0x3057, 0x3099];
        }
      case 0x305A:
        {
          return [0x3059, 0x3099];
        }
      case 0x305C:
        {
          return [0x305B, 0x3099];
        }
      case 0x305E:
        {
          return [0x305D, 0x3099];
        }
      case 0x3060:
        {
          return [0x305F, 0x3099];
        }
      case 0x3062:
        {
          return [0x3061, 0x3099];
        }
      case 0x3065:
        {
          return [0x3064, 0x3099];
        }
      case 0x3067:
        {
          return [0x3066, 0x3099];
        }
      case 0x3069:
        {
          return [0x3068, 0x3099];
        }
      case 0x3070:
        {
          return [0x306F, 0x3099];
        }
      case 0x3071:
        {
          return [0x306F, 0x309A];
        }
      case 0x3073:
        {
          return [0x3072, 0x3099];
        }
      case 0x3074:
        {
          return [0x3072, 0x309A];
        }
      case 0x3076:
        {
          return [0x3075, 0x3099];
        }
      case 0x3077:
        {
          return [0x3075, 0x309A];
        }
      case 0x3079:
        {
          return [0x3078, 0x3099];
        }
      case 0x307A:
        {
          return [0x3078, 0x309A];
        }
      case 0x307C:
        {
          return [0x307B, 0x3099];
        }
      case 0x307D:
        {
          return [0x307B, 0x309A];
        }
      case 0x3094:
        {
          return [0x3046, 0x3099];
        }
      case 0x309B:
        {
          return [0x0020, 0x3099];
        }
      case 0x309C:
        {
          return [0x0020, 0x309A];
        }
      case 0x309E:
        {
          return [0x309D, 0x3099];
        }
      case 0x309F:
        {
          return [0x3088, 0x308A];
        }
      case 0x30AC:
        {
          return [0x30AB, 0x3099];
        }
      case 0x30AE:
        {
          return [0x30AD, 0x3099];
        }
      case 0x30B0:
        {
          return [0x30AF, 0x3099];
        }
      case 0x30B2:
        {
          return [0x30B1, 0x3099];
        }
      case 0x30B4:
        {
          return [0x30B3, 0x3099];
        }
      case 0x30B6:
        {
          return [0x30B5, 0x3099];
        }
      case 0x30B8:
        {
          return [0x30B7, 0x3099];
        }
      case 0x30BA:
        {
          return [0x30B9, 0x3099];
        }
      case 0x30BC:
        {
          return [0x30BB, 0x3099];
        }
      case 0x30BE:
        {
          return [0x30BD, 0x3099];
        }
      case 0x30C0:
        {
          return [0x30BF, 0x3099];
        }
      case 0x30C2:
        {
          return [0x30C1, 0x3099];
        }
      case 0x30C5:
        {
          return [0x30C4, 0x3099];
        }
      case 0x30C7:
        {
          return [0x30C6, 0x3099];
        }
      case 0x30C9:
        {
          return [0x30C8, 0x3099];
        }
      case 0x30D0:
        {
          return [0x30CF, 0x3099];
        }
      case 0x30D1:
        {
          return [0x30CF, 0x309A];
        }
      case 0x30D3:
        {
          return [0x30D2, 0x3099];
        }
      case 0x30D4:
        {
          return [0x30D2, 0x309A];
        }
      case 0x30D6:
        {
          return [0x30D5, 0x3099];
        }
      case 0x30D7:
        {
          return [0x30D5, 0x309A];
        }
      case 0x30D9:
        {
          return [0x30D8, 0x3099];
        }
      case 0x30DA:
        {
          return [0x30D8, 0x309A];
        }
      case 0x30DC:
        {
          return [0x30DB, 0x3099];
        }
      case 0x30DD:
        {
          return [0x30DB, 0x309A];
        }
      case 0x30F4:
        {
          return [0x30A6, 0x3099];
        }
      case 0x30F7:
        {
          return [0x30EF, 0x3099];
        }
      case 0x30F8:
        {
          return [0x30F0, 0x3099];
        }
      case 0x30F9:
        {
          return [0x30F1, 0x3099];
        }
      case 0x30FA:
        {
          return [0x30F2, 0x3099];
        }
      case 0x30FE:
        {
          return [0x30FD, 0x3099];
        }
      case 0x30FF:
        {
          return [0x30B3, 0x30C8];
        }
      case 0x3131:
        {
          return [0x1100];
        }
      case 0x3132:
        {
          return [0x1101];
        }
      case 0x3133:
        {
          return [0x11AA];
        }
      case 0x3134:
        {
          return [0x1102];
        }
      case 0x3135:
        {
          return [0x11AC];
        }
      case 0x3136:
        {
          return [0x11AD];
        }
      case 0x3137:
        {
          return [0x1103];
        }
      case 0x3138:
        {
          return [0x1104];
        }
      case 0x3139:
        {
          return [0x1105];
        }
      case 0x313A:
        {
          return [0x11B0];
        }
      case 0x313B:
        {
          return [0x11B1];
        }
      case 0x313C:
        {
          return [0x11B2];
        }
      case 0x313D:
        {
          return [0x11B3];
        }
      case 0x313E:
        {
          return [0x11B4];
        }
      case 0x313F:
        {
          return [0x11B5];
        }
      case 0x3140:
        {
          return [0x111A];
        }
      case 0x3141:
        {
          return [0x1106];
        }
      case 0x3142:
        {
          return [0x1107];
        }
      case 0x3143:
        {
          return [0x1108];
        }
      case 0x3144:
        {
          return [0x1121];
        }
      case 0x3145:
        {
          return [0x1109];
        }
      case 0x3146:
        {
          return [0x110A];
        }
      case 0x3147:
        {
          return [0x110B];
        }
      case 0x3148:
        {
          return [0x110C];
        }
      case 0x3149:
        {
          return [0x110D];
        }
      case 0x314A:
        {
          return [0x110E];
        }
      case 0x314B:
        {
          return [0x110F];
        }
      case 0x314C:
        {
          return [0x1110];
        }
      case 0x314D:
        {
          return [0x1111];
        }
      case 0x314E:
        {
          return [0x1112];
        }
      case 0x314F:
        {
          return [0x1161];
        }
      case 0x3150:
        {
          return [0x1162];
        }
      case 0x3151:
        {
          return [0x1163];
        }
      case 0x3152:
        {
          return [0x1164];
        }
      case 0x3153:
        {
          return [0x1165];
        }
      case 0x3154:
        {
          return [0x1166];
        }
      case 0x3155:
        {
          return [0x1167];
        }
      case 0x3156:
        {
          return [0x1168];
        }
      case 0x3157:
        {
          return [0x1169];
        }
      case 0x3158:
        {
          return [0x116A];
        }
      case 0x3159:
        {
          return [0x116B];
        }
      case 0x315A:
        {
          return [0x116C];
        }
      case 0x315B:
        {
          return [0x116D];
        }
      case 0x315C:
        {
          return [0x116E];
        }
      case 0x315D:
        {
          return [0x116F];
        }
      case 0x315E:
        {
          return [0x1170];
        }
      case 0x315F:
        {
          return [0x1171];
        }
      case 0x3160:
        {
          return [0x1172];
        }
      case 0x3161:
        {
          return [0x1173];
        }
      case 0x3162:
        {
          return [0x1174];
        }
      case 0x3163:
        {
          return [0x1175];
        }
      case 0x3164:
        {
          return [0x1160];
        }
      case 0x3165:
        {
          return [0x1114];
        }
      case 0x3166:
        {
          return [0x1115];
        }
      case 0x3167:
        {
          return [0x11C7];
        }
      case 0x3168:
        {
          return [0x11C8];
        }
      case 0x3169:
        {
          return [0x11CC];
        }
      case 0x316A:
        {
          return [0x11CE];
        }
      case 0x316B:
        {
          return [0x11D3];
        }
      case 0x316C:
        {
          return [0x11D7];
        }
      case 0x316D:
        {
          return [0x11D9];
        }
      case 0x316E:
        {
          return [0x111C];
        }
      case 0x316F:
        {
          return [0x11DD];
        }
      case 0x3170:
        {
          return [0x11DF];
        }
      case 0x3171:
        {
          return [0x111D];
        }
      case 0x3172:
        {
          return [0x111E];
        }
      case 0x3173:
        {
          return [0x1120];
        }
      case 0x3174:
        {
          return [0x1122];
        }
      case 0x3175:
        {
          return [0x1123];
        }
      case 0x3176:
        {
          return [0x1127];
        }
      case 0x3177:
        {
          return [0x1129];
        }
      case 0x3178:
        {
          return [0x112B];
        }
      case 0x3179:
        {
          return [0x112C];
        }
      case 0x317A:
        {
          return [0x112D];
        }
      case 0x317B:
        {
          return [0x112E];
        }
      case 0x317C:
        {
          return [0x112F];
        }
      case 0x317D:
        {
          return [0x1132];
        }
      case 0x317E:
        {
          return [0x1136];
        }
      case 0x317F:
        {
          return [0x1140];
        }
      case 0x3180:
        {
          return [0x1147];
        }
      case 0x3181:
        {
          return [0x114C];
        }
      case 0x3182:
        {
          return [0x11F1];
        }
      case 0x3183:
        {
          return [0x11F2];
        }
      case 0x3184:
        {
          return [0x1157];
        }
      case 0x3185:
        {
          return [0x1158];
        }
      case 0x3186:
        {
          return [0x1159];
        }
      case 0x3187:
        {
          return [0x1184];
        }
      case 0x3188:
        {
          return [0x1185];
        }
      case 0x3189:
        {
          return [0x1188];
        }
      case 0x318A:
        {
          return [0x1191];
        }
      case 0x318B:
        {
          return [0x1192];
        }
      case 0x318C:
        {
          return [0x1194];
        }
      case 0x318D:
        {
          return [0x119E];
        }
      case 0x318E:
        {
          return [0x11A1];
        }
      case 0x3192:
        {
          return [0x4E00];
        }
      case 0x3193:
        {
          return [0x4E8C];
        }
      case 0x3194:
        {
          return [0x4E09];
        }
      case 0x3195:
        {
          return [0x56DB];
        }
      case 0x3196:
        {
          return [0x4E0A];
        }
      case 0x3197:
        {
          return [0x4E2D];
        }
      case 0x3198:
        {
          return [0x4E0B];
        }
      case 0x3199:
        {
          return [0x7532];
        }
      case 0x319A:
        {
          return [0x4E59];
        }
      case 0x319B:
        {
          return [0x4E19];
        }
      case 0x319C:
        {
          return [0x4E01];
        }
      case 0x319D:
        {
          return [0x5929];
        }
      case 0x319E:
        {
          return [0x5730];
        }
      case 0x319F:
        {
          return [0x4EBA];
        }
      case 0x3200:
        {
          return [0x0028, 0x1100, 0x0029];
        }
      case 0x3201:
        {
          return [0x0028, 0x1102, 0x0029];
        }
      case 0x3202:
        {
          return [0x0028, 0x1103, 0x0029];
        }
      case 0x3203:
        {
          return [0x0028, 0x1105, 0x0029];
        }
      case 0x3204:
        {
          return [0x0028, 0x1106, 0x0029];
        }
      case 0x3205:
        {
          return [0x0028, 0x1107, 0x0029];
        }
      case 0x3206:
        {
          return [0x0028, 0x1109, 0x0029];
        }
      case 0x3207:
        {
          return [0x0028, 0x110B, 0x0029];
        }
      case 0x3208:
        {
          return [0x0028, 0x110C, 0x0029];
        }
      case 0x3209:
        {
          return [0x0028, 0x110E, 0x0029];
        }
      case 0x320A:
        {
          return [0x0028, 0x110F, 0x0029];
        }
      case 0x320B:
        {
          return [0x0028, 0x1110, 0x0029];
        }
      case 0x320C:
        {
          return [0x0028, 0x1111, 0x0029];
        }
      case 0x320D:
        {
          return [0x0028, 0x1112, 0x0029];
        }
      case 0x320E:
        {
          return [0x0028, 0x1100, 0x1161, 0x0029];
        }
      case 0x320F:
        {
          return [0x0028, 0x1102, 0x1161, 0x0029];
        }
      case 0x3210:
        {
          return [0x0028, 0x1103, 0x1161, 0x0029];
        }
      case 0x3211:
        {
          return [0x0028, 0x1105, 0x1161, 0x0029];
        }
      case 0x3212:
        {
          return [0x0028, 0x1106, 0x1161, 0x0029];
        }
      case 0x3213:
        {
          return [0x0028, 0x1107, 0x1161, 0x0029];
        }
      case 0x3214:
        {
          return [0x0028, 0x1109, 0x1161, 0x0029];
        }
      case 0x3215:
        {
          return [0x0028, 0x110B, 0x1161, 0x0029];
        }
      case 0x3216:
        {
          return [0x0028, 0x110C, 0x1161, 0x0029];
        }
      case 0x3217:
        {
          return [0x0028, 0x110E, 0x1161, 0x0029];
        }
      case 0x3218:
        {
          return [0x0028, 0x110F, 0x1161, 0x0029];
        }
      case 0x3219:
        {
          return [0x0028, 0x1110, 0x1161, 0x0029];
        }
      case 0x321A:
        {
          return [0x0028, 0x1111, 0x1161, 0x0029];
        }
      case 0x321B:
        {
          return [0x0028, 0x1112, 0x1161, 0x0029];
        }
      case 0x321C:
        {
          return [0x0028, 0x110C, 0x116E, 0x0029];
        }
      case 0x321D:
        {
          return [0x0028, 0x110B, 0x1169, 0x110C, 0x1165, 0x11AB, 0x0029];
        }
      case 0x321E:
        {
          return [0x0028, 0x110B, 0x1169, 0x1112, 0x116E, 0x0029];
        }
      case 0x3220:
        {
          return [0x0028, 0x4E00, 0x0029];
        }
      case 0x3221:
        {
          return [0x0028, 0x4E8C, 0x0029];
        }
      case 0x3222:
        {
          return [0x0028, 0x4E09, 0x0029];
        }
      case 0x3223:
        {
          return [0x0028, 0x56DB, 0x0029];
        }
      case 0x3224:
        {
          return [0x0028, 0x4E94, 0x0029];
        }
      case 0x3225:
        {
          return [0x0028, 0x516D, 0x0029];
        }
      case 0x3226:
        {
          return [0x0028, 0x4E03, 0x0029];
        }
      case 0x3227:
        {
          return [0x0028, 0x516B, 0x0029];
        }
      case 0x3228:
        {
          return [0x0028, 0x4E5D, 0x0029];
        }
      case 0x3229:
        {
          return [0x0028, 0x5341, 0x0029];
        }
      case 0x322A:
        {
          return [0x0028, 0x6708, 0x0029];
        }
      case 0x322B:
        {
          return [0x0028, 0x706B, 0x0029];
        }
      case 0x322C:
        {
          return [0x0028, 0x6C34, 0x0029];
        }
      case 0x322D:
        {
          return [0x0028, 0x6728, 0x0029];
        }
      case 0x322E:
        {
          return [0x0028, 0x91D1, 0x0029];
        }
      case 0x322F:
        {
          return [0x0028, 0x571F, 0x0029];
        }
      case 0x3230:
        {
          return [0x0028, 0x65E5, 0x0029];
        }
      case 0x3231:
        {
          return [0x0028, 0x682A, 0x0029];
        }
      case 0x3232:
        {
          return [0x0028, 0x6709, 0x0029];
        }
      case 0x3233:
        {
          return [0x0028, 0x793E, 0x0029];
        }
      case 0x3234:
        {
          return [0x0028, 0x540D, 0x0029];
        }
      case 0x3235:
        {
          return [0x0028, 0x7279, 0x0029];
        }
      case 0x3236:
        {
          return [0x0028, 0x8CA1, 0x0029];
        }
      case 0x3237:
        {
          return [0x0028, 0x795D, 0x0029];
        }
      case 0x3238:
        {
          return [0x0028, 0x52B4, 0x0029];
        }
      case 0x3239:
        {
          return [0x0028, 0x4EE3, 0x0029];
        }
      case 0x323A:
        {
          return [0x0028, 0x547C, 0x0029];
        }
      case 0x323B:
        {
          return [0x0028, 0x5B66, 0x0029];
        }
      case 0x323C:
        {
          return [0x0028, 0x76E3, 0x0029];
        }
      case 0x323D:
        {
          return [0x0028, 0x4F01, 0x0029];
        }
      case 0x323E:
        {
          return [0x0028, 0x8CC7, 0x0029];
        }
      case 0x323F:
        {
          return [0x0028, 0x5354, 0x0029];
        }
      case 0x3240:
        {
          return [0x0028, 0x796D, 0x0029];
        }
      case 0x3241:
        {
          return [0x0028, 0x4F11, 0x0029];
        }
      case 0x3242:
        {
          return [0x0028, 0x81EA, 0x0029];
        }
      case 0x3243:
        {
          return [0x0028, 0x81F3, 0x0029];
        }
      case 0x3250:
        {
          return [0x0050, 0x0054, 0x0045];
        }
      case 0x3251:
        {
          return [0x0032, 0x0031];
        }
      case 0x3252:
        {
          return [0x0032, 0x0032];
        }
      case 0x3253:
        {
          return [0x0032, 0x0033];
        }
      case 0x3254:
        {
          return [0x0032, 0x0034];
        }
      case 0x3255:
        {
          return [0x0032, 0x0035];
        }
      case 0x3256:
        {
          return [0x0032, 0x0036];
        }
      case 0x3257:
        {
          return [0x0032, 0x0037];
        }
      case 0x3258:
        {
          return [0x0032, 0x0038];
        }
      case 0x3259:
        {
          return [0x0032, 0x0039];
        }
      case 0x325A:
        {
          return [0x0033, 0x0030];
        }
      case 0x325B:
        {
          return [0x0033, 0x0031];
        }
      case 0x325C:
        {
          return [0x0033, 0x0032];
        }
      case 0x325D:
        {
          return [0x0033, 0x0033];
        }
      case 0x325E:
        {
          return [0x0033, 0x0034];
        }
      case 0x325F:
        {
          return [0x0033, 0x0035];
        }
      case 0x3260:
        {
          return [0x1100];
        }
      case 0x3261:
        {
          return [0x1102];
        }
      case 0x3262:
        {
          return [0x1103];
        }
      case 0x3263:
        {
          return [0x1105];
        }
      case 0x3264:
        {
          return [0x1106];
        }
      case 0x3265:
        {
          return [0x1107];
        }
      case 0x3266:
        {
          return [0x1109];
        }
      case 0x3267:
        {
          return [0x110B];
        }
      case 0x3268:
        {
          return [0x110C];
        }
      case 0x3269:
        {
          return [0x110E];
        }
      case 0x326A:
        {
          return [0x110F];
        }
      case 0x326B:
        {
          return [0x1110];
        }
      case 0x326C:
        {
          return [0x1111];
        }
      case 0x326D:
        {
          return [0x1112];
        }
      case 0x326E:
        {
          return [0x1100, 0x1161];
        }
      case 0x326F:
        {
          return [0x1102, 0x1161];
        }
      case 0x3270:
        {
          return [0x1103, 0x1161];
        }
      case 0x3271:
        {
          return [0x1105, 0x1161];
        }
      case 0x3272:
        {
          return [0x1106, 0x1161];
        }
      case 0x3273:
        {
          return [0x1107, 0x1161];
        }
      case 0x3274:
        {
          return [0x1109, 0x1161];
        }
      case 0x3275:
        {
          return [0x110B, 0x1161];
        }
      case 0x3276:
        {
          return [0x110C, 0x1161];
        }
      case 0x3277:
        {
          return [0x110E, 0x1161];
        }
      case 0x3278:
        {
          return [0x110F, 0x1161];
        }
      case 0x3279:
        {
          return [0x1110, 0x1161];
        }
      case 0x327A:
        {
          return [0x1111, 0x1161];
        }
      case 0x327B:
        {
          return [0x1112, 0x1161];
        }
      case 0x327C:
        {
          return [0x110E, 0x1161, 0x11B7, 0x1100, 0x1169];
        }
      case 0x327D:
        {
          return [0x110C, 0x116E, 0x110B, 0x1174];
        }
      case 0x327E:
        {
          return [0x110B, 0x116E];
        }
      case 0x3280:
        {
          return [0x4E00];
        }
      case 0x3281:
        {
          return [0x4E8C];
        }
      case 0x3282:
        {
          return [0x4E09];
        }
      case 0x3283:
        {
          return [0x56DB];
        }
      case 0x3284:
        {
          return [0x4E94];
        }
      case 0x3285:
        {
          return [0x516D];
        }
      case 0x3286:
        {
          return [0x4E03];
        }
      case 0x3287:
        {
          return [0x516B];
        }
      case 0x3288:
        {
          return [0x4E5D];
        }
      case 0x3289:
        {
          return [0x5341];
        }
      case 0x328A:
        {
          return [0x6708];
        }
      case 0x328B:
        {
          return [0x706B];
        }
      case 0x328C:
        {
          return [0x6C34];
        }
      case 0x328D:
        {
          return [0x6728];
        }
      case 0x328E:
        {
          return [0x91D1];
        }
      case 0x328F:
        {
          return [0x571F];
        }
      case 0x3290:
        {
          return [0x65E5];
        }
      case 0x3291:
        {
          return [0x682A];
        }
      case 0x3292:
        {
          return [0x6709];
        }
      case 0x3293:
        {
          return [0x793E];
        }
      case 0x3294:
        {
          return [0x540D];
        }
      case 0x3295:
        {
          return [0x7279];
        }
      case 0x3296:
        {
          return [0x8CA1];
        }
      case 0x3297:
        {
          return [0x795D];
        }
      case 0x3298:
        {
          return [0x52B4];
        }
      case 0x3299:
        {
          return [0x79D8];
        }
      case 0x329A:
        {
          return [0x7537];
        }
      case 0x329B:
        {
          return [0x5973];
        }
      case 0x329C:
        {
          return [0x9069];
        }
      case 0x329D:
        {
          return [0x512A];
        }
      case 0x329E:
        {
          return [0x5370];
        }
      case 0x329F:
        {
          return [0x6CE8];
        }
      case 0x32A0:
        {
          return [0x9805];
        }
      case 0x32A1:
        {
          return [0x4F11];
        }
      case 0x32A2:
        {
          return [0x5199];
        }
      case 0x32A3:
        {
          return [0x6B63];
        }
      case 0x32A4:
        {
          return [0x4E0A];
        }
      case 0x32A5:
        {
          return [0x4E2D];
        }
      case 0x32A6:
        {
          return [0x4E0B];
        }
      case 0x32A7:
        {
          return [0x5DE6];
        }
      case 0x32A8:
        {
          return [0x53F3];
        }
      case 0x32A9:
        {
          return [0x533B];
        }
      case 0x32AA:
        {
          return [0x5B97];
        }
      case 0x32AB:
        {
          return [0x5B66];
        }
      case 0x32AC:
        {
          return [0x76E3];
        }
      case 0x32AD:
        {
          return [0x4F01];
        }
      case 0x32AE:
        {
          return [0x8CC7];
        }
      case 0x32AF:
        {
          return [0x5354];
        }
      case 0x32B0:
        {
          return [0x591C];
        }
      case 0x32B1:
        {
          return [0x0033, 0x0036];
        }
      case 0x32B2:
        {
          return [0x0033, 0x0037];
        }
      case 0x32B3:
        {
          return [0x0033, 0x0038];
        }
      case 0x32B4:
        {
          return [0x0033, 0x0039];
        }
      case 0x32B5:
        {
          return [0x0034, 0x0030];
        }
      case 0x32B6:
        {
          return [0x0034, 0x0031];
        }
      case 0x32B7:
        {
          return [0x0034, 0x0032];
        }
      case 0x32B8:
        {
          return [0x0034, 0x0033];
        }
      case 0x32B9:
        {
          return [0x0034, 0x0034];
        }
      case 0x32BA:
        {
          return [0x0034, 0x0035];
        }
      case 0x32BB:
        {
          return [0x0034, 0x0036];
        }
      case 0x32BC:
        {
          return [0x0034, 0x0037];
        }
      case 0x32BD:
        {
          return [0x0034, 0x0038];
        }
      case 0x32BE:
        {
          return [0x0034, 0x0039];
        }
      case 0x32BF:
        {
          return [0x0035, 0x0030];
        }
      case 0x32C0:
        {
          return [0x0031, 0x6708];
        }
      case 0x32C1:
        {
          return [0x0032, 0x6708];
        }
      case 0x32C2:
        {
          return [0x0033, 0x6708];
        }
      case 0x32C3:
        {
          return [0x0034, 0x6708];
        }
      case 0x32C4:
        {
          return [0x0035, 0x6708];
        }
      case 0x32C5:
        {
          return [0x0036, 0x6708];
        }
      case 0x32C6:
        {
          return [0x0037, 0x6708];
        }
      case 0x32C7:
        {
          return [0x0038, 0x6708];
        }
      case 0x32C8:
        {
          return [0x0039, 0x6708];
        }
      case 0x32C9:
        {
          return [0x0031, 0x0030, 0x6708];
        }
      case 0x32CA:
        {
          return [0x0031, 0x0031, 0x6708];
        }
      case 0x32CB:
        {
          return [0x0031, 0x0032, 0x6708];
        }
      case 0x32CC:
        {
          return [0x0048, 0x0067];
        }
      case 0x32CD:
        {
          return [0x0065, 0x0072, 0x0067];
        }
      case 0x32CE:
        {
          return [0x0065, 0x0056];
        }
      case 0x32CF:
        {
          return [0x004C, 0x0054, 0x0044];
        }
      case 0x32D0:
        {
          return [0x30A2];
        }
      case 0x32D1:
        {
          return [0x30A4];
        }
      case 0x32D2:
        {
          return [0x30A6];
        }
      case 0x32D3:
        {
          return [0x30A8];
        }
      case 0x32D4:
        {
          return [0x30AA];
        }
      case 0x32D5:
        {
          return [0x30AB];
        }
      case 0x32D6:
        {
          return [0x30AD];
        }
      case 0x32D7:
        {
          return [0x30AF];
        }
      case 0x32D8:
        {
          return [0x30B1];
        }
      case 0x32D9:
        {
          return [0x30B3];
        }
      case 0x32DA:
        {
          return [0x30B5];
        }
      case 0x32DB:
        {
          return [0x30B7];
        }
      case 0x32DC:
        {
          return [0x30B9];
        }
      case 0x32DD:
        {
          return [0x30BB];
        }
      case 0x32DE:
        {
          return [0x30BD];
        }
      case 0x32DF:
        {
          return [0x30BF];
        }
      case 0x32E0:
        {
          return [0x30C1];
        }
      case 0x32E1:
        {
          return [0x30C4];
        }
      case 0x32E2:
        {
          return [0x30C6];
        }
      case 0x32E3:
        {
          return [0x30C8];
        }
      case 0x32E4:
        {
          return [0x30CA];
        }
      case 0x32E5:
        {
          return [0x30CB];
        }
      case 0x32E6:
        {
          return [0x30CC];
        }
      case 0x32E7:
        {
          return [0x30CD];
        }
      case 0x32E8:
        {
          return [0x30CE];
        }
      case 0x32E9:
        {
          return [0x30CF];
        }
      case 0x32EA:
        {
          return [0x30D2];
        }
      case 0x32EB:
        {
          return [0x30D5];
        }
      case 0x32EC:
        {
          return [0x30D8];
        }
      case 0x32ED:
        {
          return [0x30DB];
        }
      case 0x32EE:
        {
          return [0x30DE];
        }
      case 0x32EF:
        {
          return [0x30DF];
        }
      case 0x32F0:
        {
          return [0x30E0];
        }
      case 0x32F1:
        {
          return [0x30E1];
        }
      case 0x32F2:
        {
          return [0x30E2];
        }
      case 0x32F3:
        {
          return [0x30E4];
        }
      case 0x32F4:
        {
          return [0x30E6];
        }
      case 0x32F5:
        {
          return [0x30E8];
        }
      case 0x32F6:
        {
          return [0x30E9];
        }
      case 0x32F7:
        {
          return [0x30EA];
        }
      case 0x32F8:
        {
          return [0x30EB];
        }
      case 0x32F9:
        {
          return [0x30EC];
        }
      case 0x32FA:
        {
          return [0x30ED];
        }
      case 0x32FB:
        {
          return [0x30EF];
        }
      case 0x32FC:
        {
          return [0x30F0];
        }
      case 0x32FD:
        {
          return [0x30F1];
        }
      case 0x32FE:
        {
          return [0x30F2];
        }
      case 0x3300:
        {
          return [0x30A2, 0x30D1, 0x30FC, 0x30C8];
        }
      case 0x3301:
        {
          return [0x30A2, 0x30EB, 0x30D5, 0x30A1];
        }
      case 0x3302:
        {
          return [0x30A2, 0x30F3, 0x30DA, 0x30A2];
        }
      case 0x3303:
        {
          return [0x30A2, 0x30FC, 0x30EB];
        }
      case 0x3304:
        {
          return [0x30A4, 0x30CB, 0x30F3, 0x30B0];
        }
      case 0x3305:
        {
          return [0x30A4, 0x30F3, 0x30C1];
        }
      case 0x3306:
        {
          return [0x30A6, 0x30A9, 0x30F3];
        }
      case 0x3307:
        {
          return [0x30A8, 0x30B9, 0x30AF, 0x30FC, 0x30C9];
        }
      case 0x3308:
        {
          return [0x30A8, 0x30FC, 0x30AB, 0x30FC];
        }
      case 0x3309:
        {
          return [0x30AA, 0x30F3, 0x30B9];
        }
      case 0x330A:
        {
          return [0x30AA, 0x30FC, 0x30E0];
        }
      case 0x330B:
        {
          return [0x30AB, 0x30A4, 0x30EA];
        }
      case 0x330C:
        {
          return [0x30AB, 0x30E9, 0x30C3, 0x30C8];
        }
      case 0x330D:
        {
          return [0x30AB, 0x30ED, 0x30EA, 0x30FC];
        }
      case 0x330E:
        {
          return [0x30AC, 0x30ED, 0x30F3];
        }
      case 0x330F:
        {
          return [0x30AC, 0x30F3, 0x30DE];
        }
      case 0x3310:
        {
          return [0x30AE, 0x30AC];
        }
      case 0x3311:
        {
          return [0x30AE, 0x30CB, 0x30FC];
        }
      case 0x3312:
        {
          return [0x30AD, 0x30E5, 0x30EA, 0x30FC];
        }
      case 0x3313:
        {
          return [0x30AE, 0x30EB, 0x30C0, 0x30FC];
        }
      case 0x3314:
        {
          return [0x30AD, 0x30ED];
        }
      case 0x3315:
        {
          return [0x30AD, 0x30ED, 0x30B0, 0x30E9, 0x30E0];
        }
      case 0x3316:
        {
          return [0x30AD, 0x30ED, 0x30E1, 0x30FC, 0x30C8, 0x30EB];
        }
      case 0x3317:
        {
          return [0x30AD, 0x30ED, 0x30EF, 0x30C3, 0x30C8];
        }
      case 0x3318:
        {
          return [0x30B0, 0x30E9, 0x30E0];
        }
      case 0x3319:
        {
          return [0x30B0, 0x30E9, 0x30E0, 0x30C8, 0x30F3];
        }
      case 0x331A:
        {
          return [0x30AF, 0x30EB, 0x30BC, 0x30A4, 0x30ED];
        }
      case 0x331B:
        {
          return [0x30AF, 0x30ED, 0x30FC, 0x30CD];
        }
      case 0x331C:
        {
          return [0x30B1, 0x30FC, 0x30B9];
        }
      case 0x331D:
        {
          return [0x30B3, 0x30EB, 0x30CA];
        }
      case 0x331E:
        {
          return [0x30B3, 0x30FC, 0x30DD];
        }
      case 0x331F:
        {
          return [0x30B5, 0x30A4, 0x30AF, 0x30EB];
        }
      case 0x3320:
        {
          return [0x30B5, 0x30F3, 0x30C1, 0x30FC, 0x30E0];
        }
      case 0x3321:
        {
          return [0x30B7, 0x30EA, 0x30F3, 0x30B0];
        }
      case 0x3322:
        {
          return [0x30BB, 0x30F3, 0x30C1];
        }
      case 0x3323:
        {
          return [0x30BB, 0x30F3, 0x30C8];
        }
      case 0x3324:
        {
          return [0x30C0, 0x30FC, 0x30B9];
        }
      case 0x3325:
        {
          return [0x30C7, 0x30B7];
        }
      case 0x3326:
        {
          return [0x30C9, 0x30EB];
        }
      case 0x3327:
        {
          return [0x30C8, 0x30F3];
        }
      case 0x3328:
        {
          return [0x30CA, 0x30CE];
        }
      case 0x3329:
        {
          return [0x30CE, 0x30C3, 0x30C8];
        }
      case 0x332A:
        {
          return [0x30CF, 0x30A4, 0x30C4];
        }
      case 0x332B:
        {
          return [0x30D1, 0x30FC, 0x30BB, 0x30F3, 0x30C8];
        }
      case 0x332C:
        {
          return [0x30D1, 0x30FC, 0x30C4];
        }
      case 0x332D:
        {
          return [0x30D0, 0x30FC, 0x30EC, 0x30EB];
        }
      case 0x332E:
        {
          return [0x30D4, 0x30A2, 0x30B9, 0x30C8, 0x30EB];
        }
      case 0x332F:
        {
          return [0x30D4, 0x30AF, 0x30EB];
        }
      case 0x3330:
        {
          return [0x30D4, 0x30B3];
        }
      case 0x3331:
        {
          return [0x30D3, 0x30EB];
        }
      case 0x3332:
        {
          return [0x30D5, 0x30A1, 0x30E9, 0x30C3, 0x30C9];
        }
      case 0x3333:
        {
          return [0x30D5, 0x30A3, 0x30FC, 0x30C8];
        }
      case 0x3334:
        {
          return [0x30D6, 0x30C3, 0x30B7, 0x30A7, 0x30EB];
        }
      case 0x3335:
        {
          return [0x30D5, 0x30E9, 0x30F3];
        }
      case 0x3336:
        {
          return [0x30D8, 0x30AF, 0x30BF, 0x30FC, 0x30EB];
        }
      case 0x3337:
        {
          return [0x30DA, 0x30BD];
        }
      case 0x3338:
        {
          return [0x30DA, 0x30CB, 0x30D2];
        }
      case 0x3339:
        {
          return [0x30D8, 0x30EB, 0x30C4];
        }
      case 0x333A:
        {
          return [0x30DA, 0x30F3, 0x30B9];
        }
      case 0x333B:
        {
          return [0x30DA, 0x30FC, 0x30B8];
        }
      case 0x333C:
        {
          return [0x30D9, 0x30FC, 0x30BF];
        }
      case 0x333D:
        {
          return [0x30DD, 0x30A4, 0x30F3, 0x30C8];
        }
      case 0x333E:
        {
          return [0x30DC, 0x30EB, 0x30C8];
        }
      case 0x333F:
        {
          return [0x30DB, 0x30F3];
        }
      case 0x3340:
        {
          return [0x30DD, 0x30F3, 0x30C9];
        }
      case 0x3341:
        {
          return [0x30DB, 0x30FC, 0x30EB];
        }
      case 0x3342:
        {
          return [0x30DB, 0x30FC, 0x30F3];
        }
      case 0x3343:
        {
          return [0x30DE, 0x30A4, 0x30AF, 0x30ED];
        }
      case 0x3344:
        {
          return [0x30DE, 0x30A4, 0x30EB];
        }
      case 0x3345:
        {
          return [0x30DE, 0x30C3, 0x30CF];
        }
      case 0x3346:
        {
          return [0x30DE, 0x30EB, 0x30AF];
        }
      case 0x3347:
        {
          return [0x30DE, 0x30F3, 0x30B7, 0x30E7, 0x30F3];
        }
      case 0x3348:
        {
          return [0x30DF, 0x30AF, 0x30ED, 0x30F3];
        }
      case 0x3349:
        {
          return [0x30DF, 0x30EA];
        }
      case 0x334A:
        {
          return [0x30DF, 0x30EA, 0x30D0, 0x30FC, 0x30EB];
        }
      case 0x334B:
        {
          return [0x30E1, 0x30AC];
        }
      case 0x334C:
        {
          return [0x30E1, 0x30AC, 0x30C8, 0x30F3];
        }
      case 0x334D:
        {
          return [0x30E1, 0x30FC, 0x30C8, 0x30EB];
        }
      case 0x334E:
        {
          return [0x30E4, 0x30FC, 0x30C9];
        }
      case 0x334F:
        {
          return [0x30E4, 0x30FC, 0x30EB];
        }
      case 0x3350:
        {
          return [0x30E6, 0x30A2, 0x30F3];
        }
      case 0x3351:
        {
          return [0x30EA, 0x30C3, 0x30C8, 0x30EB];
        }
      case 0x3352:
        {
          return [0x30EA, 0x30E9];
        }
      case 0x3353:
        {
          return [0x30EB, 0x30D4, 0x30FC];
        }
      case 0x3354:
        {
          return [0x30EB, 0x30FC, 0x30D6, 0x30EB];
        }
      case 0x3355:
        {
          return [0x30EC, 0x30E0];
        }
      case 0x3356:
        {
          return [0x30EC, 0x30F3, 0x30C8, 0x30B2, 0x30F3];
        }
      case 0x3357:
        {
          return [0x30EF, 0x30C3, 0x30C8];
        }
      case 0x3358:
        {
          return [0x0030, 0x70B9];
        }
      case 0x3359:
        {
          return [0x0031, 0x70B9];
        }
      case 0x335A:
        {
          return [0x0032, 0x70B9];
        }
      case 0x335B:
        {
          return [0x0033, 0x70B9];
        }
      case 0x335C:
        {
          return [0x0034, 0x70B9];
        }
      case 0x335D:
        {
          return [0x0035, 0x70B9];
        }
      case 0x335E:
        {
          return [0x0036, 0x70B9];
        }
      case 0x335F:
        {
          return [0x0037, 0x70B9];
        }
      case 0x3360:
        {
          return [0x0038, 0x70B9];
        }
      case 0x3361:
        {
          return [0x0039, 0x70B9];
        }
      case 0x3362:
        {
          return [0x0031, 0x0030, 0x70B9];
        }
      case 0x3363:
        {
          return [0x0031, 0x0031, 0x70B9];
        }
      case 0x3364:
        {
          return [0x0031, 0x0032, 0x70B9];
        }
      case 0x3365:
        {
          return [0x0031, 0x0033, 0x70B9];
        }
      case 0x3366:
        {
          return [0x0031, 0x0034, 0x70B9];
        }
      case 0x3367:
        {
          return [0x0031, 0x0035, 0x70B9];
        }
      case 0x3368:
        {
          return [0x0031, 0x0036, 0x70B9];
        }
      case 0x3369:
        {
          return [0x0031, 0x0037, 0x70B9];
        }
      case 0x336A:
        {
          return [0x0031, 0x0038, 0x70B9];
        }
      case 0x336B:
        {
          return [0x0031, 0x0039, 0x70B9];
        }
      case 0x336C:
        {
          return [0x0032, 0x0030, 0x70B9];
        }
      case 0x336D:
        {
          return [0x0032, 0x0031, 0x70B9];
        }
      case 0x336E:
        {
          return [0x0032, 0x0032, 0x70B9];
        }
      case 0x336F:
        {
          return [0x0032, 0x0033, 0x70B9];
        }
      case 0x3370:
        {
          return [0x0032, 0x0034, 0x70B9];
        }
      case 0x3371:
        {
          return [0x0068, 0x0050, 0x0061];
        }
      case 0x3372:
        {
          return [0x0064, 0x0061];
        }
      case 0x3373:
        {
          return [0x0041, 0x0055];
        }
      case 0x3374:
        {
          return [0x0062, 0x0061, 0x0072];
        }
      case 0x3375:
        {
          return [0x006F, 0x0056];
        }
      case 0x3376:
        {
          return [0x0070, 0x0063];
        }
      case 0x3377:
        {
          return [0x0064, 0x006D];
        }
      case 0x3378:
        {
          return [0x0064, 0x006D, 0x00B2];
        }
      case 0x3379:
        {
          return [0x0064, 0x006D, 0x00B3];
        }
      case 0x337A:
        {
          return [0x0049, 0x0055];
        }
      case 0x337B:
        {
          return [0x5E73, 0x6210];
        }
      case 0x337C:
        {
          return [0x662D, 0x548C];
        }
      case 0x337D:
        {
          return [0x5927, 0x6B63];
        }
      case 0x337E:
        {
          return [0x660E, 0x6CBB];
        }
      case 0x337F:
        {
          return [0x682A, 0x5F0F, 0x4F1A, 0x793E];
        }
      case 0x3380:
        {
          return [0x0070, 0x0041];
        }
      case 0x3381:
        {
          return [0x006E, 0x0041];
        }
      case 0x3382:
        {
          return [0x03BC, 0x0041];
        }
      case 0x3383:
        {
          return [0x006D, 0x0041];
        }
      case 0x3384:
        {
          return [0x006B, 0x0041];
        }
      case 0x3385:
        {
          return [0x004B, 0x0042];
        }
      case 0x3386:
        {
          return [0x004D, 0x0042];
        }
      case 0x3387:
        {
          return [0x0047, 0x0042];
        }
      case 0x3388:
        {
          return [0x0063, 0x0061, 0x006C];
        }
      case 0x3389:
        {
          return [0x006B, 0x0063, 0x0061, 0x006C];
        }
      case 0x338A:
        {
          return [0x0070, 0x0046];
        }
      case 0x338B:
        {
          return [0x006E, 0x0046];
        }
      case 0x338C:
        {
          return [0x03BC, 0x0046];
        }
      case 0x338D:
        {
          return [0x03BC, 0x0067];
        }
      case 0x338E:
        {
          return [0x006D, 0x0067];
        }
      case 0x338F:
        {
          return [0x006B, 0x0067];
        }
      case 0x3390:
        {
          return [0x0048, 0x007A];
        }
      case 0x3391:
        {
          return [0x006B, 0x0048, 0x007A];
        }
      case 0x3392:
        {
          return [0x004D, 0x0048, 0x007A];
        }
      case 0x3393:
        {
          return [0x0047, 0x0048, 0x007A];
        }
      case 0x3394:
        {
          return [0x0054, 0x0048, 0x007A];
        }
      case 0x3395:
        {
          return [0x03BC, 0x2113];
        }
      case 0x3396:
        {
          return [0x006D, 0x2113];
        }
      case 0x3397:
        {
          return [0x0064, 0x2113];
        }
      case 0x3398:
        {
          return [0x006B, 0x2113];
        }
      case 0x3399:
        {
          return [0x0066, 0x006D];
        }
      case 0x339A:
        {
          return [0x006E, 0x006D];
        }
      case 0x339B:
        {
          return [0x03BC, 0x006D];
        }
      case 0x339C:
        {
          return [0x006D, 0x006D];
        }
      case 0x339D:
        {
          return [0x0063, 0x006D];
        }
      case 0x339E:
        {
          return [0x006B, 0x006D];
        }
      case 0x339F:
        {
          return [0x006D, 0x006D, 0x00B2];
        }
      case 0x33A0:
        {
          return [0x0063, 0x006D, 0x00B2];
        }
      case 0x33A1:
        {
          return [0x006D, 0x00B2];
        }
      case 0x33A2:
        {
          return [0x006B, 0x006D, 0x00B2];
        }
      case 0x33A3:
        {
          return [0x006D, 0x006D, 0x00B3];
        }
      case 0x33A4:
        {
          return [0x0063, 0x006D, 0x00B3];
        }
      case 0x33A5:
        {
          return [0x006D, 0x00B3];
        }
      case 0x33A6:
        {
          return [0x006B, 0x006D, 0x00B3];
        }
      case 0x33A7:
        {
          return [0x006D, 0x2215, 0x0073];
        }
      case 0x33A8:
        {
          return [0x006D, 0x2215, 0x0073, 0x00B2];
        }
      case 0x33A9:
        {
          return [0x0050, 0x0061];
        }
      case 0x33AA:
        {
          return [0x006B, 0x0050, 0x0061];
        }
      case 0x33AB:
        {
          return [0x004D, 0x0050, 0x0061];
        }
      case 0x33AC:
        {
          return [0x0047, 0x0050, 0x0061];
        }
      case 0x33AD:
        {
          return [0x0072, 0x0061, 0x0064];
        }
      case 0x33AE:
        {
          return [0x0072, 0x0061, 0x0064, 0x2215, 0x0073];
        }
      case 0x33AF:
        {
          return [0x0072, 0x0061, 0x0064, 0x2215, 0x0073, 0x00B2];
        }
      case 0x33B0:
        {
          return [0x0070, 0x0073];
        }
      case 0x33B1:
        {
          return [0x006E, 0x0073];
        }
      case 0x33B2:
        {
          return [0x03BC, 0x0073];
        }
      case 0x33B3:
        {
          return [0x006D, 0x0073];
        }
      case 0x33B4:
        {
          return [0x0070, 0x0056];
        }
      case 0x33B5:
        {
          return [0x006E, 0x0056];
        }
      case 0x33B6:
        {
          return [0x03BC, 0x0056];
        }
      case 0x33B7:
        {
          return [0x006D, 0x0056];
        }
      case 0x33B8:
        {
          return [0x006B, 0x0056];
        }
      case 0x33B9:
        {
          return [0x004D, 0x0056];
        }
      case 0x33BA:
        {
          return [0x0070, 0x0057];
        }
      case 0x33BB:
        {
          return [0x006E, 0x0057];
        }
      case 0x33BC:
        {
          return [0x03BC, 0x0057];
        }
      case 0x33BD:
        {
          return [0x006D, 0x0057];
        }
      case 0x33BE:
        {
          return [0x006B, 0x0057];
        }
      case 0x33BF:
        {
          return [0x004D, 0x0057];
        }
      case 0x33C0:
        {
          return [0x006B, 0x03A9];
        }
      case 0x33C1:
        {
          return [0x004D, 0x03A9];
        }
      case 0x33C2:
        {
          return [0x0061, 0x002E, 0x006D, 0x002E];
        }
      case 0x33C3:
        {
          return [0x0042, 0x0071];
        }
      case 0x33C4:
        {
          return [0x0063, 0x0063];
        }
      case 0x33C5:
        {
          return [0x0063, 0x0064];
        }
      case 0x33C6:
        {
          return [0x0043, 0x2215, 0x006B, 0x0067];
        }
      case 0x33C7:
        {
          return [0x0043, 0x006F, 0x002E];
        }
      case 0x33C8:
        {
          return [0x0064, 0x0042];
        }
      case 0x33C9:
        {
          return [0x0047, 0x0079];
        }
      case 0x33CA:
        {
          return [0x0068, 0x0061];
        }
      case 0x33CB:
        {
          return [0x0048, 0x0050];
        }
      case 0x33CC:
        {
          return [0x0069, 0x006E];
        }
      case 0x33CD:
        {
          return [0x004B, 0x004B];
        }
      case 0x33CE:
        {
          return [0x004B, 0x004D];
        }
      case 0x33CF:
        {
          return [0x006B, 0x0074];
        }
      case 0x33D0:
        {
          return [0x006C, 0x006D];
        }
      case 0x33D1:
        {
          return [0x006C, 0x006E];
        }
      case 0x33D2:
        {
          return [0x006C, 0x006F, 0x0067];
        }
      case 0x33D3:
        {
          return [0x006C, 0x0078];
        }
      case 0x33D4:
        {
          return [0x006D, 0x0062];
        }
      case 0x33D5:
        {
          return [0x006D, 0x0069, 0x006C];
        }
      case 0x33D6:
        {
          return [0x006D, 0x006F, 0x006C];
        }
      case 0x33D7:
        {
          return [0x0050, 0x0048];
        }
      case 0x33D8:
        {
          return [0x0070, 0x002E, 0x006D, 0x002E];
        }
      case 0x33D9:
        {
          return [0x0050, 0x0050, 0x004D];
        }
      case 0x33DA:
        {
          return [0x0050, 0x0052];
        }
      case 0x33DB:
        {
          return [0x0073, 0x0072];
        }
      case 0x33DC:
        {
          return [0x0053, 0x0076];
        }
      case 0x33DD:
        {
          return [0x0057, 0x0062];
        }
      case 0x33DE:
        {
          return [0x0056, 0x2215, 0x006D];
        }
      case 0x33DF:
        {
          return [0x0041, 0x2215, 0x006D];
        }
      case 0x33E0:
        {
          return [0x0031, 0x65E5];
        }
      case 0x33E1:
        {
          return [0x0032, 0x65E5];
        }
      case 0x33E2:
        {
          return [0x0033, 0x65E5];
        }
      case 0x33E3:
        {
          return [0x0034, 0x65E5];
        }
      case 0x33E4:
        {
          return [0x0035, 0x65E5];
        }
      case 0x33E5:
        {
          return [0x0036, 0x65E5];
        }
      case 0x33E6:
        {
          return [0x0037, 0x65E5];
        }
      case 0x33E7:
        {
          return [0x0038, 0x65E5];
        }
      case 0x33E8:
        {
          return [0x0039, 0x65E5];
        }
      case 0x33E9:
        {
          return [0x0031, 0x0030, 0x65E5];
        }
      case 0x33EA:
        {
          return [0x0031, 0x0031, 0x65E5];
        }
      case 0x33EB:
        {
          return [0x0031, 0x0032, 0x65E5];
        }
      case 0x33EC:
        {
          return [0x0031, 0x0033, 0x65E5];
        }
      case 0x33ED:
        {
          return [0x0031, 0x0034, 0x65E5];
        }
      case 0x33EE:
        {
          return [0x0031, 0x0035, 0x65E5];
        }
      case 0x33EF:
        {
          return [0x0031, 0x0036, 0x65E5];
        }
      case 0x33F0:
        {
          return [0x0031, 0x0037, 0x65E5];
        }
      case 0x33F1:
        {
          return [0x0031, 0x0038, 0x65E5];
        }
      case 0x33F2:
        {
          return [0x0031, 0x0039, 0x65E5];
        }
      case 0x33F3:
        {
          return [0x0032, 0x0030, 0x65E5];
        }
      case 0x33F4:
        {
          return [0x0032, 0x0031, 0x65E5];
        }
      case 0x33F5:
        {
          return [0x0032, 0x0032, 0x65E5];
        }
      case 0x33F6:
        {
          return [0x0032, 0x0033, 0x65E5];
        }
      case 0x33F7:
        {
          return [0x0032, 0x0034, 0x65E5];
        }
      case 0x33F8:
        {
          return [0x0032, 0x0035, 0x65E5];
        }
      case 0x33F9:
        {
          return [0x0032, 0x0036, 0x65E5];
        }
      case 0x33FA:
        {
          return [0x0032, 0x0037, 0x65E5];
        }
      case 0x33FB:
        {
          return [0x0032, 0x0038, 0x65E5];
        }
      case 0x33FC:
        {
          return [0x0032, 0x0039, 0x65E5];
        }
      case 0x33FD:
        {
          return [0x0033, 0x0030, 0x65E5];
        }
      case 0x33FE:
        {
          return [0x0033, 0x0031, 0x65E5];
        }
      case 0x33FF:
        {
          return [0x0067, 0x0061, 0x006C];
        }
      default:
        return null;
    }
  }
}
class DecompositionMachineAlpha {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0x00A0:
        {
          return [0x0020];
        }
      case 0x00A8:
        {
          return [0x0020, 0x0308];
        }
      case 0x00AA:
        {
          return [0x0061];
        }
      case 0x00AF:
        {
          return [0x0020, 0x0304];
        }
      case 0x00B2:
        {
          return [0x0032];
        }
      case 0x00B3:
        {
          return [0x0033];
        }
      case 0x00B4:
        {
          return [0x0020, 0x0301];
        }
      case 0x00B5:
        {
          return [0x03BC];
        }
      case 0x00B8:
        {
          return [0x0020, 0x0327];
        }
      case 0x00B9:
        {
          return [0x0031];
        }
      case 0x00BA:
        {
          return [0x006F];
        }
      case 0x00BC:
        {
          return [0x0031, 0x2044, 0x0034];
        }
      case 0x00BD:
        {
          return [0x0031, 0x2044, 0x0032];
        }
      case 0x00BE:
        {
          return [0x0033, 0x2044, 0x0034];
        }
      case 0x00C0:
        {
          return [0x0041, 0x0300];
        }
      case 0x00C1:
        {
          return [0x0041, 0x0301];
        }
      case 0x00C2:
        {
          return [0x0041, 0x0302];
        }
      case 0x00C3:
        {
          return [0x0041, 0x0303];
        }
      case 0x00C4:
        {
          return [0x0041, 0x0308];
        }
      case 0x00C5:
        {
          return [0x0041, 0x030A];
        }
      case 0x00C7:
        {
          return [0x0043, 0x0327];
        }
      case 0x00C8:
        {
          return [0x0045, 0x0300];
        }
      case 0x00C9:
        {
          return [0x0045, 0x0301];
        }
      case 0x00CA:
        {
          return [0x0045, 0x0302];
        }
      case 0x00CB:
        {
          return [0x0045, 0x0308];
        }
      case 0x00CC:
        {
          return [0x0049, 0x0300];
        }
      case 0x00CD:
        {
          return [0x0049, 0x0301];
        }
      case 0x00CE:
        {
          return [0x0049, 0x0302];
        }
      case 0x00CF:
        {
          return [0x0049, 0x0308];
        }
      case 0x00D1:
        {
          return [0x004E, 0x0303];
        }
      case 0x00D2:
        {
          return [0x004F, 0x0300];
        }
      case 0x00D3:
        {
          return [0x004F, 0x0301];
        }
      case 0x00D4:
        {
          return [0x004F, 0x0302];
        }
      case 0x00D5:
        {
          return [0x004F, 0x0303];
        }
      case 0x00D6:
        {
          return [0x004F, 0x0308];
        }
      case 0x00D9:
        {
          return [0x0055, 0x0300];
        }
      case 0x00DA:
        {
          return [0x0055, 0x0301];
        }
      case 0x00DB:
        {
          return [0x0055, 0x0302];
        }
      case 0x00DC:
        {
          return [0x0055, 0x0308];
        }
      case 0x00DD:
        {
          return [0x0059, 0x0301];
        }
      case 0x00E0:
        {
          return [0x0061, 0x0300];
        }
      case 0x00E1:
        {
          return [0x0061, 0x0301];
        }
      case 0x00E2:
        {
          return [0x0061, 0x0302];
        }
      case 0x00E3:
        {
          return [0x0061, 0x0303];
        }
      case 0x00E4:
        {
          return [0x0061, 0x0308];
        }
      case 0x00E5:
        {
          return [0x0061, 0x030A];
        }
      case 0x00E7:
        {
          return [0x0063, 0x0327];
        }
      case 0x00E8:
        {
          return [0x0065, 0x0300];
        }
      case 0x00E9:
        {
          return [0x0065, 0x0301];
        }
      case 0x00EA:
        {
          return [0x0065, 0x0302];
        }
      case 0x00EB:
        {
          return [0x0065, 0x0308];
        }
      case 0x00EC:
        {
          return [0x0069, 0x0300];
        }
      case 0x00ED:
        {
          return [0x0069, 0x0301];
        }
      case 0x00EE:
        {
          return [0x0069, 0x0302];
        }
      case 0x00EF:
        {
          return [0x0069, 0x0308];
        }
      case 0x00F1:
        {
          return [0x006E, 0x0303];
        }
      case 0x00F2:
        {
          return [0x006F, 0x0300];
        }
      case 0x00F3:
        {
          return [0x006F, 0x0301];
        }
      case 0x00F4:
        {
          return [0x006F, 0x0302];
        }
      case 0x00F5:
        {
          return [0x006F, 0x0303];
        }
      case 0x00F6:
        {
          return [0x006F, 0x0308];
        }
      case 0x00F9:
        {
          return [0x0075, 0x0300];
        }
      case 0x00FA:
        {
          return [0x0075, 0x0301];
        }
      case 0x00FB:
        {
          return [0x0075, 0x0302];
        }
      case 0x00FC:
        {
          return [0x0075, 0x0308];
        }
      case 0x00FD:
        {
          return [0x0079, 0x0301];
        }
      case 0x00FF:
        {
          return [0x0079, 0x0308];
        }
      case 0x0100:
        {
          return [0x0041, 0x0304];
        }
      case 0x0101:
        {
          return [0x0061, 0x0304];
        }
      case 0x0102:
        {
          return [0x0041, 0x0306];
        }
      case 0x0103:
        {
          return [0x0061, 0x0306];
        }
      case 0x0104:
        {
          return [0x0041, 0x0328];
        }
      case 0x0105:
        {
          return [0x0061, 0x0328];
        }
      case 0x0106:
        {
          return [0x0043, 0x0301];
        }
      case 0x0107:
        {
          return [0x0063, 0x0301];
        }
      case 0x0108:
        {
          return [0x0043, 0x0302];
        }
      case 0x0109:
        {
          return [0x0063, 0x0302];
        }
      case 0x010A:
        {
          return [0x0043, 0x0307];
        }
      case 0x010B:
        {
          return [0x0063, 0x0307];
        }
      case 0x010C:
        {
          return [0x0043, 0x030C];
        }
      case 0x010D:
        {
          return [0x0063, 0x030C];
        }
      case 0x010E:
        {
          return [0x0044, 0x030C];
        }
      case 0x010F:
        {
          return [0x0064, 0x030C];
        }
      case 0x0112:
        {
          return [0x0045, 0x0304];
        }
      case 0x0113:
        {
          return [0x0065, 0x0304];
        }
      case 0x0114:
        {
          return [0x0045, 0x0306];
        }
      case 0x0115:
        {
          return [0x0065, 0x0306];
        }
      case 0x0116:
        {
          return [0x0045, 0x0307];
        }
      case 0x0117:
        {
          return [0x0065, 0x0307];
        }
      case 0x0118:
        {
          return [0x0045, 0x0328];
        }
      case 0x0119:
        {
          return [0x0065, 0x0328];
        }
      case 0x011A:
        {
          return [0x0045, 0x030C];
        }
      case 0x011B:
        {
          return [0x0065, 0x030C];
        }
      case 0x011C:
        {
          return [0x0047, 0x0302];
        }
      case 0x011D:
        {
          return [0x0067, 0x0302];
        }
      case 0x011E:
        {
          return [0x0047, 0x0306];
        }
      case 0x011F:
        {
          return [0x0067, 0x0306];
        }
      case 0x0120:
        {
          return [0x0047, 0x0307];
        }
      case 0x0121:
        {
          return [0x0067, 0x0307];
        }
      case 0x0122:
        {
          return [0x0047, 0x0327];
        }
      case 0x0123:
        {
          return [0x0067, 0x0327];
        }
      case 0x0124:
        {
          return [0x0048, 0x0302];
        }
      case 0x0125:
        {
          return [0x0068, 0x0302];
        }
      case 0x0128:
        {
          return [0x0049, 0x0303];
        }
      case 0x0129:
        {
          return [0x0069, 0x0303];
        }
      case 0x012A:
        {
          return [0x0049, 0x0304];
        }
      case 0x012B:
        {
          return [0x0069, 0x0304];
        }
      case 0x012C:
        {
          return [0x0049, 0x0306];
        }
      case 0x012D:
        {
          return [0x0069, 0x0306];
        }
      case 0x012E:
        {
          return [0x0049, 0x0328];
        }
      case 0x012F:
        {
          return [0x0069, 0x0328];
        }
      case 0x0130:
        {
          return [0x0049, 0x0307];
        }
      case 0x0132:
        {
          return [0x0049, 0x004A];
        }
      case 0x0133:
        {
          return [0x0069, 0x006A];
        }
      case 0x0134:
        {
          return [0x004A, 0x0302];
        }
      case 0x0135:
        {
          return [0x006A, 0x0302];
        }
      case 0x0136:
        {
          return [0x004B, 0x0327];
        }
      case 0x0137:
        {
          return [0x006B, 0x0327];
        }
      case 0x0139:
        {
          return [0x004C, 0x0301];
        }
      case 0x013A:
        {
          return [0x006C, 0x0301];
        }
      case 0x013B:
        {
          return [0x004C, 0x0327];
        }
      case 0x013C:
        {
          return [0x006C, 0x0327];
        }
      case 0x013D:
        {
          return [0x004C, 0x030C];
        }
      case 0x013E:
        {
          return [0x006C, 0x030C];
        }
      case 0x013F:
        {
          return [0x004C, 0x00B7];
        }
      case 0x0140:
        {
          return [0x006C, 0x00B7];
        }
      case 0x0143:
        {
          return [0x004E, 0x0301];
        }
      case 0x0144:
        {
          return [0x006E, 0x0301];
        }
      case 0x0145:
        {
          return [0x004E, 0x0327];
        }
      case 0x0146:
        {
          return [0x006E, 0x0327];
        }
      case 0x0147:
        {
          return [0x004E, 0x030C];
        }
      case 0x0148:
        {
          return [0x006E, 0x030C];
        }
      case 0x0149:
        {
          return [0x02BC, 0x006E];
        }
      case 0x014C:
        {
          return [0x004F, 0x0304];
        }
      case 0x014D:
        {
          return [0x006F, 0x0304];
        }
      case 0x014E:
        {
          return [0x004F, 0x0306];
        }
      case 0x014F:
        {
          return [0x006F, 0x0306];
        }
      case 0x0150:
        {
          return [0x004F, 0x030B];
        }
      case 0x0151:
        {
          return [0x006F, 0x030B];
        }
      case 0x0154:
        {
          return [0x0052, 0x0301];
        }
      case 0x0155:
        {
          return [0x0072, 0x0301];
        }
      case 0x0156:
        {
          return [0x0052, 0x0327];
        }
      case 0x0157:
        {
          return [0x0072, 0x0327];
        }
      case 0x0158:
        {
          return [0x0052, 0x030C];
        }
      case 0x0159:
        {
          return [0x0072, 0x030C];
        }
      case 0x015A:
        {
          return [0x0053, 0x0301];
        }
      case 0x015B:
        {
          return [0x0073, 0x0301];
        }
      case 0x015C:
        {
          return [0x0053, 0x0302];
        }
      case 0x015D:
        {
          return [0x0073, 0x0302];
        }
      case 0x015E:
        {
          return [0x0053, 0x0327];
        }
      case 0x015F:
        {
          return [0x0073, 0x0327];
        }
      case 0x0160:
        {
          return [0x0053, 0x030C];
        }
      case 0x0161:
        {
          return [0x0073, 0x030C];
        }
      case 0x0162:
        {
          return [0x0054, 0x0327];
        }
      case 0x0163:
        {
          return [0x0074, 0x0327];
        }
      case 0x0164:
        {
          return [0x0054, 0x030C];
        }
      case 0x0165:
        {
          return [0x0074, 0x030C];
        }
      case 0x0168:
        {
          return [0x0055, 0x0303];
        }
      case 0x0169:
        {
          return [0x0075, 0x0303];
        }
      case 0x016A:
        {
          return [0x0055, 0x0304];
        }
      case 0x016B:
        {
          return [0x0075, 0x0304];
        }
      case 0x016C:
        {
          return [0x0055, 0x0306];
        }
      case 0x016D:
        {
          return [0x0075, 0x0306];
        }
      case 0x016E:
        {
          return [0x0055, 0x030A];
        }
      case 0x016F:
        {
          return [0x0075, 0x030A];
        }
      case 0x0170:
        {
          return [0x0055, 0x030B];
        }
      case 0x0171:
        {
          return [0x0075, 0x030B];
        }
      case 0x0172:
        {
          return [0x0055, 0x0328];
        }
      case 0x0173:
        {
          return [0x0075, 0x0328];
        }
      case 0x0174:
        {
          return [0x0057, 0x0302];
        }
      case 0x0175:
        {
          return [0x0077, 0x0302];
        }
      case 0x0176:
        {
          return [0x0059, 0x0302];
        }
      case 0x0177:
        {
          return [0x0079, 0x0302];
        }
      case 0x0178:
        {
          return [0x0059, 0x0308];
        }
      case 0x0179:
        {
          return [0x005A, 0x0301];
        }
      case 0x017A:
        {
          return [0x007A, 0x0301];
        }
      case 0x017B:
        {
          return [0x005A, 0x0307];
        }
      case 0x017C:
        {
          return [0x007A, 0x0307];
        }
      case 0x017D:
        {
          return [0x005A, 0x030C];
        }
      case 0x017E:
        {
          return [0x007A, 0x030C];
        }
      case 0x017F:
        {
          return [0x0073];
        }
      case 0x01A0:
        {
          return [0x004F, 0x031B];
        }
      case 0x01A1:
        {
          return [0x006F, 0x031B];
        }
      case 0x01AF:
        {
          return [0x0055, 0x031B];
        }
      case 0x01B0:
        {
          return [0x0075, 0x031B];
        }
      case 0x01C4:
        {
          return [0x0044, 0x017D];
        }
      case 0x01C5:
        {
          return [0x0044, 0x017E];
        }
      case 0x01C6:
        {
          return [0x0064, 0x017E];
        }
      case 0x01C7:
        {
          return [0x004C, 0x004A];
        }
      case 0x01C8:
        {
          return [0x004C, 0x006A];
        }
      case 0x01C9:
        {
          return [0x006C, 0x006A];
        }
      case 0x01CA:
        {
          return [0x004E, 0x004A];
        }
      case 0x01CB:
        {
          return [0x004E, 0x006A];
        }
      case 0x01CC:
        {
          return [0x006E, 0x006A];
        }
      case 0x01CD:
        {
          return [0x0041, 0x030C];
        }
      case 0x01CE:
        {
          return [0x0061, 0x030C];
        }
      case 0x01CF:
        {
          return [0x0049, 0x030C];
        }
      case 0x01D0:
        {
          return [0x0069, 0x030C];
        }
      case 0x01D1:
        {
          return [0x004F, 0x030C];
        }
      case 0x01D2:
        {
          return [0x006F, 0x030C];
        }
      case 0x01D3:
        {
          return [0x0055, 0x030C];
        }
      case 0x01D4:
        {
          return [0x0075, 0x030C];
        }
      case 0x01D5:
        {
          return [0x00DC, 0x0304];
        }
      case 0x01D6:
        {
          return [0x00FC, 0x0304];
        }
      case 0x01D7:
        {
          return [0x00DC, 0x0301];
        }
      case 0x01D8:
        {
          return [0x00FC, 0x0301];
        }
      case 0x01D9:
        {
          return [0x00DC, 0x030C];
        }
      case 0x01DA:
        {
          return [0x00FC, 0x030C];
        }
      case 0x01DB:
        {
          return [0x00DC, 0x0300];
        }
      case 0x01DC:
        {
          return [0x00FC, 0x0300];
        }
      case 0x01DE:
        {
          return [0x00C4, 0x0304];
        }
      case 0x01DF:
        {
          return [0x00E4, 0x0304];
        }
      case 0x01E0:
        {
          return [0x0226, 0x0304];
        }
      case 0x01E1:
        {
          return [0x0227, 0x0304];
        }
      case 0x01E2:
        {
          return [0x00C6, 0x0304];
        }
      case 0x01E3:
        {
          return [0x00E6, 0x0304];
        }
      case 0x01E6:
        {
          return [0x0047, 0x030C];
        }
      case 0x01E7:
        {
          return [0x0067, 0x030C];
        }
      case 0x01E8:
        {
          return [0x004B, 0x030C];
        }
      case 0x01E9:
        {
          return [0x006B, 0x030C];
        }
      case 0x01EA:
        {
          return [0x004F, 0x0328];
        }
      case 0x01EB:
        {
          return [0x006F, 0x0328];
        }
      case 0x01EC:
        {
          return [0x01EA, 0x0304];
        }
      case 0x01ED:
        {
          return [0x01EB, 0x0304];
        }
      case 0x01EE:
        {
          return [0x01B7, 0x030C];
        }
      case 0x01EF:
        {
          return [0x0292, 0x030C];
        }
      case 0x01F0:
        {
          return [0x006A, 0x030C];
        }
      case 0x01F1:
        {
          return [0x0044, 0x005A];
        }
      case 0x01F2:
        {
          return [0x0044, 0x007A];
        }
      case 0x01F3:
        {
          return [0x0064, 0x007A];
        }
      case 0x01F4:
        {
          return [0x0047, 0x0301];
        }
      case 0x01F5:
        {
          return [0x0067, 0x0301];
        }
      case 0x01F8:
        {
          return [0x004E, 0x0300];
        }
      case 0x01F9:
        {
          return [0x006E, 0x0300];
        }
      case 0x01FA:
        {
          return [0x00C5, 0x0301];
        }
      case 0x01FB:
        {
          return [0x00E5, 0x0301];
        }
      case 0x01FC:
        {
          return [0x00C6, 0x0301];
        }
      case 0x01FD:
        {
          return [0x00E6, 0x0301];
        }
      case 0x01FE:
        {
          return [0x00D8, 0x0301];
        }
      case 0x01FF:
        {
          return [0x00F8, 0x0301];
        }
      case 0x0200:
        {
          return [0x0041, 0x030F];
        }
      case 0x0201:
        {
          return [0x0061, 0x030F];
        }
      case 0x0202:
        {
          return [0x0041, 0x0311];
        }
      case 0x0203:
        {
          return [0x0061, 0x0311];
        }
      case 0x0204:
        {
          return [0x0045, 0x030F];
        }
      case 0x0205:
        {
          return [0x0065, 0x030F];
        }
      case 0x0206:
        {
          return [0x0045, 0x0311];
        }
      case 0x0207:
        {
          return [0x0065, 0x0311];
        }
      case 0x0208:
        {
          return [0x0049, 0x030F];
        }
      case 0x0209:
        {
          return [0x0069, 0x030F];
        }
      case 0x020A:
        {
          return [0x0049, 0x0311];
        }
      case 0x020B:
        {
          return [0x0069, 0x0311];
        }
      case 0x020C:
        {
          return [0x004F, 0x030F];
        }
      case 0x020D:
        {
          return [0x006F, 0x030F];
        }
      case 0x020E:
        {
          return [0x004F, 0x0311];
        }
      case 0x020F:
        {
          return [0x006F, 0x0311];
        }
      case 0x0210:
        {
          return [0x0052, 0x030F];
        }
      case 0x0211:
        {
          return [0x0072, 0x030F];
        }
      case 0x0212:
        {
          return [0x0052, 0x0311];
        }
      case 0x0213:
        {
          return [0x0072, 0x0311];
        }
      case 0x0214:
        {
          return [0x0055, 0x030F];
        }
      case 0x0215:
        {
          return [0x0075, 0x030F];
        }
      case 0x0216:
        {
          return [0x0055, 0x0311];
        }
      case 0x0217:
        {
          return [0x0075, 0x0311];
        }
      case 0x0218:
        {
          return [0x0053, 0x0326];
        }
      case 0x0219:
        {
          return [0x0073, 0x0326];
        }
      case 0x021A:
        {
          return [0x0054, 0x0326];
        }
      case 0x021B:
        {
          return [0x0074, 0x0326];
        }
      case 0x021E:
        {
          return [0x0048, 0x030C];
        }
      case 0x021F:
        {
          return [0x0068, 0x030C];
        }
      case 0x0226:
        {
          return [0x0041, 0x0307];
        }
      case 0x0227:
        {
          return [0x0061, 0x0307];
        }
      case 0x0228:
        {
          return [0x0045, 0x0327];
        }
      case 0x0229:
        {
          return [0x0065, 0x0327];
        }
      case 0x022A:
        {
          return [0x00D6, 0x0304];
        }
      case 0x022B:
        {
          return [0x00F6, 0x0304];
        }
      case 0x022C:
        {
          return [0x00D5, 0x0304];
        }
      case 0x022D:
        {
          return [0x00F5, 0x0304];
        }
      case 0x022E:
        {
          return [0x004F, 0x0307];
        }
      case 0x022F:
        {
          return [0x006F, 0x0307];
        }
      case 0x0230:
        {
          return [0x022E, 0x0304];
        }
      case 0x0231:
        {
          return [0x022F, 0x0304];
        }
      case 0x0232:
        {
          return [0x0059, 0x0304];
        }
      case 0x0233:
        {
          return [0x0079, 0x0304];
        }
      case 0x02B0:
        {
          return [0x0068];
        }
      case 0x02B1:
        {
          return [0x0266];
        }
      case 0x02B2:
        {
          return [0x006A];
        }
      case 0x02B3:
        {
          return [0x0072];
        }
      case 0x02B4:
        {
          return [0x0279];
        }
      case 0x02B5:
        {
          return [0x027B];
        }
      case 0x02B6:
        {
          return [0x0281];
        }
      case 0x02B7:
        {
          return [0x0077];
        }
      case 0x02B8:
        {
          return [0x0079];
        }
      case 0x02D8:
        {
          return [0x0020, 0x0306];
        }
      case 0x02D9:
        {
          return [0x0020, 0x0307];
        }
      case 0x02DA:
        {
          return [0x0020, 0x030A];
        }
      case 0x02DB:
        {
          return [0x0020, 0x0328];
        }
      case 0x02DC:
        {
          return [0x0020, 0x0303];
        }
      case 0x02DD:
        {
          return [0x0020, 0x030B];
        }
      case 0x02E0:
        {
          return [0x0263];
        }
      case 0x02E1:
        {
          return [0x006C];
        }
      case 0x02E2:
        {
          return [0x0073];
        }
      case 0x02E3:
        {
          return [0x0078];
        }
      case 0x02E4:
        {
          return [0x0295];
        }
      case 0x0340:
        {
          return [0x0300];
        }
      case 0x0341:
        {
          return [0x0301];
        }
      case 0x0343:
        {
          return [0x0313];
        }
      case 0x0344:
        {
          return [0x0308, 0x0301];
        }
      case 0x0374:
        {
          return [0x02B9];
        }
      case 0x037A:
        {
          return [0x0020, 0x0345];
        }
      case 0x037E:
        {
          return [0x003B];
        }
      case 0x0384:
        {
          return [0x0020, 0x0301];
        }
      case 0x0385:
        {
          return [0x00A8, 0x0301];
        }
      case 0x0386:
        {
          return [0x0391, 0x0301];
        }
      case 0x0387:
        {
          return [0x00B7];
        }
      case 0x0388:
        {
          return [0x0395, 0x0301];
        }
      case 0x0389:
        {
          return [0x0397, 0x0301];
        }
      case 0x038A:
        {
          return [0x0399, 0x0301];
        }
      case 0x038C:
        {
          return [0x039F, 0x0301];
        }
      case 0x038E:
        {
          return [0x03A5, 0x0301];
        }
      case 0x038F:
        {
          return [0x03A9, 0x0301];
        }
      case 0x0390:
        {
          return [0x03CA, 0x0301];
        }
      case 0x03AA:
        {
          return [0x0399, 0x0308];
        }
      case 0x03AB:
        {
          return [0x03A5, 0x0308];
        }
      case 0x03AC:
        {
          return [0x03B1, 0x0301];
        }
      case 0x03AD:
        {
          return [0x03B5, 0x0301];
        }
      case 0x03AE:
        {
          return [0x03B7, 0x0301];
        }
      case 0x03AF:
        {
          return [0x03B9, 0x0301];
        }
      case 0x03B0:
        {
          return [0x03CB, 0x0301];
        }
      case 0x03CA:
        {
          return [0x03B9, 0x0308];
        }
      case 0x03CB:
        {
          return [0x03C5, 0x0308];
        }
      case 0x03CC:
        {
          return [0x03BF, 0x0301];
        }
      case 0x03CD:
        {
          return [0x03C5, 0x0301];
        }
      case 0x03CE:
        {
          return [0x03C9, 0x0301];
        }
      case 0x03D0:
        {
          return [0x03B2];
        }
      case 0x03D1:
        {
          return [0x03B8];
        }
      case 0x03D2:
        {
          return [0x03A5];
        }
      case 0x03D3:
        {
          return [0x03D2, 0x0301];
        }
      case 0x03D4:
        {
          return [0x03D2, 0x0308];
        }
      case 0x03D5:
        {
          return [0x03C6];
        }
      case 0x03D6:
        {
          return [0x03C0];
        }
      case 0x03F0:
        {
          return [0x03BA];
        }
      case 0x03F1:
        {
          return [0x03C1];
        }
      case 0x03F2:
        {
          return [0x03C2];
        }
      case 0x03F4:
        {
          return [0x0398];
        }
      case 0x03F5:
        {
          return [0x03B5];
        }
      case 0x03F9:
        {
          return [0x03A3];
        }
      case 0x0400:
        {
          return [0x0415, 0x0300];
        }
      case 0x0401:
        {
          return [0x0415, 0x0308];
        }
      case 0x0403:
        {
          return [0x0413, 0x0301];
        }
      case 0x0407:
        {
          return [0x0406, 0x0308];
        }
      case 0x040C:
        {
          return [0x041A, 0x0301];
        }
      case 0x040D:
        {
          return [0x0418, 0x0300];
        }
      case 0x040E:
        {
          return [0x0423, 0x0306];
        }
      case 0x0419:
        {
          return [0x0418, 0x0306];
        }
      case 0x0439:
        {
          return [0x0438, 0x0306];
        }
      case 0x0450:
        {
          return [0x0435, 0x0300];
        }
      case 0x0451:
        {
          return [0x0435, 0x0308];
        }
      case 0x0453:
        {
          return [0x0433, 0x0301];
        }
      case 0x0457:
        {
          return [0x0456, 0x0308];
        }
      case 0x045C:
        {
          return [0x043A, 0x0301];
        }
      case 0x045D:
        {
          return [0x0438, 0x0300];
        }
      case 0x045E:
        {
          return [0x0443, 0x0306];
        }
      case 0x0476:
        {
          return [0x0474, 0x030F];
        }
      case 0x0477:
        {
          return [0x0475, 0x030F];
        }
      case 0x04C1:
        {
          return [0x0416, 0x0306];
        }
      case 0x04C2:
        {
          return [0x0436, 0x0306];
        }
      case 0x04D0:
        {
          return [0x0410, 0x0306];
        }
      case 0x04D1:
        {
          return [0x0430, 0x0306];
        }
      case 0x04D2:
        {
          return [0x0410, 0x0308];
        }
      case 0x04D3:
        {
          return [0x0430, 0x0308];
        }
      case 0x04D6:
        {
          return [0x0415, 0x0306];
        }
      case 0x04D7:
        {
          return [0x0435, 0x0306];
        }
      case 0x04DA:
        {
          return [0x04D8, 0x0308];
        }
      case 0x04DB:
        {
          return [0x04D9, 0x0308];
        }
      case 0x04DC:
        {
          return [0x0416, 0x0308];
        }
      case 0x04DD:
        {
          return [0x0436, 0x0308];
        }
      case 0x04DE:
        {
          return [0x0417, 0x0308];
        }
      case 0x04DF:
        {
          return [0x0437, 0x0308];
        }
      case 0x04E2:
        {
          return [0x0418, 0x0304];
        }
      case 0x04E3:
        {
          return [0x0438, 0x0304];
        }
      case 0x04E4:
        {
          return [0x0418, 0x0308];
        }
      case 0x04E5:
        {
          return [0x0438, 0x0308];
        }
      case 0x04E6:
        {
          return [0x041E, 0x0308];
        }
      case 0x04E7:
        {
          return [0x043E, 0x0308];
        }
      case 0x04EA:
        {
          return [0x04E8, 0x0308];
        }
      case 0x04EB:
        {
          return [0x04E9, 0x0308];
        }
      case 0x04EC:
        {
          return [0x042D, 0x0308];
        }
      case 0x04ED:
        {
          return [0x044D, 0x0308];
        }
      case 0x04EE:
        {
          return [0x0423, 0x0304];
        }
      case 0x04EF:
        {
          return [0x0443, 0x0304];
        }
      case 0x04F0:
        {
          return [0x0423, 0x0308];
        }
      case 0x04F1:
        {
          return [0x0443, 0x0308];
        }
      case 0x04F2:
        {
          return [0x0423, 0x030B];
        }
      case 0x04F3:
        {
          return [0x0443, 0x030B];
        }
      case 0x04F4:
        {
          return [0x0427, 0x0308];
        }
      case 0x04F5:
        {
          return [0x0447, 0x0308];
        }
      case 0x04F8:
        {
          return [0x042B, 0x0308];
        }
      case 0x04F9:
        {
          return [0x044B, 0x0308];
        }
      case 0x0587:
        {
          return [0x0565, 0x0582];
        }
      case 0x0622:
        {
          return [0x0627, 0x0653];
        }
      case 0x0623:
        {
          return [0x0627, 0x0654];
        }
      case 0x0624:
        {
          return [0x0648, 0x0654];
        }
      case 0x0625:
        {
          return [0x0627, 0x0655];
        }
      case 0x0626:
        {
          return [0x064A, 0x0654];
        }
      case 0x0675:
        {
          return [0x0627, 0x0674];
        }
      case 0x0676:
        {
          return [0x0648, 0x0674];
        }
      case 0x0677:
        {
          return [0x06C7, 0x0674];
        }
      case 0x0678:
        {
          return [0x064A, 0x0674];
        }
      case 0x06C0:
        {
          return [0x06D5, 0x0654];
        }
      case 0x06C2:
        {
          return [0x06C1, 0x0654];
        }
      case 0x06D3:
        {
          return [0x06D2, 0x0654];
        }
      case 0x0929:
        {
          return [0x0928, 0x093C];
        }
      case 0x0931:
        {
          return [0x0930, 0x093C];
        }
      case 0x0934:
        {
          return [0x0933, 0x093C];
        }
      case 0x0958:
        {
          return [0x0915, 0x093C];
        }
      case 0x0959:
        {
          return [0x0916, 0x093C];
        }
      case 0x095A:
        {
          return [0x0917, 0x093C];
        }
      case 0x095B:
        {
          return [0x091C, 0x093C];
        }
      case 0x095C:
        {
          return [0x0921, 0x093C];
        }
      case 0x095D:
        {
          return [0x0922, 0x093C];
        }
      case 0x095E:
        {
          return [0x092B, 0x093C];
        }
      case 0x095F:
        {
          return [0x092F, 0x093C];
        }
      case 0x09CB:
        {
          return [0x09C7, 0x09BE];
        }
      case 0x09CC:
        {
          return [0x09C7, 0x09D7];
        }
      case 0x09DC:
        {
          return [0x09A1, 0x09BC];
        }
      case 0x09DD:
        {
          return [0x09A2, 0x09BC];
        }
      case 0x09DF:
        {
          return [0x09AF, 0x09BC];
        }
      case 0x0A33:
        {
          return [0x0A32, 0x0A3C];
        }
      case 0x0A36:
        {
          return [0x0A38, 0x0A3C];
        }
      case 0x0A59:
        {
          return [0x0A16, 0x0A3C];
        }
      case 0x0A5A:
        {
          return [0x0A17, 0x0A3C];
        }
      case 0x0A5B:
        {
          return [0x0A1C, 0x0A3C];
        }
      case 0x0A5E:
        {
          return [0x0A2B, 0x0A3C];
        }
      case 0x0B48:
        {
          return [0x0B47, 0x0B56];
        }
      case 0x0B4B:
        {
          return [0x0B47, 0x0B3E];
        }
      case 0x0B4C:
        {
          return [0x0B47, 0x0B57];
        }
      case 0x0B5C:
        {
          return [0x0B21, 0x0B3C];
        }
      case 0x0B5D:
        {
          return [0x0B22, 0x0B3C];
        }
      case 0x0B94:
        {
          return [0x0B92, 0x0BD7];
        }
      case 0x0BCA:
        {
          return [0x0BC6, 0x0BBE];
        }
      case 0x0BCB:
        {
          return [0x0BC7, 0x0BBE];
        }
      case 0x0BCC:
        {
          return [0x0BC6, 0x0BD7];
        }
      case 0x0C48:
        {
          return [0x0C46, 0x0C56];
        }
      case 0x0CC0:
        {
          return [0x0CBF, 0x0CD5];
        }
      case 0x0CC7:
        {
          return [0x0CC6, 0x0CD5];
        }
      case 0x0CC8:
        {
          return [0x0CC6, 0x0CD6];
        }
      case 0x0CCA:
        {
          return [0x0CC6, 0x0CC2];
        }
      case 0x0CCB:
        {
          return [0x0CCA, 0x0CD5];
        }
      case 0x0D4A:
        {
          return [0x0D46, 0x0D3E];
        }
      case 0x0D4B:
        {
          return [0x0D47, 0x0D3E];
        }
      case 0x0D4C:
        {
          return [0x0D46, 0x0D57];
        }
      case 0x0DDA:
        {
          return [0x0DD9, 0x0DCA];
        }
      case 0x0DDC:
        {
          return [0x0DD9, 0x0DCF];
        }
      case 0x0DDD:
        {
          return [0x0DDC, 0x0DCA];
        }
      case 0x0DDE:
        {
          return [0x0DD9, 0x0DDF];
        }
      case 0x0E33:
        {
          return [0x0E4D, 0x0E32];
        }
      case 0x0EB3:
        {
          return [0x0ECD, 0x0EB2];
        }
      case 0x0EDC:
        {
          return [0x0EAB, 0x0E99];
        }
      case 0x0EDD:
        {
          return [0x0EAB, 0x0EA1];
        }
      case 0x0F0C:
        {
          return [0x0F0B];
        }
      case 0x0F43:
        {
          return [0x0F42, 0x0FB7];
        }
      case 0x0F4D:
        {
          return [0x0F4C, 0x0FB7];
        }
      case 0x0F52:
        {
          return [0x0F51, 0x0FB7];
        }
      case 0x0F57:
        {
          return [0x0F56, 0x0FB7];
        }
      case 0x0F5C:
        {
          return [0x0F5B, 0x0FB7];
        }
      case 0x0F69:
        {
          return [0x0F40, 0x0FB5];
        }
      case 0x0F73:
        {
          return [0x0F71, 0x0F72];
        }
      case 0x0F75:
        {
          return [0x0F71, 0x0F74];
        }
      case 0x0F76:
        {
          return [0x0FB2, 0x0F80];
        }
      case 0x0F77:
        {
          return [0x0FB2, 0x0F81];
        }
      case 0x0F78:
        {
          return [0x0FB3, 0x0F80];
        }
      case 0x0F79:
        {
          return [0x0FB3, 0x0F81];
        }
      case 0x0F81:
        {
          return [0x0F71, 0x0F80];
        }
      case 0x0F93:
        {
          return [0x0F92, 0x0FB7];
        }
      case 0x0F9D:
        {
          return [0x0F9C, 0x0FB7];
        }
      case 0x0FA2:
        {
          return [0x0FA1, 0x0FB7];
        }
      case 0x0FA7:
        {
          return [0x0FA6, 0x0FB7];
        }
      case 0x0FAC:
        {
          return [0x0FAB, 0x0FB7];
        }
      case 0x0FB9:
        {
          return [0x0F90, 0x0FB5];
        }
      case 0x1026:
        {
          return [0x1025, 0x102E];
        }
      case 0x10FC:
        {
          return [0x10DC];
        }
      case 0x1B06:
        {
          return [0x1B05, 0x1B35];
        }
      case 0x1B08:
        {
          return [0x1B07, 0x1B35];
        }
      case 0x1B0A:
        {
          return [0x1B09, 0x1B35];
        }
      case 0x1B0C:
        {
          return [0x1B0B, 0x1B35];
        }
      case 0x1B0E:
        {
          return [0x1B0D, 0x1B35];
        }
      case 0x1B12:
        {
          return [0x1B11, 0x1B35];
        }
      case 0x1B3B:
        {
          return [0x1B3A, 0x1B35];
        }
      case 0x1B3D:
        {
          return [0x1B3C, 0x1B35];
        }
      case 0x1B40:
        {
          return [0x1B3E, 0x1B35];
        }
      case 0x1B41:
        {
          return [0x1B3F, 0x1B35];
        }
      case 0x1B43:
        {
          return [0x1B42, 0x1B35];
        }
      case 0x1D2C:
        {
          return [0x0041];
        }
      case 0x1D2D:
        {
          return [0x00C6];
        }
      case 0x1D2E:
        {
          return [0x0042];
        }
      case 0x1D30:
        {
          return [0x0044];
        }
      case 0x1D31:
        {
          return [0x0045];
        }
      case 0x1D32:
        {
          return [0x018E];
        }
      case 0x1D33:
        {
          return [0x0047];
        }
      case 0x1D34:
        {
          return [0x0048];
        }
      case 0x1D35:
        {
          return [0x0049];
        }
      case 0x1D36:
        {
          return [0x004A];
        }
      case 0x1D37:
        {
          return [0x004B];
        }
      case 0x1D38:
        {
          return [0x004C];
        }
      case 0x1D39:
        {
          return [0x004D];
        }
      case 0x1D3A:
        {
          return [0x004E];
        }
      case 0x1D3C:
        {
          return [0x004F];
        }
      case 0x1D3D:
        {
          return [0x0222];
        }
      case 0x1D3E:
        {
          return [0x0050];
        }
      case 0x1D3F:
        {
          return [0x0052];
        }
      case 0x1D40:
        {
          return [0x0054];
        }
      case 0x1D41:
        {
          return [0x0055];
        }
      case 0x1D42:
        {
          return [0x0057];
        }
      case 0x1D43:
        {
          return [0x0061];
        }
      case 0x1D44:
        {
          return [0x0250];
        }
      case 0x1D45:
        {
          return [0x0251];
        }
      case 0x1D46:
        {
          return [0x1D02];
        }
      case 0x1D47:
        {
          return [0x0062];
        }
      case 0x1D48:
        {
          return [0x0064];
        }
      case 0x1D49:
        {
          return [0x0065];
        }
      case 0x1D4A:
        {
          return [0x0259];
        }
      case 0x1D4B:
        {
          return [0x025B];
        }
      case 0x1D4C:
        {
          return [0x025C];
        }
      case 0x1D4D:
        {
          return [0x0067];
        }
      case 0x1D4F:
        {
          return [0x006B];
        }
      case 0x1D50:
        {
          return [0x006D];
        }
      case 0x1D51:
        {
          return [0x014B];
        }
      case 0x1D52:
        {
          return [0x006F];
        }
      case 0x1D53:
        {
          return [0x0254];
        }
      case 0x1D54:
        {
          return [0x1D16];
        }
      case 0x1D55:
        {
          return [0x1D17];
        }
      case 0x1D56:
        {
          return [0x0070];
        }
      case 0x1D57:
        {
          return [0x0074];
        }
      case 0x1D58:
        {
          return [0x0075];
        }
      case 0x1D59:
        {
          return [0x1D1D];
        }
      case 0x1D5A:
        {
          return [0x026F];
        }
      case 0x1D5B:
        {
          return [0x0076];
        }
      case 0x1D5C:
        {
          return [0x1D25];
        }
      case 0x1D5D:
        {
          return [0x03B2];
        }
      case 0x1D5E:
        {
          return [0x03B3];
        }
      case 0x1D5F:
        {
          return [0x03B4];
        }
      case 0x1D60:
        {
          return [0x03C6];
        }
      case 0x1D61:
        {
          return [0x03C7];
        }
      case 0x1D62:
        {
          return [0x0069];
        }
      case 0x1D63:
        {
          return [0x0072];
        }
      case 0x1D64:
        {
          return [0x0075];
        }
      case 0x1D65:
        {
          return [0x0076];
        }
      case 0x1D66:
        {
          return [0x03B2];
        }
      case 0x1D67:
        {
          return [0x03B3];
        }
      case 0x1D68:
        {
          return [0x03C1];
        }
      case 0x1D69:
        {
          return [0x03C6];
        }
      case 0x1D6A:
        {
          return [0x03C7];
        }
      case 0x1D78:
        {
          return [0x043D];
        }
      case 0x1D9B:
        {
          return [0x0252];
        }
      case 0x1D9C:
        {
          return [0x0063];
        }
      case 0x1D9D:
        {
          return [0x0255];
        }
      case 0x1D9E:
        {
          return [0x00F0];
        }
      case 0x1D9F:
        {
          return [0x025C];
        }
      case 0x1DA0:
        {
          return [0x0066];
        }
      case 0x1DA1:
        {
          return [0x025F];
        }
      case 0x1DA2:
        {
          return [0x0261];
        }
      case 0x1DA3:
        {
          return [0x0265];
        }
      case 0x1DA4:
        {
          return [0x0268];
        }
      case 0x1DA5:
        {
          return [0x0269];
        }
      case 0x1DA6:
        {
          return [0x026A];
        }
      case 0x1DA7:
        {
          return [0x1D7B];
        }
      case 0x1DA8:
        {
          return [0x029D];
        }
      case 0x1DA9:
        {
          return [0x026D];
        }
      case 0x1DAA:
        {
          return [0x1D85];
        }
      case 0x1DAB:
        {
          return [0x029F];
        }
      case 0x1DAC:
        {
          return [0x0271];
        }
      case 0x1DAD:
        {
          return [0x0270];
        }
      case 0x1DAE:
        {
          return [0x0272];
        }
      case 0x1DAF:
        {
          return [0x0273];
        }
      case 0x1DB0:
        {
          return [0x0274];
        }
      case 0x1DB1:
        {
          return [0x0275];
        }
      case 0x1DB2:
        {
          return [0x0278];
        }
      case 0x1DB3:
        {
          return [0x0282];
        }
      case 0x1DB4:
        {
          return [0x0283];
        }
      case 0x1DB5:
        {
          return [0x01AB];
        }
      case 0x1DB6:
        {
          return [0x0289];
        }
      case 0x1DB7:
        {
          return [0x028A];
        }
      case 0x1DB8:
        {
          return [0x1D1C];
        }
      case 0x1DB9:
        {
          return [0x028B];
        }
      case 0x1DBA:
        {
          return [0x028C];
        }
      case 0x1DBB:
        {
          return [0x007A];
        }
      case 0x1DBC:
        {
          return [0x0290];
        }
      case 0x1DBD:
        {
          return [0x0291];
        }
      case 0x1DBE:
        {
          return [0x0292];
        }
      case 0x1DBF:
        {
          return [0x03B8];
        }
      case 0x1E00:
        {
          return [0x0041, 0x0325];
        }
      case 0x1E01:
        {
          return [0x0061, 0x0325];
        }
      case 0x1E02:
        {
          return [0x0042, 0x0307];
        }
      case 0x1E03:
        {
          return [0x0062, 0x0307];
        }
      case 0x1E04:
        {
          return [0x0042, 0x0323];
        }
      case 0x1E05:
        {
          return [0x0062, 0x0323];
        }
      case 0x1E06:
        {
          return [0x0042, 0x0331];
        }
      case 0x1E07:
        {
          return [0x0062, 0x0331];
        }
      case 0x1E08:
        {
          return [0x00C7, 0x0301];
        }
      case 0x1E09:
        {
          return [0x00E7, 0x0301];
        }
      case 0x1E0A:
        {
          return [0x0044, 0x0307];
        }
      case 0x1E0B:
        {
          return [0x0064, 0x0307];
        }
      case 0x1E0C:
        {
          return [0x0044, 0x0323];
        }
      case 0x1E0D:
        {
          return [0x0064, 0x0323];
        }
      case 0x1E0E:
        {
          return [0x0044, 0x0331];
        }
      case 0x1E0F:
        {
          return [0x0064, 0x0331];
        }
      case 0x1E10:
        {
          return [0x0044, 0x0327];
        }
      case 0x1E11:
        {
          return [0x0064, 0x0327];
        }
      case 0x1E12:
        {
          return [0x0044, 0x032D];
        }
      case 0x1E13:
        {
          return [0x0064, 0x032D];
        }
      case 0x1E14:
        {
          return [0x0112, 0x0300];
        }
      case 0x1E15:
        {
          return [0x0113, 0x0300];
        }
      case 0x1E16:
        {
          return [0x0112, 0x0301];
        }
      case 0x1E17:
        {
          return [0x0113, 0x0301];
        }
      case 0x1E18:
        {
          return [0x0045, 0x032D];
        }
      case 0x1E19:
        {
          return [0x0065, 0x032D];
        }
      case 0x1E1A:
        {
          return [0x0045, 0x0330];
        }
      case 0x1E1B:
        {
          return [0x0065, 0x0330];
        }
      case 0x1E1C:
        {
          return [0x0228, 0x0306];
        }
      case 0x1E1D:
        {
          return [0x0229, 0x0306];
        }
      case 0x1E1E:
        {
          return [0x0046, 0x0307];
        }
      case 0x1E1F:
        {
          return [0x0066, 0x0307];
        }
      case 0x1E20:
        {
          return [0x0047, 0x0304];
        }
      case 0x1E21:
        {
          return [0x0067, 0x0304];
        }
      case 0x1E22:
        {
          return [0x0048, 0x0307];
        }
      case 0x1E23:
        {
          return [0x0068, 0x0307];
        }
      case 0x1E24:
        {
          return [0x0048, 0x0323];
        }
      case 0x1E25:
        {
          return [0x0068, 0x0323];
        }
      case 0x1E26:
        {
          return [0x0048, 0x0308];
        }
      case 0x1E27:
        {
          return [0x0068, 0x0308];
        }
      case 0x1E28:
        {
          return [0x0048, 0x0327];
        }
      case 0x1E29:
        {
          return [0x0068, 0x0327];
        }
      case 0x1E2A:
        {
          return [0x0048, 0x032E];
        }
      case 0x1E2B:
        {
          return [0x0068, 0x032E];
        }
      case 0x1E2C:
        {
          return [0x0049, 0x0330];
        }
      case 0x1E2D:
        {
          return [0x0069, 0x0330];
        }
      case 0x1E2E:
        {
          return [0x00CF, 0x0301];
        }
      case 0x1E2F:
        {
          return [0x00EF, 0x0301];
        }
      case 0x1E30:
        {
          return [0x004B, 0x0301];
        }
      case 0x1E31:
        {
          return [0x006B, 0x0301];
        }
      case 0x1E32:
        {
          return [0x004B, 0x0323];
        }
      case 0x1E33:
        {
          return [0x006B, 0x0323];
        }
      case 0x1E34:
        {
          return [0x004B, 0x0331];
        }
      case 0x1E35:
        {
          return [0x006B, 0x0331];
        }
      case 0x1E36:
        {
          return [0x004C, 0x0323];
        }
      case 0x1E37:
        {
          return [0x006C, 0x0323];
        }
      case 0x1E38:
        {
          return [0x1E36, 0x0304];
        }
      case 0x1E39:
        {
          return [0x1E37, 0x0304];
        }
      case 0x1E3A:
        {
          return [0x004C, 0x0331];
        }
      case 0x1E3B:
        {
          return [0x006C, 0x0331];
        }
      case 0x1E3C:
        {
          return [0x004C, 0x032D];
        }
      case 0x1E3D:
        {
          return [0x006C, 0x032D];
        }
      case 0x1E3E:
        {
          return [0x004D, 0x0301];
        }
      case 0x1E3F:
        {
          return [0x006D, 0x0301];
        }
      case 0x1E40:
        {
          return [0x004D, 0x0307];
        }
      case 0x1E41:
        {
          return [0x006D, 0x0307];
        }
      case 0x1E42:
        {
          return [0x004D, 0x0323];
        }
      case 0x1E43:
        {
          return [0x006D, 0x0323];
        }
      case 0x1E44:
        {
          return [0x004E, 0x0307];
        }
      case 0x1E45:
        {
          return [0x006E, 0x0307];
        }
      case 0x1E46:
        {
          return [0x004E, 0x0323];
        }
      case 0x1E47:
        {
          return [0x006E, 0x0323];
        }
      case 0x1E48:
        {
          return [0x004E, 0x0331];
        }
      case 0x1E49:
        {
          return [0x006E, 0x0331];
        }
      case 0x1E4A:
        {
          return [0x004E, 0x032D];
        }
      case 0x1E4B:
        {
          return [0x006E, 0x032D];
        }
      case 0x1E4C:
        {
          return [0x00D5, 0x0301];
        }
      case 0x1E4D:
        {
          return [0x00F5, 0x0301];
        }
      case 0x1E4E:
        {
          return [0x00D5, 0x0308];
        }
      case 0x1E4F:
        {
          return [0x00F5, 0x0308];
        }
      case 0x1E50:
        {
          return [0x014C, 0x0300];
        }
      case 0x1E51:
        {
          return [0x014D, 0x0300];
        }
      case 0x1E52:
        {
          return [0x014C, 0x0301];
        }
      case 0x1E53:
        {
          return [0x014D, 0x0301];
        }
      case 0x1E54:
        {
          return [0x0050, 0x0301];
        }
      case 0x1E55:
        {
          return [0x0070, 0x0301];
        }
      case 0x1E56:
        {
          return [0x0050, 0x0307];
        }
      case 0x1E57:
        {
          return [0x0070, 0x0307];
        }
      case 0x1E58:
        {
          return [0x0052, 0x0307];
        }
      case 0x1E59:
        {
          return [0x0072, 0x0307];
        }
      case 0x1E5A:
        {
          return [0x0052, 0x0323];
        }
      case 0x1E5B:
        {
          return [0x0072, 0x0323];
        }
      case 0x1E5C:
        {
          return [0x1E5A, 0x0304];
        }
      case 0x1E5D:
        {
          return [0x1E5B, 0x0304];
        }
      case 0x1E5E:
        {
          return [0x0052, 0x0331];
        }
      case 0x1E5F:
        {
          return [0x0072, 0x0331];
        }
      case 0x1E60:
        {
          return [0x0053, 0x0307];
        }
      case 0x1E61:
        {
          return [0x0073, 0x0307];
        }
      case 0x1E62:
        {
          return [0x0053, 0x0323];
        }
      case 0x1E63:
        {
          return [0x0073, 0x0323];
        }
      case 0x1E64:
        {
          return [0x015A, 0x0307];
        }
      case 0x1E65:
        {
          return [0x015B, 0x0307];
        }
      case 0x1E66:
        {
          return [0x0160, 0x0307];
        }
      case 0x1E67:
        {
          return [0x0161, 0x0307];
        }
      case 0x1E68:
        {
          return [0x1E62, 0x0307];
        }
      case 0x1E69:
        {
          return [0x1E63, 0x0307];
        }
      case 0x1E6A:
        {
          return [0x0054, 0x0307];
        }
      case 0x1E6B:
        {
          return [0x0074, 0x0307];
        }
      case 0x1E6C:
        {
          return [0x0054, 0x0323];
        }
      case 0x1E6D:
        {
          return [0x0074, 0x0323];
        }
      case 0x1E6E:
        {
          return [0x0054, 0x0331];
        }
      case 0x1E6F:
        {
          return [0x0074, 0x0331];
        }
      case 0x1E70:
        {
          return [0x0054, 0x032D];
        }
      case 0x1E71:
        {
          return [0x0074, 0x032D];
        }
      case 0x1E72:
        {
          return [0x0055, 0x0324];
        }
      case 0x1E73:
        {
          return [0x0075, 0x0324];
        }
      case 0x1E74:
        {
          return [0x0055, 0x0330];
        }
      case 0x1E75:
        {
          return [0x0075, 0x0330];
        }
      case 0x1E76:
        {
          return [0x0055, 0x032D];
        }
      case 0x1E77:
        {
          return [0x0075, 0x032D];
        }
      case 0x1E78:
        {
          return [0x0168, 0x0301];
        }
      case 0x1E79:
        {
          return [0x0169, 0x0301];
        }
      case 0x1E7A:
        {
          return [0x016A, 0x0308];
        }
      case 0x1E7B:
        {
          return [0x016B, 0x0308];
        }
      case 0x1E7C:
        {
          return [0x0056, 0x0303];
        }
      case 0x1E7D:
        {
          return [0x0076, 0x0303];
        }
      case 0x1E7E:
        {
          return [0x0056, 0x0323];
        }
      case 0x1E7F:
        {
          return [0x0076, 0x0323];
        }
      case 0x1E80:
        {
          return [0x0057, 0x0300];
        }
      case 0x1E81:
        {
          return [0x0077, 0x0300];
        }
      case 0x1E82:
        {
          return [0x0057, 0x0301];
        }
      case 0x1E83:
        {
          return [0x0077, 0x0301];
        }
      case 0x1E84:
        {
          return [0x0057, 0x0308];
        }
      case 0x1E85:
        {
          return [0x0077, 0x0308];
        }
      case 0x1E86:
        {
          return [0x0057, 0x0307];
        }
      case 0x1E87:
        {
          return [0x0077, 0x0307];
        }
      case 0x1E88:
        {
          return [0x0057, 0x0323];
        }
      case 0x1E89:
        {
          return [0x0077, 0x0323];
        }
      case 0x1E8A:
        {
          return [0x0058, 0x0307];
        }
      case 0x1E8B:
        {
          return [0x0078, 0x0307];
        }
      case 0x1E8C:
        {
          return [0x0058, 0x0308];
        }
      case 0x1E8D:
        {
          return [0x0078, 0x0308];
        }
      case 0x1E8E:
        {
          return [0x0059, 0x0307];
        }
      case 0x1E8F:
        {
          return [0x0079, 0x0307];
        }
      case 0x1E90:
        {
          return [0x005A, 0x0302];
        }
      case 0x1E91:
        {
          return [0x007A, 0x0302];
        }
      case 0x1E92:
        {
          return [0x005A, 0x0323];
        }
      case 0x1E93:
        {
          return [0x007A, 0x0323];
        }
      case 0x1E94:
        {
          return [0x005A, 0x0331];
        }
      case 0x1E95:
        {
          return [0x007A, 0x0331];
        }
      case 0x1E96:
        {
          return [0x0068, 0x0331];
        }
      case 0x1E97:
        {
          return [0x0074, 0x0308];
        }
      case 0x1E98:
        {
          return [0x0077, 0x030A];
        }
      case 0x1E99:
        {
          return [0x0079, 0x030A];
        }
      case 0x1E9A:
        {
          return [0x0061, 0x02BE];
        }
      case 0x1E9B:
        {
          return [0x017F, 0x0307];
        }
      case 0x1EA0:
        {
          return [0x0041, 0x0323];
        }
      case 0x1EA1:
        {
          return [0x0061, 0x0323];
        }
      case 0x1EA2:
        {
          return [0x0041, 0x0309];
        }
      case 0x1EA3:
        {
          return [0x0061, 0x0309];
        }
      case 0x1EA4:
        {
          return [0x00C2, 0x0301];
        }
      case 0x1EA5:
        {
          return [0x00E2, 0x0301];
        }
      case 0x1EA6:
        {
          return [0x00C2, 0x0300];
        }
      case 0x1EA7:
        {
          return [0x00E2, 0x0300];
        }
      case 0x1EA8:
        {
          return [0x00C2, 0x0309];
        }
      case 0x1EA9:
        {
          return [0x00E2, 0x0309];
        }
      case 0x1EAA:
        {
          return [0x00C2, 0x0303];
        }
      case 0x1EAB:
        {
          return [0x00E2, 0x0303];
        }
      case 0x1EAC:
        {
          return [0x1EA0, 0x0302];
        }
      case 0x1EAD:
        {
          return [0x1EA1, 0x0302];
        }
      case 0x1EAE:
        {
          return [0x0102, 0x0301];
        }
      case 0x1EAF:
        {
          return [0x0103, 0x0301];
        }
      case 0x1EB0:
        {
          return [0x0102, 0x0300];
        }
      case 0x1EB1:
        {
          return [0x0103, 0x0300];
        }
      case 0x1EB2:
        {
          return [0x0102, 0x0309];
        }
      case 0x1EB3:
        {
          return [0x0103, 0x0309];
        }
      case 0x1EB4:
        {
          return [0x0102, 0x0303];
        }
      case 0x1EB5:
        {
          return [0x0103, 0x0303];
        }
      case 0x1EB6:
        {
          return [0x1EA0, 0x0306];
        }
      case 0x1EB7:
        {
          return [0x1EA1, 0x0306];
        }
      case 0x1EB8:
        {
          return [0x0045, 0x0323];
        }
      case 0x1EB9:
        {
          return [0x0065, 0x0323];
        }
      case 0x1EBA:
        {
          return [0x0045, 0x0309];
        }
      case 0x1EBB:
        {
          return [0x0065, 0x0309];
        }
      case 0x1EBC:
        {
          return [0x0045, 0x0303];
        }
      case 0x1EBD:
        {
          return [0x0065, 0x0303];
        }
      case 0x1EBE:
        {
          return [0x00CA, 0x0301];
        }
      case 0x1EBF:
        {
          return [0x00EA, 0x0301];
        }
      case 0x1EC0:
        {
          return [0x00CA, 0x0300];
        }
      case 0x1EC1:
        {
          return [0x00EA, 0x0300];
        }
      case 0x1EC2:
        {
          return [0x00CA, 0x0309];
        }
      case 0x1EC3:
        {
          return [0x00EA, 0x0309];
        }
      case 0x1EC4:
        {
          return [0x00CA, 0x0303];
        }
      case 0x1EC5:
        {
          return [0x00EA, 0x0303];
        }
      case 0x1EC6:
        {
          return [0x1EB8, 0x0302];
        }
      case 0x1EC7:
        {
          return [0x1EB9, 0x0302];
        }
      case 0x1EC8:
        {
          return [0x0049, 0x0309];
        }
      case 0x1EC9:
        {
          return [0x0069, 0x0309];
        }
      case 0x1ECA:
        {
          return [0x0049, 0x0323];
        }
      case 0x1ECB:
        {
          return [0x0069, 0x0323];
        }
      case 0x1ECC:
        {
          return [0x004F, 0x0323];
        }
      case 0x1ECD:
        {
          return [0x006F, 0x0323];
        }
      case 0x1ECE:
        {
          return [0x004F, 0x0309];
        }
      case 0x1ECF:
        {
          return [0x006F, 0x0309];
        }
      case 0x1ED0:
        {
          return [0x00D4, 0x0301];
        }
      case 0x1ED1:
        {
          return [0x00F4, 0x0301];
        }
      case 0x1ED2:
        {
          return [0x00D4, 0x0300];
        }
      case 0x1ED3:
        {
          return [0x00F4, 0x0300];
        }
      case 0x1ED4:
        {
          return [0x00D4, 0x0309];
        }
      case 0x1ED5:
        {
          return [0x00F4, 0x0309];
        }
      case 0x1ED6:
        {
          return [0x00D4, 0x0303];
        }
      case 0x1ED7:
        {
          return [0x00F4, 0x0303];
        }
      case 0x1ED8:
        {
          return [0x1ECC, 0x0302];
        }
      case 0x1ED9:
        {
          return [0x1ECD, 0x0302];
        }
      case 0x1EDA:
        {
          return [0x01A0, 0x0301];
        }
      case 0x1EDB:
        {
          return [0x01A1, 0x0301];
        }
      case 0x1EDC:
        {
          return [0x01A0, 0x0300];
        }
      case 0x1EDD:
        {
          return [0x01A1, 0x0300];
        }
      case 0x1EDE:
        {
          return [0x01A0, 0x0309];
        }
      case 0x1EDF:
        {
          return [0x01A1, 0x0309];
        }
      case 0x1EE0:
        {
          return [0x01A0, 0x0303];
        }
      case 0x1EE1:
        {
          return [0x01A1, 0x0303];
        }
      case 0x1EE2:
        {
          return [0x01A0, 0x0323];
        }
      case 0x1EE3:
        {
          return [0x01A1, 0x0323];
        }
      case 0x1EE4:
        {
          return [0x0055, 0x0323];
        }
      case 0x1EE5:
        {
          return [0x0075, 0x0323];
        }
      case 0x1EE6:
        {
          return [0x0055, 0x0309];
        }
      case 0x1EE7:
        {
          return [0x0075, 0x0309];
        }
      case 0x1EE8:
        {
          return [0x01AF, 0x0301];
        }
      case 0x1EE9:
        {
          return [0x01B0, 0x0301];
        }
      case 0x1EEA:
        {
          return [0x01AF, 0x0300];
        }
      case 0x1EEB:
        {
          return [0x01B0, 0x0300];
        }
      case 0x1EEC:
        {
          return [0x01AF, 0x0309];
        }
      case 0x1EED:
        {
          return [0x01B0, 0x0309];
        }
      case 0x1EEE:
        {
          return [0x01AF, 0x0303];
        }
      case 0x1EEF:
        {
          return [0x01B0, 0x0303];
        }
      case 0x1EF0:
        {
          return [0x01AF, 0x0323];
        }
      case 0x1EF1:
        {
          return [0x01B0, 0x0323];
        }
      case 0x1EF2:
        {
          return [0x0059, 0x0300];
        }
      case 0x1EF3:
        {
          return [0x0079, 0x0300];
        }
      case 0x1EF4:
        {
          return [0x0059, 0x0323];
        }
      case 0x1EF5:
        {
          return [0x0079, 0x0323];
        }
      case 0x1EF6:
        {
          return [0x0059, 0x0309];
        }
      case 0x1EF7:
        {
          return [0x0079, 0x0309];
        }
      case 0x1EF8:
        {
          return [0x0059, 0x0303];
        }
      case 0x1EF9:
        {
          return [0x0079, 0x0303];
        }
      case 0x1F00:
        {
          return [0x03B1, 0x0313];
        }
      case 0x1F01:
        {
          return [0x03B1, 0x0314];
        }
      case 0x1F02:
        {
          return [0x1F00, 0x0300];
        }
      case 0x1F03:
        {
          return [0x1F01, 0x0300];
        }
      case 0x1F04:
        {
          return [0x1F00, 0x0301];
        }
      case 0x1F05:
        {
          return [0x1F01, 0x0301];
        }
      case 0x1F06:
        {
          return [0x1F00, 0x0342];
        }
      case 0x1F07:
        {
          return [0x1F01, 0x0342];
        }
      case 0x1F08:
        {
          return [0x0391, 0x0313];
        }
      case 0x1F09:
        {
          return [0x0391, 0x0314];
        }
      case 0x1F0A:
        {
          return [0x1F08, 0x0300];
        }
      case 0x1F0B:
        {
          return [0x1F09, 0x0300];
        }
      case 0x1F0C:
        {
          return [0x1F08, 0x0301];
        }
      case 0x1F0D:
        {
          return [0x1F09, 0x0301];
        }
      case 0x1F0E:
        {
          return [0x1F08, 0x0342];
        }
      case 0x1F0F:
        {
          return [0x1F09, 0x0342];
        }
      case 0x1F10:
        {
          return [0x03B5, 0x0313];
        }
      case 0x1F11:
        {
          return [0x03B5, 0x0314];
        }
      case 0x1F12:
        {
          return [0x1F10, 0x0300];
        }
      case 0x1F13:
        {
          return [0x1F11, 0x0300];
        }
      case 0x1F14:
        {
          return [0x1F10, 0x0301];
        }
      case 0x1F15:
        {
          return [0x1F11, 0x0301];
        }
      case 0x1F18:
        {
          return [0x0395, 0x0313];
        }
      case 0x1F19:
        {
          return [0x0395, 0x0314];
        }
      case 0x1F1A:
        {
          return [0x1F18, 0x0300];
        }
      case 0x1F1B:
        {
          return [0x1F19, 0x0300];
        }
      case 0x1F1C:
        {
          return [0x1F18, 0x0301];
        }
      case 0x1F1D:
        {
          return [0x1F19, 0x0301];
        }
      case 0x1F20:
        {
          return [0x03B7, 0x0313];
        }
      case 0x1F21:
        {
          return [0x03B7, 0x0314];
        }
      case 0x1F22:
        {
          return [0x1F20, 0x0300];
        }
      case 0x1F23:
        {
          return [0x1F21, 0x0300];
        }
      case 0x1F24:
        {
          return [0x1F20, 0x0301];
        }
      case 0x1F25:
        {
          return [0x1F21, 0x0301];
        }
      case 0x1F26:
        {
          return [0x1F20, 0x0342];
        }
      case 0x1F27:
        {
          return [0x1F21, 0x0342];
        }
      case 0x1F28:
        {
          return [0x0397, 0x0313];
        }
      case 0x1F29:
        {
          return [0x0397, 0x0314];
        }
      case 0x1F2A:
        {
          return [0x1F28, 0x0300];
        }
      case 0x1F2B:
        {
          return [0x1F29, 0x0300];
        }
      case 0x1F2C:
        {
          return [0x1F28, 0x0301];
        }
      case 0x1F2D:
        {
          return [0x1F29, 0x0301];
        }
      case 0x1F2E:
        {
          return [0x1F28, 0x0342];
        }
      case 0x1F2F:
        {
          return [0x1F29, 0x0342];
        }
      case 0x1F30:
        {
          return [0x03B9, 0x0313];
        }
      case 0x1F31:
        {
          return [0x03B9, 0x0314];
        }
      case 0x1F32:
        {
          return [0x1F30, 0x0300];
        }
      case 0x1F33:
        {
          return [0x1F31, 0x0300];
        }
      case 0x1F34:
        {
          return [0x1F30, 0x0301];
        }
      case 0x1F35:
        {
          return [0x1F31, 0x0301];
        }
      case 0x1F36:
        {
          return [0x1F30, 0x0342];
        }
      case 0x1F37:
        {
          return [0x1F31, 0x0342];
        }
      case 0x1F38:
        {
          return [0x0399, 0x0313];
        }
      case 0x1F39:
        {
          return [0x0399, 0x0314];
        }
      case 0x1F3A:
        {
          return [0x1F38, 0x0300];
        }
      case 0x1F3B:
        {
          return [0x1F39, 0x0300];
        }
      case 0x1F3C:
        {
          return [0x1F38, 0x0301];
        }
      case 0x1F3D:
        {
          return [0x1F39, 0x0301];
        }
      case 0x1F3E:
        {
          return [0x1F38, 0x0342];
        }
      case 0x1F3F:
        {
          return [0x1F39, 0x0342];
        }
      case 0x1F40:
        {
          return [0x03BF, 0x0313];
        }
      case 0x1F41:
        {
          return [0x03BF, 0x0314];
        }
      case 0x1F42:
        {
          return [0x1F40, 0x0300];
        }
      case 0x1F43:
        {
          return [0x1F41, 0x0300];
        }
      case 0x1F44:
        {
          return [0x1F40, 0x0301];
        }
      case 0x1F45:
        {
          return [0x1F41, 0x0301];
        }
      case 0x1F48:
        {
          return [0x039F, 0x0313];
        }
      case 0x1F49:
        {
          return [0x039F, 0x0314];
        }
      case 0x1F4A:
        {
          return [0x1F48, 0x0300];
        }
      case 0x1F4B:
        {
          return [0x1F49, 0x0300];
        }
      case 0x1F4C:
        {
          return [0x1F48, 0x0301];
        }
      case 0x1F4D:
        {
          return [0x1F49, 0x0301];
        }
      case 0x1F50:
        {
          return [0x03C5, 0x0313];
        }
      case 0x1F51:
        {
          return [0x03C5, 0x0314];
        }
      case 0x1F52:
        {
          return [0x1F50, 0x0300];
        }
      case 0x1F53:
        {
          return [0x1F51, 0x0300];
        }
      case 0x1F54:
        {
          return [0x1F50, 0x0301];
        }
      case 0x1F55:
        {
          return [0x1F51, 0x0301];
        }
      case 0x1F56:
        {
          return [0x1F50, 0x0342];
        }
      case 0x1F57:
        {
          return [0x1F51, 0x0342];
        }
      case 0x1F59:
        {
          return [0x03A5, 0x0314];
        }
      case 0x1F5B:
        {
          return [0x1F59, 0x0300];
        }
      case 0x1F5D:
        {
          return [0x1F59, 0x0301];
        }
      case 0x1F5F:
        {
          return [0x1F59, 0x0342];
        }
      case 0x1F60:
        {
          return [0x03C9, 0x0313];
        }
      case 0x1F61:
        {
          return [0x03C9, 0x0314];
        }
      case 0x1F62:
        {
          return [0x1F60, 0x0300];
        }
      case 0x1F63:
        {
          return [0x1F61, 0x0300];
        }
      case 0x1F64:
        {
          return [0x1F60, 0x0301];
        }
      case 0x1F65:
        {
          return [0x1F61, 0x0301];
        }
      case 0x1F66:
        {
          return [0x1F60, 0x0342];
        }
      case 0x1F67:
        {
          return [0x1F61, 0x0342];
        }
      case 0x1F68:
        {
          return [0x03A9, 0x0313];
        }
      case 0x1F69:
        {
          return [0x03A9, 0x0314];
        }
      case 0x1F6A:
        {
          return [0x1F68, 0x0300];
        }
      case 0x1F6B:
        {
          return [0x1F69, 0x0300];
        }
      case 0x1F6C:
        {
          return [0x1F68, 0x0301];
        }
      case 0x1F6D:
        {
          return [0x1F69, 0x0301];
        }
      case 0x1F6E:
        {
          return [0x1F68, 0x0342];
        }
      case 0x1F6F:
        {
          return [0x1F69, 0x0342];
        }
      case 0x1F70:
        {
          return [0x03B1, 0x0300];
        }
      case 0x1F71:
        {
          return [0x03AC];
        }
      case 0x1F72:
        {
          return [0x03B5, 0x0300];
        }
      case 0x1F73:
        {
          return [0x03AD];
        }
      case 0x1F74:
        {
          return [0x03B7, 0x0300];
        }
      case 0x1F75:
        {
          return [0x03AE];
        }
      case 0x1F76:
        {
          return [0x03B9, 0x0300];
        }
      case 0x1F77:
        {
          return [0x03AF];
        }
      case 0x1F78:
        {
          return [0x03BF, 0x0300];
        }
      case 0x1F79:
        {
          return [0x03CC];
        }
      case 0x1F7A:
        {
          return [0x03C5, 0x0300];
        }
      case 0x1F7B:
        {
          return [0x03CD];
        }
      case 0x1F7C:
        {
          return [0x03C9, 0x0300];
        }
      case 0x1F7D:
        {
          return [0x03CE];
        }
      case 0x1F80:
        {
          return [0x1F00, 0x0345];
        }
      case 0x1F81:
        {
          return [0x1F01, 0x0345];
        }
      case 0x1F82:
        {
          return [0x1F02, 0x0345];
        }
      case 0x1F83:
        {
          return [0x1F03, 0x0345];
        }
      case 0x1F84:
        {
          return [0x1F04, 0x0345];
        }
      case 0x1F85:
        {
          return [0x1F05, 0x0345];
        }
      case 0x1F86:
        {
          return [0x1F06, 0x0345];
        }
      case 0x1F87:
        {
          return [0x1F07, 0x0345];
        }
      case 0x1F88:
        {
          return [0x1F08, 0x0345];
        }
      case 0x1F89:
        {
          return [0x1F09, 0x0345];
        }
      case 0x1F8A:
        {
          return [0x1F0A, 0x0345];
        }
      case 0x1F8B:
        {
          return [0x1F0B, 0x0345];
        }
      case 0x1F8C:
        {
          return [0x1F0C, 0x0345];
        }
      case 0x1F8D:
        {
          return [0x1F0D, 0x0345];
        }
      case 0x1F8E:
        {
          return [0x1F0E, 0x0345];
        }
      case 0x1F8F:
        {
          return [0x1F0F, 0x0345];
        }
      case 0x1F90:
        {
          return [0x1F20, 0x0345];
        }
      case 0x1F91:
        {
          return [0x1F21, 0x0345];
        }
      case 0x1F92:
        {
          return [0x1F22, 0x0345];
        }
      case 0x1F93:
        {
          return [0x1F23, 0x0345];
        }
      case 0x1F94:
        {
          return [0x1F24, 0x0345];
        }
      case 0x1F95:
        {
          return [0x1F25, 0x0345];
        }
      case 0x1F96:
        {
          return [0x1F26, 0x0345];
        }
      case 0x1F97:
        {
          return [0x1F27, 0x0345];
        }
      case 0x1F98:
        {
          return [0x1F28, 0x0345];
        }
      case 0x1F99:
        {
          return [0x1F29, 0x0345];
        }
      case 0x1F9A:
        {
          return [0x1F2A, 0x0345];
        }
      case 0x1F9B:
        {
          return [0x1F2B, 0x0345];
        }
      case 0x1F9C:
        {
          return [0x1F2C, 0x0345];
        }
      case 0x1F9D:
        {
          return [0x1F2D, 0x0345];
        }
      case 0x1F9E:
        {
          return [0x1F2E, 0x0345];
        }
      case 0x1F9F:
        {
          return [0x1F2F, 0x0345];
        }
      case 0x1FA0:
        {
          return [0x1F60, 0x0345];
        }
      case 0x1FA1:
        {
          return [0x1F61, 0x0345];
        }
      case 0x1FA2:
        {
          return [0x1F62, 0x0345];
        }
      case 0x1FA3:
        {
          return [0x1F63, 0x0345];
        }
      case 0x1FA4:
        {
          return [0x1F64, 0x0345];
        }
      case 0x1FA5:
        {
          return [0x1F65, 0x0345];
        }
      case 0x1FA6:
        {
          return [0x1F66, 0x0345];
        }
      case 0x1FA7:
        {
          return [0x1F67, 0x0345];
        }
      case 0x1FA8:
        {
          return [0x1F68, 0x0345];
        }
      case 0x1FA9:
        {
          return [0x1F69, 0x0345];
        }
      case 0x1FAA:
        {
          return [0x1F6A, 0x0345];
        }
      case 0x1FAB:
        {
          return [0x1F6B, 0x0345];
        }
      case 0x1FAC:
        {
          return [0x1F6C, 0x0345];
        }
      case 0x1FAD:
        {
          return [0x1F6D, 0x0345];
        }
      case 0x1FAE:
        {
          return [0x1F6E, 0x0345];
        }
      case 0x1FAF:
        {
          return [0x1F6F, 0x0345];
        }
      case 0x1FB0:
        {
          return [0x03B1, 0x0306];
        }
      case 0x1FB1:
        {
          return [0x03B1, 0x0304];
        }
      case 0x1FB2:
        {
          return [0x1F70, 0x0345];
        }
      case 0x1FB3:
        {
          return [0x03B1, 0x0345];
        }
      case 0x1FB4:
        {
          return [0x03AC, 0x0345];
        }
      case 0x1FB6:
        {
          return [0x03B1, 0x0342];
        }
      case 0x1FB7:
        {
          return [0x1FB6, 0x0345];
        }
      case 0x1FB8:
        {
          return [0x0391, 0x0306];
        }
      case 0x1FB9:
        {
          return [0x0391, 0x0304];
        }
      case 0x1FBA:
        {
          return [0x0391, 0x0300];
        }
      case 0x1FBB:
        {
          return [0x0386];
        }
      case 0x1FBC:
        {
          return [0x0391, 0x0345];
        }
      case 0x1FBD:
        {
          return [0x0020, 0x0313];
        }
      case 0x1FBE:
        {
          return [0x03B9];
        }
      case 0x1FBF:
        {
          return [0x0020, 0x0313];
        }
      case 0x1FC0:
        {
          return [0x0020, 0x0342];
        }
      case 0x1FC1:
        {
          return [0x00A8, 0x0342];
        }
      case 0x1FC2:
        {
          return [0x1F74, 0x0345];
        }
      case 0x1FC3:
        {
          return [0x03B7, 0x0345];
        }
      case 0x1FC4:
        {
          return [0x03AE, 0x0345];
        }
      case 0x1FC6:
        {
          return [0x03B7, 0x0342];
        }
      case 0x1FC7:
        {
          return [0x1FC6, 0x0345];
        }
      case 0x1FC8:
        {
          return [0x0395, 0x0300];
        }
      case 0x1FC9:
        {
          return [0x0388];
        }
      case 0x1FCA:
        {
          return [0x0397, 0x0300];
        }
      case 0x1FCB:
        {
          return [0x0389];
        }
      case 0x1FCC:
        {
          return [0x0397, 0x0345];
        }
      case 0x1FCD:
        {
          return [0x1FBF, 0x0300];
        }
      case 0x1FCE:
        {
          return [0x1FBF, 0x0301];
        }
      case 0x1FCF:
        {
          return [0x1FBF, 0x0342];
        }
      case 0x1FD0:
        {
          return [0x03B9, 0x0306];
        }
      case 0x1FD1:
        {
          return [0x03B9, 0x0304];
        }
      case 0x1FD2:
        {
          return [0x03CA, 0x0300];
        }
      case 0x1FD3:
        {
          return [0x0390];
        }
      case 0x1FD6:
        {
          return [0x03B9, 0x0342];
        }
      case 0x1FD7:
        {
          return [0x03CA, 0x0342];
        }
      case 0x1FD8:
        {
          return [0x0399, 0x0306];
        }
      case 0x1FD9:
        {
          return [0x0399, 0x0304];
        }
      case 0x1FDA:
        {
          return [0x0399, 0x0300];
        }
      case 0x1FDB:
        {
          return [0x038A];
        }
      case 0x1FDD:
        {
          return [0x1FFE, 0x0300];
        }
      case 0x1FDE:
        {
          return [0x1FFE, 0x0301];
        }
      case 0x1FDF:
        {
          return [0x1FFE, 0x0342];
        }
      case 0x1FE0:
        {
          return [0x03C5, 0x0306];
        }
      case 0x1FE1:
        {
          return [0x03C5, 0x0304];
        }
      case 0x1FE2:
        {
          return [0x03CB, 0x0300];
        }
      case 0x1FE3:
        {
          return [0x03B0];
        }
      case 0x1FE4:
        {
          return [0x03C1, 0x0313];
        }
      case 0x1FE5:
        {
          return [0x03C1, 0x0314];
        }
      case 0x1FE6:
        {
          return [0x03C5, 0x0342];
        }
      case 0x1FE7:
        {
          return [0x03CB, 0x0342];
        }
      case 0x1FE8:
        {
          return [0x03A5, 0x0306];
        }
      case 0x1FE9:
        {
          return [0x03A5, 0x0304];
        }
      case 0x1FEA:
        {
          return [0x03A5, 0x0300];
        }
      case 0x1FEB:
        {
          return [0x038E];
        }
      case 0x1FEC:
        {
          return [0x03A1, 0x0314];
        }
      case 0x1FED:
        {
          return [0x00A8, 0x0300];
        }
      case 0x1FEE:
        {
          return [0x0385];
        }
      case 0x1FEF:
        {
          return [0x0060];
        }
      case 0x1FF2:
        {
          return [0x1F7C, 0x0345];
        }
      case 0x1FF3:
        {
          return [0x03C9, 0x0345];
        }
      case 0x1FF4:
        {
          return [0x03CE, 0x0345];
        }
      case 0x1FF6:
        {
          return [0x03C9, 0x0342];
        }
      case 0x1FF7:
        {
          return [0x1FF6, 0x0345];
        }
      case 0x1FF8:
        {
          return [0x039F, 0x0300];
        }
      case 0x1FF9:
        {
          return [0x038C];
        }
      case 0x1FFA:
        {
          return [0x03A9, 0x0300];
        }
      case 0x1FFB:
        {
          return [0x038F];
        }
      case 0x1FFC:
        {
          return [0x03A9, 0x0345];
        }
      case 0x1FFD:
        {
          return [0x00B4];
        }
      case 0x1FFE:
        {
          return [0x0020, 0x0314];
        }
      default:
        return null;
    }
  }
}
class DiacriticsFilterInstructionsZeta {
  static executeOpcode(opcode) {
    switch (opcode) {
      case 0xA802:
        return [];
      case 0xA806:
        return [];
      case 0xA80B:
        return [];
      case 0xA823:
        return [];
      case 0xA824:
        return [];
      case 0xA825:
        return [];
      case 0xA826:
        return [];
      case 0xA827:
        return [];
      default:
        return [opcode];
    }
  }
}
let UnicodeVM = /*#__PURE__*/(() => {
  class UnicodeVM {
    static {
      this.UCVM_HANGUL_SBASE = 0xAC00;
    }
    static {
      this.UCVM_HANGUL_LBASE = 0x1100;
    }
    static {
      this.UCVM_HANGUL_VBASE = 0x1161;
    }
    static {
      this.UCVM_HANGUL_TBASE = 0x11A7;
    }
    static {
      this.UCVM_HANGUL_LCOUNT = 19;
    }
    static {
      this.UCVM_HANGUL_VCOUNT = 21;
    }
    static {
      this.UCVM_HANGUL_TCOUNT = 28;
    }
    static {
      this.UCVM_HANGUL_NCOUNT = 588;
    }
    static {
      this.UCVM_HANGUL_SCOUNT = 11172;
    }
    static {
      this.UVMC_HTML_ENTITY_HEX = 0x78;
    } // x
    static {
      this.UVMC_HTML_ENTITY_NUMBER = 0x23;
    } // #
    static {
      this.UVMC_HTML_ENTITY_START = 0x3B;
    } // ;
    static {
      this.UVMC_HTML_ENTITY_STOP = 0x26;
    } // &
    static {
      this.uvmcEntityNames = ['quot', 'amp', 'apos', 'lt', 'gt', 'nbsp', 'iexcl', 'cent', 'pound', 'curren', 'yen', 'brvbar', 'sect', 'uml', 'copy', 'ordf', 'laquo', 'not', 'shy', 'reg', 'macr', 'deg', 'plusmn', 'sup2', 'sup3', 'acute', 'micro', 'para', 'middot', 'cedil', 'sup1', 'ordm', 'raquo', 'frac14', 'frac12', 'frac34', 'iquest', 'Agrave', 'Aacute', 'Acirc', 'Atilde', 'Auml', 'Aring', 'AElig', 'Ccedil', 'Egrave', 'Eacute', 'Ecirc', 'Euml', 'Igrave', 'Iacute', 'Icirc', 'Iuml', 'ETH', 'Ntilde', 'Ograve', 'Oacute', 'Ocirc', 'Otilde', 'Ouml', 'times', 'Oslash', 'Ugrave', 'Uacute', 'Ucirc', 'Uuml', 'Yacute', 'THORN', 'szlig', 'agrave', 'aacute', 'acirc', 'atilde', 'auml', 'aring', 'aelig', 'ccedil', 'egrave', 'eacute', 'ecirc', 'euml', 'igrave', 'iacute', 'icirc', 'iuml', 'eth', 'ntilde', 'ograve', 'oacute', 'ocirc', 'otilde', 'ouml', 'divide', 'oslash', 'ugrave', 'uacute', 'ucirc', 'uuml', 'yacute', 'thorn', 'yuml', 'OElig', 'oelig', 'Scaron', 'scaron', 'Yuml', 'fnof', 'circ', 'tilde', 'Alpha', 'Beta', 'Gamma', 'Delta', 'Epsilon', 'Zeta', 'Eta', 'Theta', 'Iota', 'Kappa', 'Lambda', 'Mu', 'Nu', 'Xi', 'Omicron', 'Pi', 'Rho', 'Sigma', 'Tau', 'Upsilon', 'Phi', 'Chi', 'Psi', 'Omega', 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'pi', 'rho', 'sigmaf', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega', 'thetasym', 'upsih', 'piv', 'ensp', 'emsp', 'thinsp', 'zwnj', 'zwj', 'lrm', 'rlm', 'ndash', 'mdash', 'lsquo', 'rsquo', 'sbquo', 'ldquo', 'rdquo', 'bdquo', 'dagger', 'Dagger', 'bull', 'hellip', 'permil', 'prime', 'Prime', 'lsaquo', 'rsaquo', 'oline', 'frasl', 'euro', 'image', 'weierp', 'real', 'trade', 'alefsym', 'larr', 'uarr', 'rarr', 'darr', 'harr', 'crarr', 'lArr', 'uArr', 'rArr', 'dArr', 'hArr', 'forall', 'part', 'exist', 'empty', 'nabla', 'isin', 'notin', 'ni', 'prod', 'sum', 'minus', 'lowast', 'radic', 'prop', 'infin', 'ang', 'and', 'or', 'cap', 'cup', 'int', 'there4', 'sim', 'cong', 'asymp', 'ne', 'equiv', 'le', 'ge', 'sub', 'sup', 'nsub', 'sube', 'supe', 'oplus', 'otimes', 'perp', 'sdot', 'lceil', 'rceil', 'lfloor', 'rfloor', 'lang', 'rang', 'loz', 'spades', 'clubs', 'hearts', 'diams'];
    }
    static {
      this.uvmcEntityCodes = [0x0022, 0x0026, 0x0027, 0x003C, 0x003E, 0x00A0, 0x00A1, 0x00A2, 0x00A3, 0x00A4, 0x00A5, 0x00A6, 0x00A7, 0x00A8, 0x00A9, 0x00AA, 0x00AB, 0x00AC, 0x00AD, 0x00AE, 0x00AF, 0x00B0, 0x00B1, 0x00B2, 0x00B3, 0x00B4, 0x00B5, 0x00B6, 0x00B7, 0x00B8, 0x00B9, 0x00BA, 0x00BB, 0x00BC, 0x00BD, 0x00BE, 0x00BF, 0x00C0, 0x00C1, 0x00C2, 0x00C3, 0x00C4, 0x00C5, 0x00C6, 0x00C7, 0x00C8, 0x00C9, 0x00CA, 0x00CB, 0x00CC, 0x00CD, 0x00CE, 0x00CF, 0x00D0, 0x00D1, 0x00D2, 0x00D3, 0x00D4, 0x00D5, 0x00D6, 0x00D7, 0x00D8, 0x00D9, 0x00DA, 0x00DB, 0x00DC, 0x00DD, 0x00DE, 0x00DF, 0x00E0, 0x00E1, 0x00E2, 0x00E3, 0x00E4, 0x00E5, 0x00E6, 0x00E7, 0x00E8, 0x00E9, 0x00EA, 0x00EB, 0x00EC, 0x00ED, 0x00EE, 0x00EF, 0x00F0, 0x00F1, 0x00F2, 0x00F3, 0x00F4, 0x00F5, 0x00F6, 0x00F7, 0x00F8, 0x00F9, 0x00FA, 0x00FB, 0x00FC, 0x00FD, 0x00FE, 0x00FF, 0x0152, 0x0153, 0x0160, 0x0161, 0x0178, 0x0192, 0x02C6, 0x02DC, 0x0391, 0x0392, 0x0393, 0x0394, 0x0395, 0x0396, 0x0397, 0x0398, 0x0399, 0x039A, 0x039B, 0x039C, 0x039D, 0x039E, 0x039F, 0x03A0, 0x03A1, 0x03A3, 0x03A4, 0x03A5, 0x03A6, 0x03A7, 0x03A8, 0x03A9, 0x03B1, 0x03B2, 0x03B3, 0x03B4, 0x03B5, 0x03B6, 0x03B7, 0x03B8, 0x03B9, 0x03BA, 0x03BB, 0x03BC, 0x03BD, 0x03BE, 0x03BF, 0x03C0, 0x03C1, 0x03C2, 0x03C3, 0x03C4, 0x03C5, 0x03C6, 0x03C7, 0x03C8, 0x03C9, 0x03D1, 0x03D2, 0x03D6, 0x2002, 0x2003, 0x2009, 0x200C, 0x200D, 0x200E, 0x200F, 0x2013, 0x2014, 0x2018, 0x2019, 0x201A, 0x201C, 0x201D, 0x201E, 0x2020, 0x2021, 0x2022, 0x2026, 0x2030, 0x2032, 0x2033, 0x2039, 0x203A, 0x203E, 0x2044, 0x20AC, 0x2111, 0x2118, 0x211C, 0x2122, 0x2135, 0x2190, 0x2191, 0x2192, 0x2193, 0x2194, 0x21B5, 0x21D0, 0x21D1, 0x21D2, 0x21D3, 0x21D4, 0x2200, 0x2202, 0x2203, 0x2205, 0x2207, 0x2208, 0x2209, 0x220B, 0x220F, 0x2211, 0x2212, 0x2217, 0x221A, 0x221D, 0x221E, 0x2220, 0x2227, 0x2228, 0x2229, 0x222A, 0x222B, 0x2234, 0x223C, 0x2245, 0x2248, 0x2260, 0x2261, 0x2264, 0x2265, 0x2282, 0x2283, 0x2284, 0x2286, 0x2287, 0x2295, 0x2297, 0x22A5, 0x22C5, 0x2308, 0x2309, 0x230A, 0x230B, 0x2329, 0x232A, 0x25CA, 0x2660, 0x2663, 0x2665, 0x2666];
    }
    static string2code(s) {
      const code = [];
      for (let i = 0; i < s.length; i++) {
        code.push(s.charCodeAt(i));
      }
      return code;
    }
    static data2string(data) {
      let result = '';
      while (data.length > 0) {
        result += String.fromCharCode(data.pop());
      }
      return result;
    }
    static DecomposeCanonical(s) {
      let code = UnicodeVM.string2code(s);
      const data = [];
      while (code.length > 0) {
        const charCode = code.pop();
        const decCode = UnicodeVM.decomposeCanonicalOpcode(charCode);
        if (decCode) {
          code = code.concat(decCode);
        } else {
          data.push(charCode);
        }
      }
      return UnicodeVM.data2string(data);
    }
    static DecomposeHangul(s) {
      const codes = UnicodeVM.string2code(s);
      let data = [];
      while (codes.length > 0) {
        data = data.concat(UnicodeVM.decomposeHangulOpcode(codes.pop()));
      }
      return UnicodeVM.data2string(data);
    }
    static ComposeHTMLEntities(s) {
      const code = UnicodeVM.string2code(s);
      const data = [];
      const command = [];
      while (code.length > 0) {
        UnicodeVM.htmlEntityOpcode(code, data, command);
      }
      return UnicodeVM.data2string(data);
    }
    static Decompose(s) {
      const canonical = UnicodeVM.DecomposeCanonical(s);
      return UnicodeVM.DecomposeHangul(canonical);
    }
    static Normalize(src) {
      const detagged = UnicodeVM.CutTags(src);
      const deentitied = UnicodeVM.ComposeHTMLEntities(detagged);
      const decomposed = UnicodeVM.Decompose(deentitied);
      const unmarked = UnicodeVM.CutDiacritics(decomposed);
      const lowercased = UnicodeVM.Lowercase(unmarked);
      const dst = UnicodeVM.ComposeSpaces(lowercased);
      return dst;
    }
    static Lowercase(s) {
      let code = UnicodeVM.string2code(s);
      let data = [];
      while (code.length > 0) {
        const charCode = code.pop();
        const decCode = UnicodeVM.lowercaseOpcode(charCode);
        if (decCode) {
          code = code.concat(decCode);
        } else {
          data = data.concat([charCode]);
        }
      }
      return UnicodeVM.data2string(data);
    }
    static CutDiacritics(s) {
      const code = UnicodeVM.string2code(s);
      let data = [];
      while (code.length > 0) {
        data = data.concat(UnicodeVM.diacriticsfilterOpcode(code.pop()));
      }
      return UnicodeVM.data2string(data);
    }
    static ComposeSpaces(s) {
      const code = UnicodeVM.string2code(s);
      const data = [];
      while (true) {
        if (code.length === 0) {
          break;
        }
        if (code[code.length - 1] === 0x20) {
          code.pop();
        } else {
          break;
        }
      }
      while (code.length > 0) {
        if (data.length > 0) {
          if (data[data.length - 1] === 0x20 && code[code.length - 1] === 0x20) {
            code.pop();
          } else {
            data.push(code.pop());
          }
        } else {
          data.push(code.pop());
        }
      }
      while (true) {
        if (data.length === 0) {
          break;
        }
        if (data[data.length - 1] === 0x20) {
          data.pop();
        } else {
          break;
        }
      }
      return UnicodeVM.data2string(data);
    }
    static CutTags(s) {
      const code = UnicodeVM.string2code(s);
      const data = [];
      let inside_tag = 0;
      while (code.length > 0) {
        const code_top = code[code.length - 1];
        if (code_top === 0x3E) {
          inside_tag = 1;
        }
        if (inside_tag === 0) {
          data.push(code_top);
        }
        if (code_top === 0x3C) {
          inside_tag = 0;
        }
        code.pop();
      }
      return UnicodeVM.data2string(data);
    }
    static decomposeCanonicalOpcode(opcode) {
      if (opcode >= 0x0000 && opcode <= 0x1FFF) {
        return DecompositionMachineAlpha.executeOpcode(opcode);
      } else if (opcode >= 0x2000 && opcode <= 0x3FFF) {
        return DecompositionMachineBeta.executeOpcode(opcode);
      } else if (opcode >= 0x4000 && opcode <= 0x5FFF) {
        return null;
      } else if (opcode >= 0x6000 && opcode <= 0x7FFF) {
        return null;
      } else if (opcode >= 0x8000 && opcode <= 0x9FFF) {
        return null;
      } else if (opcode >= 0xA000 && opcode <= 0xBFFF) {
        return null;
      } else if (opcode >= 0xC000 && opcode <= 0xDFFF) {
        return null;
      } else if (opcode >= 0xE000 && opcode <= 0xFFFF) {
        return DecompositionMachineTheta.executeOpcode(opcode);
      } else {
        return [];
      }
    }
    static decomposeHangulOpcode(opcode) {
      if (opcode >= 0x3130 && opcode <= 0x318E || opcode >= 0x1100 && opcode <= 0x11FF || opcode >= 0xAC00 && opcode <= 0xD7A3) {
        const hangul_sindex = opcode - UnicodeVM.UCVM_HANGUL_SBASE;
        if (hangul_sindex < 0 || hangul_sindex >= UnicodeVM.UCVM_HANGUL_SCOUNT) {
          return [opcode];
        } else {
          const L = UnicodeVM.UCVM_HANGUL_LBASE + hangul_sindex / UnicodeVM.UCVM_HANGUL_NCOUNT;
          const V = UnicodeVM.UCVM_HANGUL_VBASE + hangul_sindex % UnicodeVM.UCVM_HANGUL_NCOUNT / UnicodeVM.UCVM_HANGUL_TCOUNT;
          const T = UnicodeVM.UCVM_HANGUL_TBASE + hangul_sindex % UnicodeVM.UCVM_HANGUL_TCOUNT;
          const arr = [];
          if (T !== UnicodeVM.UCVM_HANGUL_TBASE) {
            arr.push(T);
          }
          arr.push(V);
          arr.push(L);
          return arr;
        }
      } else {
        return [opcode];
      }
    }
    static decodeEntity(command) {
      let entity = 0;
      if (command[0] === UnicodeVM.UVMC_HTML_ENTITY_NUMBER) {
        command.pop();
        if (command[0] === UnicodeVM.UVMC_HTML_ENTITY_HEX) {
          command.pop();
          const s1 = UnicodeVM.data2string(command);
          entity = parseInt(s1, 16);
        } else {
          const s2 = UnicodeVM.data2string(command);
          entity = parseInt(s2, 10);
        }
      } else {
        const entityName = UnicodeVM.data2string(command);
        for (let i = 0; i < UnicodeVM.uvmcEntityNames.length; ++i) {
          if (entityName === UnicodeVM.uvmcEntityNames[i]) {
            entity = UnicodeVM.uvmcEntityCodes[i];
            break;
          }
        }
      }
      return entity;
    }
    static htmlEntityOpcode(code, data, command) {
      const opcode = code.pop();
      if (opcode === UnicodeVM.UVMC_HTML_ENTITY_START) {
        data.push(opcode);
      } else {
        if (opcode === UnicodeVM.UVMC_HTML_ENTITY_STOP) {
          if (command.length === 0) {
            data.push(opcode);
          } else {
            data.push(opcode);
            let entity = 0;
            let commandsize = command.length + 1 + 1; // + ; + &
            if ((entity = UnicodeVM.decodeEntity(command)) !== 0) {
              while (commandsize-- !== 0 && data.length !== 0) {
                data.pop();
              }
              command.length = 0;
              data.push(entity);
            } else {
              command.length = 0;
            }
          }
        } else {
          let last = 0;
          if (data.length !== 0) {
            last = data[data.length - 1];
          }
          if (command.length !== 0 || last === UnicodeVM.UVMC_HTML_ENTITY_START) {
            command.push(opcode);
          }
          data.push(opcode);
        }
      }
    }
    static lowercaseOpcode(opcode) {
      if (opcode >= 0x0000 && opcode <= 0x1FFF) {
        return LowercaseMachineAlpha.executeOpcode(opcode);
      } else if (opcode >= 0x2000 && opcode <= 0x3FFF) {
        return LowercaseMachineBeta.executeOpcode(opcode);
      } else if (opcode >= 0x4000 && opcode <= 0x5FFF) {
        return null;
      } else if (opcode >= 0x6000 && opcode <= 0x7FFF) {
        return null;
      } else if (opcode >= 0x8000 && opcode <= 0x9FFF) {
        return null;
      } else if (opcode >= 0xA000 && opcode <= 0xBFFF) {
        return null;
      } else if (opcode >= 0xC000 && opcode <= 0xDFFF) {
        return null;
      } else if (opcode >= 0xE000 && opcode <= 0xFFFF) {
        return LowercaseMachineTheta.executeOpcode(opcode);
      } else {
        return [];
      }
    }
    static diacriticsfilterOpcode(opcode) {
      if (opcode >= 0x0000 && opcode <= 0x1FFF) {
        return DiacriticsFilterInstructionsAlpha.executeOpcode(opcode);
      } else if (opcode >= 0x2000 && opcode <= 0x3FFF) {
        return DiacriticsFilterInstructionsBeta.executeOpcode(opcode);
      } else if (opcode >= 0x4000 && opcode <= 0x5FFF) {
        return [opcode];
      } else if (opcode >= 0x6000 && opcode <= 0x7FFF) {
        return [opcode];
      } else if (opcode >= 0x8000 && opcode <= 0x9FFF) {
        return [opcode];
      } else if (opcode >= 0xA000 && opcode <= 0xBFFF) {
        return DiacriticsFilterInstructionsZeta.executeOpcode(opcode);
      } else if (opcode >= 0xC000 && opcode <= 0xDFFF) {
        return [opcode];
      } else if (opcode >= 0xE000 && opcode <= 0xFFFF) {
        return DiacriticsFilterInstructionsTheta.executeOpcode(opcode);
      } else {
        return [];
      }
    }
  }
  return UnicodeVM;
})();
/**
 * Generated bundle index. Do not edit.
 */
export { UnicodeVM };
